(self["webpackChunkgreen_bubble_theme"] = self["webpackChunkgreen_bubble_theme"] || []).push([["/app"],{

/***/ "./src/js/app.js":
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _toggles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toggles */ "./src/js/toggles.js");
/* harmony import */ var _custom_add_to_cart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./custom-add-to-cart */ "./src/js/custom-add-to-cart.js");
/* harmony import */ var _sliders__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./sliders */ "./src/js/sliders.js");
/* harmony import */ var _price_slider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./price-slider */ "./src/js/price-slider.js");
/* harmony import */ var _price_slider__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_price_slider__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _collection_description__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./collection-description */ "./src/js/collection-description.js");
/* harmony import */ var _collection_description__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_collection_description__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _trustpilot_scroll__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./trustpilot-scroll */ "./src/js/trustpilot-scroll.js");
/* harmony import */ var _b2b_quote_form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./b2b-quote-form */ "./src/js/b2b-quote-form.js");
/* harmony import */ var _b2b_quote_form__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_b2b_quote_form__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var bootstrap_js_dist_tab__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! bootstrap/js/dist/tab */ "../../node_modules/.pnpm/bootstrap@5.3.8_@popperjs+core@2.11.8/node_modules/bootstrap/js/dist/tab.js");
/* harmony import */ var bootstrap_js_dist_tab__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(bootstrap_js_dist_tab__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! bootstrap/js/dist/modal */ "../../node_modules/.pnpm/bootstrap@5.3.8_@popperjs+core@2.11.8/node_modules/bootstrap/js/dist/modal.js");
/* harmony import */ var bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _fancyapps_fancybox__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @fancyapps/fancybox */ "../../node_modules/.pnpm/@fancyapps+fancybox@3.5.7_jquery@3.7.1/node_modules/@fancyapps/fancybox/dist/jquery.fancybox.js");
/* harmony import */ var _fancyapps_fancybox__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_fancyapps_fancybox__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! js-cookie */ "../../node_modules/.pnpm/js-cookie@3.0.7/node_modules/js-cookie/dist/js.cookie.mjs");
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
/* harmony import */ var _find_my_pot__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./find-my-pot */ "./src/js/find-my-pot.js");
/* provided dependency */ var __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "../../node_modules/.pnpm/jquery@3.7.1/node_modules/jquery/dist/jquery.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "../../node_modules/.pnpm/jquery@3.7.1/node_modules/jquery/dist/jquery.js");














window.$ = __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "../../node_modules/.pnpm/jquery@3.7.1/node_modules/jquery/dist/jquery.js");
var mq = {
  xxs: 0,
  xs: 380,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1600,
  xxxxl: 1800
};
var responsiveChanges = function responsiveChanges() {
  changeFooter();
};
responsiveChanges();
function changeFooter() {
  var windowWidth = $(window).width();
  if (windowWidth < mq.md) {
    $(".footer-top-menus__menu ul").hide().addClass("is-hidden");
  } else {
    $(".footer-top-menus__menu ul").show().addClass("is-show");
  }
}
function changeFilter() {
  $(".js-drawer-filter").prepend($(".js-collection-filters"));
}
changeFilter();

// Debounce function to limit how often a function is executed
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
function replaceMenu() {
  if ($(window).width() < mq.xs) {
    $(".js-panel").prepend($(".js-header-right"));
    $(".js-panel").prepend($(".js-header-nav"));
  } else if ($(window).width() < mq.lg && $(window).width() > mq.xs) {
    $(".js-panel").prepend($(".js-header-right"));
    $(".js-panel").prepend($(".js-header-nav"));
  } else if ($(window).width() < mq.xl && $(window).width() >= mq.lg) {
    $(".js-header-main").append($(".js-header-search"));
    $(".js-panel").prepend($(".js-header-nav"));
    $(".js-panel").prepend($(".js-header-right"));
  } else {
    $(".js-header-main").append($(".js-header-search"));
    $(".js-header-end .container").prepend($(".js-header-right"));
    $(".js-header-end .container").prepend($(".js-header-nav"));
    $("html").removeClass("show-nav");
    $(".js-header-toggle").removeClass("is-active");
  }
}
var replaceHome = function replaceHome() {
  (0,_sliders__WEBPACK_IMPORTED_MODULE_2__.destroyHomeHeroAsideMobileSlider)();
  if ($(window).width() < mq.md) {
    $(".js-home-hero-top").append($(".js-home-hero-trustpilot"));
    $(".js-home-hero-top").append($(".js-home-hero-main"));
    $(".js-home-hero-end").append($(".js-home-hero-usp"));
    $(".js-home-hero-category").insertAfter($(".js-home-hero").next("section"));
    if ($(".js-home-hero-aside-mobile .js-home-hero-aside-element").length === 0) {
      $(".js-home-hero-aside-mobile").append($(".js-home-hero-aside-element"));
    }
    if ($(".js-home-hero-aside-mobile .js-category-aside-block").length === 0) {
      $(".js-home-hero-aside-mobile").append($(".js-category-aside-block"));
    }
  } else {
    $(".js-home-hero-top").append($(".js-home-hero-main"));
    $(".js-home-hero-middle").append($(".js-home-hero-usp"));
    $(".js-home-hero-category").insertAfter($(".js-home-hero").next("section"));
    if ($(".js-home-hero-aside-desktop .js-home-hero-aside-element").length === 0) {
      $(".js-home-hero-aside-desktop").append($(".js-home-hero-aside-element"));
    }
    if ($(".js-category-aside .js-category-aside-block").length === 0) {
      $(".js-category-aside").append($(".js-category-aside-block"));
    }
  }
  setTimeout(function () {
    (0,_sliders__WEBPACK_IMPORTED_MODULE_2__.initHomeHeroAsideMobileSlider)();
  }, 250);
};
var replaceHomeList = function replaceHomeList() {
  if ($(window).width() < mq.lg) {
    $(".js-plants-tab-first").append($(".js-plants-content-first"));
    $(".js-plants-tab-second").append($(".js-plants-content-second"));
  } else {
    $(".js-plants-row").prepend($(".js-plants-content-second"));
    $(".js-plants-row").prepend($(".js-plants-content-first"));
  }
};
function checkSiteNotice() {
  // Check the notice if it should be shown
  if (!js_cookie__WEBPACK_IMPORTED_MODULE_10__["default"].get("notice-hidden") || js_cookie__WEBPACK_IMPORTED_MODULE_10__["default"].get("notice-hidden") !== "true") {
    $(".js-site-notice").removeClass("d-none");
    $(".js-home-hero").removeClass("no-sitenotice");
  }
}

// On click js-close-notice use js-cookie to set "notice-hidden" cookie to true and hide the notice
$(document).on("click", ".js-close-notice", function () {
  // Set cookie and hide notice
  js_cookie__WEBPACK_IMPORTED_MODULE_10__["default"].set("notice-hidden", "true", {
    expires: 1
  });
  $(".js-site-notice").addClass("d-none");
  $(".js-home-hero").addClass("no-sitenotice");
});
$(document).on("click", ".js-quickview-toggle", function (event) {
  (0,_find_my_pot__WEBPACK_IMPORTED_MODULE_12__.showQuickView)(event);
});
var screenWidth = $(window).width();
$(window).on("resize", function () {
  if (screenWidth === $(window).width()) {
    return;
  }
  screenWidth = $(window).width();
  responsiveChanges();
  replaceMenu();
  changeFilter();
  replaceHome();
  replaceHomeList();
  updateHeroCurves();
});

// Compare button container vs content container width and toggle curve classes
// 3 states: buttons narrower (default curves), equal (no curves), wider (reversed curves)
function updateHeroCurves() {
  var content = document.querySelector(".home-hero-top__content");
  var buttons = document.querySelector(".home-hero-top__buttons-container");
  if (!content || !buttons) return;
  if (content.offsetParent === null) return;

  // Reset all states
  content.classList.remove("home-hero-top__content--no-curve", "home-hero-top__content--wider-below", "home-hero-top__content--narrower-below");
  buttons.classList.remove("home-hero-top__buttons-container--no-curve", "home-hero-top__buttons-container--wider");
  buttons.style.minWidth = "";
  void content.offsetWidth;
  var contentWidth = content.offsetWidth;
  var buttonsWidth = buttons.offsetWidth;
  var diff = buttonsWidth - contentWidth;
  var threshold = 20;
  if (diff > threshold) {
    // Buttons clearly wider: show reversed curves + top-right radius
    content.classList.add("home-hero-top__content--wider-below");
    buttons.classList.add("home-hero-top__buttons-container--wider");
  } else if (diff > -threshold) {
    // Nearly equal: force same width, no curves
    buttons.style.minWidth = contentWidth + "px";
    content.classList.add("home-hero-top__content--no-curve");
    buttons.classList.add("home-hero-top__buttons-container--no-curve");
  } else {
    // Buttons clearly narrower: show default curves + content bottom-right radius
    content.classList.add("home-hero-top__content--narrower-below");
  }
  // else: buttons narrower — default curves apply
}
checkSiteNotice();
replaceHomeList();
replaceHome();
replaceMenu();

// Run after initial layout + fonts are ready
requestAnimationFrame(function () {
  requestAnimationFrame(updateHeroCurves);
});
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(updateHeroCurves);
}
window.addEventListener('resize', updateHeroCurves);

// checkRedirect();

/***/ }),

/***/ "./src/js/b2b-quote-form.js":
/*!**********************************!*\
  !*** ./src/js/b2b-quote-form.js ***!
  \**********************************/
/***/ (() => {

// B2B Multi-step Quote Form Handler
(function () {
  'use strict';

  var B2BQuoteForm = {
    form: null,
    currentStep: 1,
    totalSteps: 2,
    init: function init() {
      this.form = document.getElementById('b2b-quote-form-element');
      if (!this.form) return;
      this.bindEvents();
      this.setTimestamp();
      this.addNotificationStyles();
    },
    addNotificationStyles: function addNotificationStyles() {
      if (document.getElementById('b2b-notification-styles')) return;
      var style = document.createElement('style');
      style.id = 'b2b-notification-styles';
      style.textContent = "\n        @keyframes b2bSlideIn {\n          from { transform: translateX(100%); opacity: 0; }\n          to { transform: translateX(0); opacity: 1; }\n        }\n        @keyframes b2bSlideOut {\n          from { transform: translateX(0); opacity: 1; }\n          to { transform: translateX(100%); opacity: 0; }\n        }\n        .b2b-notification {\n          position: fixed;\n          top: 20px;\n          right: 20px;\n          z-index: 10000;\n          max-width: 420px;\n          background: linear-gradient(135deg, #023c2d 0%, #045d44 100%);\n          color: white;\n          padding: 20px 24px;\n          border-radius: 12px;\n          box-shadow: 0 10px 40px rgba(0,0,0,0.2);\n          animation: b2bSlideIn 0.4s ease-out;\n        }\n        .b2b-notification.hiding {\n          animation: b2bSlideOut 0.3s ease-out forwards;\n        }\n        .b2b-notification__icon {\n          width: 48px;\n          height: 48px;\n          background: rgba(255,255,255,0.2);\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          font-size: 24px;\n        }\n        .b2b-notification__title {\n          font-size: 18px;\n          font-weight: 600;\n          margin: 0 0 4px;\n        }\n        .b2b-notification__message {\n          font-size: 14px;\n          opacity: 0.9;\n          margin: 0;\n        }\n        .b2b-notification__close {\n          position: absolute;\n          top: 12px;\n          right: 12px;\n          background: none;\n          border: none;\n          color: white;\n          opacity: 0.7;\n          cursor: pointer;\n          font-size: 18px;\n          padding: 4px;\n          line-height: 1;\n        }\n        .b2b-notification__close:hover {\n          opacity: 1;\n        }\n      ";
      document.head.appendChild(style);
    },
    bindEvents: function bindEvents() {
      var _this = this;
      // Next step button
      document.querySelectorAll('.js-quote-next').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var nextStep = parseInt(e.currentTarget.dataset.next);
          if (_this.validateStep(_this.currentStep)) {
            _this.goToStep(nextStep);
          }
        });
      });

      // Previous step button
      document.querySelectorAll('.js-quote-prev').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var prevStep = parseInt(e.currentTarget.dataset.prev);
          _this.goToStep(prevStep);
        });
      });

      // Pot toggle conditional logic
      document.querySelectorAll('.js-pot-toggle').forEach(function (radio) {
        radio.addEventListener('change', function (e) {
          _this.togglePotQuestions(e.target.value === 'Ja');
        });
      });

      // Form submission via AJAX
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (_this.validateStep(2)) {
          _this.submitForm();
        }
      });

      // Clear validation on input
      this.form.querySelectorAll('input, textarea').forEach(function (field) {
        field.addEventListener('input', function () {
          field.classList.remove('is-invalid');
        });
      });

      // Clear checkbox group validation on change
      this.form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function (field) {
        field.addEventListener('change', function () {
          var group = field.closest('.b2b-quote-form__checkbox-group, .b2b-quote-form__radio-group');
          if (group) {
            group.classList.remove('is-invalid');
          }
        });
      });
    },
    validateStep: function validateStep(step) {
      var stepEl = this.form.querySelector("[data-step=\"".concat(step, "\"]"));
      if (!stepEl) return true;
      var isValid = true;

      // Validate text/email/tel inputs
      var requiredInputs = stepEl.querySelectorAll('input[required]:not([type="checkbox"]):not([type="radio"])');
      requiredInputs.forEach(function (field) {
        field.classList.remove('is-invalid');
        if (!field.value.trim()) {
          field.classList.add('is-invalid');
          isValid = false;
        }

        // Email validation
        if (field.type === 'email' && field.value) {
          var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!emailPattern.test(field.value)) {
            field.classList.add('is-invalid');
            isValid = false;
          }
        }
      });

      // Step 2 specific validations
      if (step === 2) {
        // Validate at least one plant size is selected
        var sizeCheckboxes = stepEl.querySelectorAll('input[name="plant_sizes[]"]:checked');
        var sizeGroup = document.getElementById('plant-size-group');
        var sizeError = document.getElementById('size-error');
        if (sizeCheckboxes.length === 0) {
          if (sizeGroup) sizeGroup.classList.add('is-invalid');
          if (sizeError) sizeError.style.display = 'block';
          isValid = false;
        } else {
          if (sizeGroup) sizeGroup.classList.remove('is-invalid');
          if (sizeError) sizeError.style.display = 'none';
        }

        // Validate pot preference is selected
        var potRadios = stepEl.querySelectorAll('input[name="want_pots"]:checked');
        var potGroup = document.getElementById('pot-preference-group');
        var potError = document.getElementById('pot-error');
        if (potRadios.length === 0) {
          if (potGroup) potGroup.classList.add('is-invalid');
          if (potError) potError.style.display = 'block';
          isValid = false;
        } else {
          if (potGroup) potGroup.classList.remove('is-invalid');
          if (potError) potError.style.display = 'none';
        }

        // Validate quantity
        var quantityField = document.getElementById('b2b-quantity');
        if (quantityField && !quantityField.value.trim()) {
          quantityField.classList.add('is-invalid');
          isValid = false;
        }
      }
      return isValid;
    },
    goToStep: function goToStep(step) {
      // Hide all steps
      this.form.querySelectorAll('.b2b-quote-form__step').forEach(function (s) {
        s.style.display = 'none';
      });

      // Show target step
      var targetStep = this.form.querySelector("[data-step=\"".concat(step, "\"]"));
      if (targetStep) {
        targetStep.style.display = 'block';
      }

      // Update progress indicator
      document.querySelectorAll('.progress-step').forEach(function (indicator) {
        var indicatorStep = parseInt(indicator.dataset.step);
        indicator.classList.remove('active', 'completed');
        if (indicatorStep < step) {
          indicator.classList.add('completed');
        } else if (indicatorStep === step) {
          indicator.classList.add('active');
        }
      });
      this.currentStep = step;

      // Scroll to form top
      var formSection = document.getElementById('b2b-quote-form');
      if (formSection) {
        formSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    togglePotQuestions: function togglePotQuestions(show) {
      var potQuestions = document.querySelector('.js-pot-questions');
      if (potQuestions) {
        potQuestions.style.display = show ? 'block' : 'none';

        // Clear conditional fields if hidden
        if (!show) {
          potQuestions.querySelectorAll('input').forEach(function (input) {
            if (input.type === 'radio') {
              input.checked = false;
            } else {
              input.value = '';
            }
          });
        }
      }
    },
    setTimestamp: function setTimestamp() {
      var timestampField = document.getElementById('form-timestamp');
      if (timestampField) {
        timestampField.value = new Date().toISOString();
      }
    },
    submitForm: function submitForm() {
      var _this2 = this;
      var submitBtn = this.form.querySelector('.js-quote-submit');
      var originalHTML = submitBtn.innerHTML;

      // Show loading state
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>Verzenden...';

      // Collect form data
      var formData = new FormData(this.form);

      // Get values
      var company = formData.get('company') || '';
      var name = formData.get('name') || '';
      var email = formData.get('email') || '';
      var phone = formData.get('phone') || '';
      var vat = formData.get('vat_number') || '';
      var quantity = formData.get('quantity_needed') || '';
      var comments = formData.get('comments') || '';
      var wantPots = formData.get('want_pots') || '';
      var potColor = formData.get('pot_color_preference') || '';
      var plantsInPots = formData.get('plants_in_pots') || '';
      var timestamp = formData.get('timestamp') || '';
      var sourcePage = formData.get('source_page') || window.location.href;

      // Get plant sizes
      var plantSizes = formData.getAll('plant_sizes[]');
      var plantSizesText = plantSizes.join(', ');

      // Format date
      var dateObj = new Date(timestamp);
      var formattedDate = dateObj.toLocaleDateString('nl-NL', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });

      // Build plain text message for better email compatibility
      var messageBody = "\n\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\n       B2B OFFERTE AANVRAAG - GREEN BUBBLE\n\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\n\n\uD83D\uDCCB BEDRIJFSGEGEVENS\n\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\nBedrijfsnaam:     ".concat(company, "\nContactpersoon:   ").concat(name, "\nE-mail:           ").concat(email, "\nTelefoon:         ").concat(phone, "\nBTW-nummer:       ").concat(vat || 'Niet opgegeven', "\n\n\uD83C\uDF31 PLANTWENSEN\n\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\nPlantformaten:    ").concat(plantSizesText, "\nAantal planten:   ").concat(quantity, "\n\n\uD83E\uDEB4 POTVOORKEUREN\n\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\nPotten gewenst:   ").concat(wantPots);
      if (wantPots === 'Ja') {
        messageBody += "\nKleurvoorkeur:    ".concat(potColor || 'Niet opgegeven', "\nIn sierpotten:    ").concat(plantsInPots || 'Niet opgegeven');
      }
      if (comments) {
        messageBody += "\n\n\uD83D\uDCAC OPMERKINGEN\n\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\n".concat(comments);
      }
      messageBody += "\n\n\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\n\uD83D\uDCC5 Ontvangen op: ".concat(formattedDate, "\n\uD83D\uDD17 Bron: ").concat(sourcePage, "\n\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\n");

      // Create payload with clean structured fields for Web3Forms
      var payload = {
        access_key: formData.get('access_key'),
        subject: "\uD83C\uDF3F Nieuwe B2B Offerte Aanvraag - ".concat(company),
        from_name: 'Green Bubble B2B',
        replyto: email,
        // Section headers as field names with values
        '═══ BEDRIJFSGEGEVENS ═══': '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━',
        'Bedrijfsnaam': company,
        'Contactpersoon': name,
        'E-mail': email,
        'Telefoon': phone,
        'BTW-nummer': vat || '—',
        '═══ PLANTWENSEN ═══': '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━',
        'Gewenste plantformaten': plantSizesText,
        'Aantal planten nodig': quantity,
        '═══ POTVOORKEUREN ═══': '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━',
        'Potten gewenst': wantPots,
        'Kleurvoorkeur potten': wantPots === 'Ja' ? potColor || '—' : 'n.v.t.',
        'Planten in sierpotten': wantPots === 'Ja' ? plantsInPots || '—' : 'n.v.t.',
        '═══ EXTRA INFO ═══': '━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━',
        'Opmerkingen': comments || '—',
        'Ontvangen op': formattedDate,
        'Aanvraag via pagina': sourcePage
      };

      // Submit via AJAX
      fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.success) {
          _this2.showSuccessNotification();
          _this2.resetForm();
        } else {
          throw new Error(data.message || 'Verzenden mislukt');
        }
      })["catch"](function (error) {
        console.error('Form submission error:', error);
        _this2.showErrorNotification();
      })["finally"](function () {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalHTML;
      });
    },
    showSuccessNotification: function showSuccessNotification() {
      var _this3 = this;
      // Remove existing notifications
      document.querySelectorAll('.b2b-notification').forEach(function (n) {
        return n.remove();
      });
      var notification = document.createElement('div');
      notification.className = 'b2b-notification';
      notification.innerHTML = "\n        <button class=\"b2b-notification__close\" aria-label=\"Sluiten\">&times;</button>\n        <div class=\"d-flex align-items-center gap-3\">\n          <div class=\"b2b-notification__icon\">\n            <i class=\"fa-sharp fa-solid fa-check\"></i>\n          </div>\n          <div>\n            <p class=\"b2b-notification__title\">Bedankt voor uw aanvraag!</p>\n            <p class=\"b2b-notification__message\">We nemen zo snel mogelijk contact met u op.</p>\n          </div>\n        </div>\n      ";
      document.body.appendChild(notification);

      // Close button
      notification.querySelector('.b2b-notification__close').addEventListener('click', function () {
        _this3.hideNotification(notification);
      });

      // Auto-hide after 6 seconds
      setTimeout(function () {
        _this3.hideNotification(notification);
      }, 6000);
    },
    showErrorNotification: function showErrorNotification() {
      var _this4 = this;
      // Remove existing notifications
      document.querySelectorAll('.b2b-notification').forEach(function (n) {
        return n.remove();
      });
      var notification = document.createElement('div');
      notification.className = 'b2b-notification';
      notification.style.background = 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)';
      notification.innerHTML = "\n        <button class=\"b2b-notification__close\" aria-label=\"Sluiten\">&times;</button>\n        <div class=\"d-flex align-items-center gap-3\">\n          <div class=\"b2b-notification__icon\">\n            <i class=\"fa-sharp fa-solid fa-exclamation\"></i>\n          </div>\n          <div>\n            <p class=\"b2b-notification__title\">Er ging iets mis</p>\n            <p class=\"b2b-notification__message\">Probeer het opnieuw of neem contact met ons op.</p>\n          </div>\n        </div>\n      ";
      document.body.appendChild(notification);

      // Close button
      notification.querySelector('.b2b-notification__close').addEventListener('click', function () {
        _this4.hideNotification(notification);
      });

      // Auto-hide after 6 seconds
      setTimeout(function () {
        _this4.hideNotification(notification);
      }, 6000);
    },
    hideNotification: function hideNotification(notification) {
      if (!notification || !notification.parentElement) return;
      notification.classList.add('hiding');
      setTimeout(function () {
        if (notification.parentElement) {
          notification.remove();
        }
      }, 300);
    },
    resetForm: function resetForm() {
      // Reset all form fields
      this.form.reset();

      // Go back to step 1
      this.goToStep(1);

      // Reset progress indicators
      document.querySelectorAll('.progress-step').forEach(function (indicator) {
        indicator.classList.remove('completed');
        if (parseInt(indicator.dataset.step) === 1) {
          indicator.classList.add('active');
        } else {
          indicator.classList.remove('active');
        }
      });

      // Hide pot questions
      this.togglePotQuestions(false);

      // Reset timestamp
      this.setTimestamp();

      // Scroll to form
      var formSection = document.getElementById('b2b-quote-form');
      if (formSection) {
        formSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      return B2BQuoteForm.init();
    });
  } else {
    B2BQuoteForm.init();
  }
})();

/***/ }),

/***/ "./src/js/collection-description.js":
/*!******************************************!*\
  !*** ./src/js/collection-description.js ***!
  \******************************************/
/***/ (() => {

(function () {
  // Store original HTML for re-rendering on resize
  var originalHtmlStore = null;
  var lastScreenMode = null;
  function initCollectionDescription(forceReinit) {
    var container = document.getElementById('collection-description-sections');
    if (!container) return;

    // Determine current screen mode
    var currentScreenMode = window.innerWidth >= 768 ? 'desktop' : 'mobile';

    // Check if already processed (has collection-section-block children)
    if (container.querySelector('.collection-section-block') && !forceReinit) {
      return;
    }

    // If forcing reinit and screen mode hasn't changed, skip
    if (forceReinit && lastScreenMode === currentScreenMode) {
      return;
    }
    lastScreenMode = currentScreenMode;

    // Get raw HTML - preserve the original content
    // Use stored original if this is a reinit, otherwise get from container
    var rawHtml;
    if (forceReinit && originalHtmlStore) {
      rawHtml = originalHtmlStore;
    } else {
      rawHtml = container.innerHTML.trim();
      // Store original HTML on first init
      if (!originalHtmlStore && rawHtml) {
        originalHtmlStore = rawHtml;
      }
    }
    if (!rawHtml) {
      console.warn('Collection description: No content found');
      return;
    }

    // Store original HTML in case we need to fall back
    var originalHtml = rawHtml;

    // Clear container
    container.innerHTML = '';

    // Create temporary div to parse HTML
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = rawHtml;

    // Split content by H2 headings
    var sections = [];
    var currentHeading = null;
    var currentContent = [];
    Array.from(tempDiv.childNodes).forEach(function (node) {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H2') {
        // Save previous section if exists
        if (currentHeading || currentContent.length > 0) {
          sections.push({
            heading: currentHeading,
            content: currentContent
          });
        }
        // Start new section
        currentHeading = node.cloneNode(true);
        currentContent = [];
      } else if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        // Add to current section content
        currentContent.push(node.cloneNode(true));
      }
    });

    // Add last section
    if (currentHeading || currentContent.length > 0) {
      sections.push({
        heading: currentHeading,
        content: currentContent
      });
    }

    // If no sections were created, restore original HTML and return
    if (sections.length === 0) {
      console.warn('Collection description: No sections found, restoring original content');
      container.innerHTML = originalHtml;
      return;
    }

    // Check if desktop (md breakpoint = 768px)
    var isDesktop = window.innerWidth >= 768;

    // Create blocks for each section
    sections.forEach(function (section, index) {
      // Skip empty sections - check if there's any meaningful content
      if (!section.heading && section.content.length === 0) {
        return;
      }

      // Check if all content is empty (only whitespace text nodes)
      if (!section.heading && section.content.length > 0) {
        var hasContent = section.content.some(function (node) {
          if (node.nodeType === Node.TEXT_NODE) {
            return node.textContent.trim().length > 0;
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            return node.textContent.trim().length > 0 || node.children.length > 0;
          }
          return true;
        });
        if (!hasContent) {
          return;
        }
      }
      var sectionBlock = document.createElement('div');
      sectionBlock.classList.add('col-lg-6', 'col-12');
      var innerBlock = document.createElement('div');
      innerBlock.classList.add('collection-section-block');

      // Add heading if exists
      if (section.heading) {
        innerBlock.appendChild(section.heading.cloneNode(true));
      }

      // Create content wrapper
      var contentWrapper = document.createElement('div');
      contentWrapper.classList.add('collection-section-content');

      // Always show full content without truncation on all screen sizes
      section.content.forEach(function (node) {
        contentWrapper.appendChild(node.cloneNode(true));
      });
      innerBlock.appendChild(contentWrapper);
      sectionBlock.appendChild(innerBlock);

      // Only append if there's actual content in the block
      if (contentWrapper.innerHTML.trim() || section.heading) {
        container.appendChild(sectionBlock);
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCollectionDescription(false);
    });
  } else {
    // DOM is already ready
    initCollectionDescription(false);
  }

  // Also listen for Shopify section:load event (for theme editor)
  document.addEventListener('shopify:section:load', function () {
    initCollectionDescription(false);
  });

  // Re-render on window resize when crossing mobile/desktop breakpoint
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initCollectionDescription(true);
    }, 150);
  });
})();

/***/ }),

/***/ "./src/js/custom-add-to-cart.js":
/*!**************************************!*\
  !*** ./src/js/custom-add-to-cart.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   addEventListenersToCart: () => (/* binding */ addEventListenersToCart),
/* harmony export */   initRelatedAddToCart: () => (/* binding */ initRelatedAddToCart),
/* harmony export */   refreshCartSections: () => (/* binding */ refreshCartSections),
/* harmony export */   updateCart: () => (/* binding */ updateCart)
/* harmony export */ });
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
/* harmony import */ var _sliders__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./sliders */ "./src/js/sliders.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "../../node_modules/.pnpm/jquery@3.7.1/node_modules/jquery/dist/jquery.js");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }


var addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

/**
 * Get all add-on services data from checked checkboxes
 * @returns {Array} Array of add-on data objects
 */
function getAddonServicesData() {
  var addonCheckboxes = document.querySelectorAll('.js-addon-checkbox:checked');
  if (addonCheckboxes.length === 0) return [];
  var quantityInput = document.querySelector('input[name="quantity"]');
  var quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
  var addons = [];
  addonCheckboxes.forEach(function (checkbox) {
    var addonVariationId = parseInt(checkbox.value);
    var addonProductId = checkbox.dataset.productId;
    if (!addonProductId || !addonVariationId) return;

    // Get add-on message if available
    var addonOption = checkbox.closest('.product-addon-option');
    var addonMessageInput = addonOption ? addonOption.querySelector('.js-addon-message') : null;
    var addonMessage = addonMessageInput ? (addonMessageInput.value || '').trim() : '';
    var addonName = checkbox.dataset.addonName || 'Add-on';
    var addonType = checkbox.dataset.addonType || 'addon';
    var addon = {
      id: addonVariationId,
      quantity: quantity,
      properties: {
        _sub: "true",
        _type: addonType
      }
    };

    // Add message if present
    if (addonMessage) {
      addon.properties[addonName + ' Message'] = addonMessage;
    }
    addons.push(addon);
  });
  return addons;
}

/**
 * Validate card message - if card is selected, message must be entered
 * @returns {Object} { valid: boolean, message: string }
 */
function validateCardMessage() {
  var cardCheckbox = document.querySelector('.js-card-checkbox:checked');
  if (!cardCheckbox) return {
    valid: true,
    message: ''
  };

  // Card is selected, check if message is entered
  var cardOption = cardCheckbox.closest('.product-card-option');
  var cardMessageInput = cardOption ? cardOption.querySelector('.js-card-message') : null;
  var cardMessage = cardMessageInput ? (cardMessageInput.value || '').trim() : '';
  if (!cardMessage) {
    var _window$cartTranslati;
    return {
      valid: false,
      message: ((_window$cartTranslati = window.cartTranslations) === null || _window$cartTranslati === void 0 ? void 0 : _window$cartTranslati.card_message_required) || 'Vul een bericht in voor de kaart'
    };
  }
  return {
    valid: true,
    message: ''
  };
}

/**
 * Show validation error for card message
 * @param {string} message - Error message to display
 */
function showCardMessageError(message) {
  var cardOption = document.querySelector('.product-card-option');
  if (!cardOption) return;

  // Remove any existing error
  var existingError = cardOption.querySelector('.card-message-error');
  if (existingError) existingError.remove();

  // Create and show error message
  var errorDiv = document.createElement('div');
  errorDiv.className = 'card-message-error text-danger mt-2';
  errorDiv.style.cssText = 'font-size: 13px; font-weight: 500;';
  errorDiv.innerHTML = "<i class=\"fa-sharp fa-regular fa-circle-exclamation me-1\"></i>".concat(message);
  var messageWrapper = cardOption.querySelector('.product-card-option__message-wrapper');
  if (messageWrapper) {
    messageWrapper.appendChild(errorDiv);
  }

  // Focus on the textarea
  var cardMessageInput = cardOption.querySelector('.js-card-message');
  if (cardMessageInput) {
    cardMessageInput.focus();
    cardMessageInput.style.borderColor = '#dc3545';
  }

  // Auto-remove error after 5 seconds or when user types
  setTimeout(function () {
    if (errorDiv.parentElement) errorDiv.remove();
    if (cardMessageInput) cardMessageInput.style.borderColor = '';
  }, 5000);
  if (cardMessageInput) {
    cardMessageInput.addEventListener('input', function onInput() {
      if (errorDiv.parentElement) errorDiv.remove();
      cardMessageInput.style.borderColor = '';
      cardMessageInput.removeEventListener('input', onInput);
    }, {
      once: true
    });
  }
}

/**
 * Get card service data from checked checkbox
 * @returns {Object|null} Card service data object or null
 */
function getCardServiceData() {
  var cardCheckbox = document.querySelector('.js-card-checkbox:checked');
  if (!cardCheckbox) return null;
  var cardVariationId = parseInt(cardCheckbox.value);
  var cardProductId = cardCheckbox.dataset.productId;
  if (!cardProductId || !cardVariationId) return null;
  var quantityInput = document.querySelector('input[name="quantity"]');
  var quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

  // Get card type and message from the same card option container
  var cardOption = cardCheckbox.closest('.product-card-option');

  // Find the checked radio button within this specific card option
  var cardType = '';
  if (cardOption) {
    var cardTypeInput = cardOption.querySelector('input.js-card-type-radio:checked');
    if (cardTypeInput) {
      cardType = cardTypeInput.value;
    }
  }

  // Find the message textarea within this specific card option
  var cardMessage = '';
  if (cardOption) {
    var cardMessageInput = cardOption.querySelector('textarea.js-card-message');
    if (cardMessageInput) {
      cardMessage = (cardMessageInput.value || '').trim();
    }
  }
  var cardItem = {
    id: cardVariationId,
    quantity: quantity,
    properties: {
      _sub: "true",
      _type: 'card_service'
    }
  };

  // Add card type if selected
  if (cardType) {
    cardItem.properties['Card Type'] = cardType;
  }

  // Add card message if present
  if (cardMessage) {
    cardItem.properties['Card Message'] = cardMessage;
  }
  return cardItem;
}

/**
 * Get upsell items data from checked checkboxes
 * @returns {Array} Array of upsell item objects
 */
function getUpsellItemsData() {
  var upsellCheckboxes = document.querySelectorAll('.js-upsell-checkbox:checked');
  if (upsellCheckboxes.length === 0) return [];
  var quantityInput = document.querySelector('input[name="quantity"]');
  var quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
  var upsells = [];
  upsellCheckboxes.forEach(function (checkbox) {
    var upsellVariationId = parseInt(checkbox.value);
    var upsellProductId = checkbox.dataset.productId;
    var upsellTitle = checkbox.dataset.title || 'Upsell';
    if (!upsellProductId || !upsellVariationId) return;
    upsells.push({
      id: upsellVariationId,
      quantity: quantity,
      properties: {
        _sub: "true",
        _type: 'upsell'
      }
    });
  });
  return upsells;
}

/**
 * Build cart items array from form and selected add-ons
 * @param {HTMLFormElement} form - The form element
 * @returns {Array} Array of cart item objects
 */
function buildCartItems(form) {
  var formData = new FormData(form);
  var variantId = formData.get('id');
  var quantity = parseInt(formData.get('quantity')) || 1;
  if (!variantId) {
    console.error('No variant ID found in form');
    return [];
  }
  var items = [];

  // Get add-ons, card, and upsells. Potting comes through the generic add-on path with
  // _type: potting, set on the checkbox by snippets/product-addon-option.liquid.
  var addonItems = getAddonServicesData();
  var cardItem = getCardServiceData();
  var upsellItems = getUpsellItemsData();
  var hasRelatedItems = addonItems.length > 0 || cardItem || upsellItems.length > 0;

  // Only generate configuration ID when there are related items to group
  var configurationId = hasRelatedItems ? Date.now().toString() : null;

  // Add add-ons first (they will be sub-items)
  addonItems.forEach(function (item) {
    item.properties._configuration_id = configurationId;
    items.push(item);
  });

  // Add card service if selected
  if (cardItem) {
    cardItem.properties._configuration_id = configurationId;
    items.push(cardItem);
  }

  // Add upsell items if selected
  upsellItems.forEach(function (item) {
    item.properties._configuration_id = configurationId;
    items.push(item);
  });

  // Add main product last (it will be the main item)
  var mainProduct = {
    id: variantId,
    quantity: quantity,
    properties: {}
  };

  // Only add grouping properties when there are related items
  if (hasRelatedItems) {
    mainProduct.properties._sub = "false";
    mainProduct.properties._configuration_id = configurationId;
  }

  // Copy any other form properties to main product (skip empty values)
  var _iterator = _createForOfIteratorHelper(formData.entries()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        value = _step$value[1];
      if (key !== 'id' && key !== 'quantity' && key.startsWith('properties[') && value.trim() !== '') {
        var propName = key.replace('properties[', '').replace(']', '');
        mainProduct.properties[propName] = value;
      }
    }

    // Remove empty properties so Shopify can stack identical items
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (Object.keys(mainProduct.properties).length === 0) {
    delete mainProduct.properties;
  }
  items.push(mainProduct);
  return items;
}

/**
 * Show an instant placeholder card in the drawer while the API runs.
 * Replaced when the real .drawer-cart innerHTML is swapped in.
 *
 * @param {Element} [sourceEl] Optional element to read title/image from
 *        (e.g. a product card). Defaults to the PDP <h1> + hero image.
 */
function injectOptimisticCartPlaceholder(sourceEl) {
  var drawer = document.querySelector('.drawer-cart');
  if (!drawer) return;
  var title = 'Product';
  var imageSrc = '';
  if (sourceEl) {
    // Reading from a product card on a collection / homepage / related products.
    var card = sourceEl.closest('.block-product') || sourceEl;
    var cardTitle = card.querySelector('.block-product__title');
    var cardImg = card.querySelector('.block-product__media img');
    if (cardTitle) title = cardTitle.textContent.trim();
    if (cardImg) imageSrc = cardImg.currentSrc || cardImg.src;
  } else {
    // PDP fallback — read from the page's main H1 + hero slider.
    var titleEl = document.querySelector('h1.display-2');
    var imageEl = document.querySelector('.product-hero-main-slider__slide.slick-active img, .product-hero-main-slider__slide img');
    if (titleEl) title = titleEl.textContent.trim();
    if (imageEl) imageSrc = imageEl.currentSrc || imageEl.src;
  }
  var contentArea = drawer.querySelector('.drawer-content');
  if (!contentArea) return;
  var placeholderHtml = "\n\t\t<div class=\"cart-item rounded p-1 position-relative js-optimistic-placeholder\" style=\"opacity:.7;background:rgba(0,0,0,.02);\">\n\t\t\t<div class=\"cart-item__content d-flex align-items-center gap-1 w-100\">\n\t\t\t\t<div class=\"cart-item__media position-relative\" style=\"width:60px;height:60px;flex-shrink:0;\">\n\t\t\t\t\t".concat(imageSrc ? "<img src=\"".concat(imageSrc, "\" alt=\"").concat(title, "\" class=\"img-abs-center\" style=\"width:100%;height:100%;object-fit:cover;border-radius:4px;\">") : '', "\n\t\t\t\t</div>\n\t\t\t\t<div class=\"cart-item__details flex-grow-1 ps-1\">\n\t\t\t\t\t<strong class=\"cart-item__title fw-medium d-block lh-1 mb-1\">").concat(title, "</strong>\n\t\t\t\t\t<small class=\"text-muted\">\n\t\t\t\t\t\t<i class=\"fa-duotone fa-solid fa-spinner-third fa-spin\"></i> Adding\u2026\n\t\t\t\t\t</small>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t");
  contentArea.insertAdjacentHTML('afterbegin', placeholderHtml);
}
addToCartForms.forEach(function (form) {
  form.addEventListener('submit', /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
      var cardValidation, cartItems, addData, cartRes, cartData, existingItem, changeRes, addRes, _addRes, minicartHtml, newBox;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            event.preventDefault();

            // Skip if find-my-pot configurator is handling add-to-cart
            if (!document.querySelector('#find_my_pot_configurator .js-plant-configuration')) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            // Validate card message if card is selected
            cardValidation = validateCardMessage();
            if (cardValidation.valid) {
              _context.n = 2;
              break;
            }
            showCardMessageError(cardValidation.message);
            return _context.a(2);
          case 2:
            // Build cart items array
            cartItems = buildCartItems(form);
            if (!(cartItems.length === 0)) {
              _context.n = 3;
              break;
            }
            console.error('No items to add to cart');
            return _context.a(2);
          case 3:
            // Open drawer immediately for instant UX feedback.
            // Cart content updates after the API response below.
            (0,_functions__WEBPACK_IMPORTED_MODULE_0__.openMiniCart)();
            (0,_functions__WEBPACK_IMPORTED_MODULE_0__.lockHTML)();

            // Optimistic UI: show a placeholder card while the API + section render runs.
            injectOptimisticCartPlaceholder();
            if (!(cartItems.length === 1)) {
              _context.n = 12;
              break;
            }
            _context.n = 4;
            return fetch(window.Shopify.routes.root + 'cart.js');
          case 4:
            cartRes = _context.v;
            _context.n = 5;
            return cartRes.json();
          case 5:
            cartData = _context.v;
            existingItem = cartData.items.find(function (item) {
              var _item$properties;
              return item.variant_id === parseInt(cartItems[0].id) && !((_item$properties = item.properties) !== null && _item$properties !== void 0 && _item$properties._configuration_id);
            });
            if (!existingItem) {
              _context.n = 8;
              break;
            }
            _context.n = 6;
            return fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: "POST",
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                line: cartData.items.indexOf(existingItem) + 1,
                quantity: existingItem.quantity + cartItems[0].quantity,
                sections: ['base-minicart']
              })
            });
          case 6:
            changeRes = _context.v;
            _context.n = 7;
            return changeRes.json();
          case 7:
            addData = _context.v;
            _context.n = 11;
            break;
          case 8:
            _context.n = 9;
            return fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: "POST",
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: cartItems,
                sections: ['base-minicart']
              })
            });
          case 9:
            addRes = _context.v;
            _context.n = 10;
            return addRes.json();
          case 10:
            addData = _context.v;
          case 11:
            _context.n = 15;
            break;
          case 12:
            _context.n = 13;
            return fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: "POST",
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: cartItems,
                sections: ['base-minicart']
              })
            });
          case 13:
            _addRes = _context.v;
            _context.n = 14;
            return _addRes.json();
          case 14:
            addData = _context.v;
          case 15:
            if (!(addData.sections && addData.sections['base-minicart'])) {
              _context.n = 16;
              break;
            }
            minicartHtml = document.createElement('div');
            minicartHtml.innerHTML = addData.sections['base-minicart'];
            newBox = minicartHtml.querySelector('.drawer-cart');
            if (newBox) {
              document.querySelector('.drawer-cart').innerHTML = newBox.innerHTML;
              requestAnimationFrame(function () {
                addEventListenersToCart();
                initRelatedAddToCart();
                (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.reInitCartSliders)();
              });
            }
            _context.n = 17;
            break;
          case 16:
            _context.n = 17;
            return refreshCartSections();
          case 17:
            // Update cart count
            document.querySelector('.js-cart-count').classList.add('header-main__cart--hasitems');
            (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.debounceReInitSliders)();

            // Update count + gifts in background
            fetch(window.Shopify.routes.root + 'cart.js').then(function (r) {
              return r.json();
            }).then(function (cart) {
              document.querySelectorAll('.js-cart-count').forEach(function (el) {
                el.textContent = cart.item_count;
              });
              new Promise(function (resolve) {
                window.dispatchEvent(new CustomEvent('cart:updated', {
                  detail: {
                    action: 'add',
                    cart: cart,
                    done: resolve
                  }
                }));
              }).then(function () {
                return refreshCartSections();
              });
            });
          case 18:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
});

/**
 * Handle related products add to cart
 */
function initRelatedAddToCart() {
  var addToCartItems = document.querySelectorAll('form.js-related-add-to-cart');
  addToCartItems.forEach(function (form) {
    form.addEventListener('submit', /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
        var formData, items, addRes, addData, minicartHtml, newBox;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              event.preventDefault();

              // Optimistic placeholder — drawer is typically already open here
              // (cross-sells live inside the minicart) but call openMiniCart()
              // just in case (also opens it on related-products carousels on PDP).
              (0,_functions__WEBPACK_IMPORTED_MODULE_0__.openMiniCart)();
              injectOptimisticCartPlaceholder(form);

              // Single combined request that adds + returns the rendered minicart section.
              formData = new FormData(form);
              items = [];
              formData.forEach(function (value, key) {
                if (key === 'id') items.push({
                  id: parseInt(value),
                  quantity: 1
                });
              });
              _context2.n = 1;
              return fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  items: items,
                  sections: ['base-minicart']
                })
              });
            case 1:
              addRes = _context2.v;
              _context2.n = 2;
              return addRes.json();
            case 2:
              addData = _context2.v;
              if (!(addData.sections && addData.sections['base-minicart'])) {
                _context2.n = 3;
                break;
              }
              minicartHtml = document.createElement('div');
              minicartHtml.innerHTML = addData.sections['base-minicart'];
              newBox = minicartHtml.querySelector('.drawer-cart');
              if (newBox) {
                document.querySelector('.drawer-cart').innerHTML = newBox.innerHTML;
                requestAnimationFrame(function () {
                  addEventListenersToCart();
                  initRelatedAddToCart();
                  (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.reInitCartSliders)();
                });
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.n = 4;
              return refreshCartSections();
            case 4:
              document.querySelector('.js-cart-count').classList.add('header-main__cart--hasitems');

              // Update count + dispatch cart:updated in background
              fetch(window.Shopify.routes.root + 'cart.js').then(function (r) {
                return r.json();
              }).then(function (cart) {
                document.querySelectorAll('.js-cart-count').forEach(function (el) {
                  el.textContent = cart.item_count;
                });
                window.dispatchEvent(new CustomEvent('cart:updated', {
                  detail: {
                    action: 'add',
                    cart: cart
                  }
                }));
              });
            case 5:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  });
}
function updateCart(_x3) {
  return _updateCart.apply(this, arguments);
}
function _updateCart() {
  _updateCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(cart) {
    var rootUrl, minicartSectionUrl, jsCart, fetchPromises, cartSectionUrl, responses, texts, minicartHtml, newBox, cartHtml, newCartBox;
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          _context9.n = 1;
          return new Promise(function (resolve) {
            window.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                action: 'add',
                cart: cart,
                done: resolve
              }
            }));
          });
        case 1:
          rootUrl = window.Shopify.routes.root;
          minicartSectionUrl = "".concat(rootUrl, "?section_id=base-minicart");
          jsCart = document.querySelector('.js-cart');
          fetchPromises = [fetch(minicartSectionUrl)];
          if (jsCart) {
            cartSectionUrl = "".concat(rootUrl, "?section_id=page-cart");
            fetchPromises.push(fetch(cartSectionUrl));
          }
          _context9.n = 2;
          return Promise.all(fetchPromises);
        case 2:
          responses = _context9.v;
          _context9.n = 3;
          return Promise.all(responses.map(function (r) {
            return r.text();
          }));
        case 3:
          texts = _context9.v;
          // Update minicart
          minicartHtml = document.createElement('div');
          minicartHtml.innerHTML = texts[0];
          newBox = minicartHtml.querySelector(".drawer-cart");
          document.querySelector('.drawer-cart').innerHTML = newBox.innerHTML;

          // Update cart page if present
          if (jsCart && texts[1]) {
            cartHtml = document.createElement('div');
            cartHtml.innerHTML = texts[1];
            newCartBox = cartHtml.querySelector(".js-cart");
            document.querySelector('.js-cart').innerHTML = newCartBox.innerHTML;
          }

          // Re-attach event listeners
          addEventListenersToCart();
          initRelatedAddToCart();
          (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.reInitCartSliders)();

          // Update mobile cart bar
          updateMobileCartBar();
        case 4:
          return _context9.a(2);
      }
    }, _callee9);
  }));
  return _updateCart.apply(this, arguments);
}
function refreshCartSections() {
  return _refreshCartSections.apply(this, arguments);
}
function _refreshCartSections() {
  _refreshCartSections = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
    var rootUrl, minicartSectionUrl, jsCart, fetchPromises, cartSectionUrl, responses, texts, minicartHtml, newBox, cartHtml, newCartBox;
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.n) {
        case 0:
          rootUrl = window.Shopify.routes.root;
          minicartSectionUrl = "".concat(rootUrl, "?section_id=base-minicart");
          jsCart = document.querySelector('.js-cart');
          fetchPromises = [fetch(minicartSectionUrl)];
          if (jsCart) {
            cartSectionUrl = "".concat(rootUrl, "?section_id=page-cart");
            fetchPromises.push(fetch(cartSectionUrl));
          }
          _context0.n = 1;
          return Promise.all(fetchPromises);
        case 1:
          responses = _context0.v;
          _context0.n = 2;
          return Promise.all(responses.map(function (r) {
            return r.text();
          }));
        case 2:
          texts = _context0.v;
          minicartHtml = document.createElement('div');
          minicartHtml.innerHTML = texts[0];
          newBox = minicartHtml.querySelector(".drawer-cart");
          if (newBox) {
            document.querySelector('.drawer-cart').innerHTML = newBox.innerHTML;
          }
          if (jsCart && texts[1]) {
            cartHtml = document.createElement('div');
            cartHtml.innerHTML = texts[1];
            newCartBox = cartHtml.querySelector(".js-cart");
            if (newCartBox) {
              document.querySelector('.js-cart').innerHTML = newCartBox.innerHTML;
            }
          }
          addEventListenersToCart();
          initRelatedAddToCart();
          (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.reInitCartSliders)();
          updateMobileCartBar();
        case 3:
          return _context0.a(2);
      }
    }, _callee0);
  }));
  return _refreshCartSections.apply(this, arguments);
}
function updateMobileCartBar() {
  var bar = document.querySelector('.js-mobile-cart-bar');
  if (!bar) return;
  fetch(window.Shopify.routes.root + 'cart.js').then(function (r) {
    return r.json();
  }).then(function (cart) {
    if (cart.item_count > 0) {
      bar.style.display = '';
      var totalEl = bar.querySelector('.js-mobile-cart-total');
      if (totalEl) {
        totalEl.textContent = (cart.total_price / 100).toFixed(2).replace('.', ',');
      }
      bar.querySelectorAll('.js-cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    } else {
      bar.style.display = 'none';
    }
  });
}

// Show mobile cart bar on page load if cart has items
updateMobileCartBar();
function addQuantityUpdateListeners() {
  document.querySelectorAll('.js-cart-item-quantity button').forEach(function (button) {
    button.addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var rootItem, key, parentContainer, configurationId, itemType, updateItems, currentQuantity, isUp, newQuantity, updates, removedSubItems, removedByType, pottingItem, pottingKey, cardItem, cardKey, addonItems, _pottingItem, _pottingKey, response, data, res, cart;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            rootItem = button.closest('[data-line-item-key]');
            key = rootItem.getAttribute('data-line-item-key'); // Find parent cart-item/cart-lineitem container to get configuration_id
            parentContainer = rootItem.closest('.cart-item, .cart-lineitem');
            configurationId = parentContainer && parentContainer.hasAttribute('data-configuration-id') ? parentContainer.getAttribute('data-configuration-id') : null; // Get item type from the rootItem
            itemType = rootItem.getAttribute('data-item-type') || 'plant'; // Sub-items in the DOM only carry data-line-item-key — `data-configuration-id`
            // lives on the parent container. To cascade qty changes across the whole
            // configuration group, walk inside the parent container.
            updateItems = configurationId && parentContainer ? parentContainer.querySelectorAll('[data-line-item-key]') : [rootItem];
            updateItems.forEach(function (item) {
              item.querySelectorAll('.js-cart-item-quantity button').forEach(function (btn) {
                return btn.disabled = true;
              });
              item.classList.add('is-updating');
            });

            // Huidige hoeveelheid ophalen van het hoofdproduct
            currentQuantity = parseInt(rootItem.querySelector('.js-cart-item-quantity input').value, 10);
            isUp = button.classList.contains('is-plus');
            newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1; // Stel updates object in
            updates = {};
            removedSubItems = {
              potting: false,
              card: false
            };
            removedByType = ''; // If quantity becomes 0, handle sub-item removal based on item type
            if (newQuantity <= 0 && configurationId) {
              // Add main item to updates
              updates[key] = 0;
              if (parentContainer) {
                if (itemType === 'plant') {
                  // Plant removed - remove all sub-items (potting, card_service, addon)
                  pottingItem = parentContainer.querySelector('[data-item-type="potting"]');
                  if (pottingItem) {
                    pottingKey = pottingItem.getAttribute('data-line-item-key');
                    if (pottingKey && pottingKey !== key) {
                      updates[pottingKey] = 0;
                      removedSubItems.potting = true;
                      removedByType = 'plant';
                      pottingItem.classList.add('is-updating');
                    }
                  }

                  // Remove card_service item (postcard/kaartje)
                  cardItem = parentContainer.querySelector('[data-item-type="card_service"]');
                  if (cardItem) {
                    cardKey = cardItem.getAttribute('data-line-item-key');
                    if (cardKey && cardKey !== key) {
                      updates[cardKey] = 0;
                      removedSubItems.card = true;
                      removedByType = 'plant';
                      cardItem.classList.add('is-updating');
                    }
                  }

                  // Remove all addon items
                  addonItems = parentContainer.querySelectorAll('[data-item-type="addon"]');
                  addonItems.forEach(function (addonItem) {
                    var addonKey = addonItem.getAttribute('data-line-item-key');
                    if (addonKey && addonKey !== key) {
                      updates[addonKey] = 0;
                      addonItem.classList.add('is-updating');
                    }
                  });
                } else if (itemType === 'pot') {
                  // Pot removed - remove potting service only
                  _pottingItem = parentContainer.querySelector('[data-item-type="potting"]');
                  if (_pottingItem) {
                    _pottingKey = _pottingItem.getAttribute('data-line-item-key');
                    if (_pottingKey && _pottingKey !== key) {
                      updates[_pottingKey] = 0;
                      removedSubItems.potting = true;
                      removedByType = 'pot';
                      _pottingItem.classList.add('is-updating');
                    }
                  }
                }
              }
            } else {
              // Normal quantity update - update all items with same configurationId
              updateItems.forEach(function (item) {
                var itemKey = item.getAttribute('data-line-item-key');
                if (itemKey) {
                  updates[itemKey] = newQuantity;
                }
              });
            }

            // AJAX update voor de geselecteerde items
            _context3.n = 1;
            return fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                updates: updates
              })
            });
          case 1:
            response = _context3.v;
            _context3.n = 2;
            return response.json();
          case 2:
            data = _context3.v;
            // update winkelwagen count
            document.querySelectorAll('.js-cart-count').forEach(function (el) {
              return el.textContent = data.item_count;
            });

            // Verwijder is-updating class en enable de buttons
            updateItems.forEach(function (item) {
              item.classList.remove('is-updating');
              item.querySelectorAll('.js-cart-item-quantity button').forEach(function (btn) {
                return btn.disabled = false;
              });
            });

            // Get New Cart object
            _context3.n = 3;
            return fetch(window.Shopify.routes.root + 'cart.js');
          case 3:
            res = _context3.v;
            _context3.n = 4;
            return res.json();
          case 4:
            cart = _context3.v;
            _context3.n = 5;
            return updateCart(cart);
          case 5:
            // Show notification if any sub-items were auto-removed
            if (removedSubItems.potting || removedSubItems.card) {
              showSubItemRemovedNotification(removedSubItems, removedByType);
            }
            document.dispatchEvent(new CustomEvent('lineitem:updated', {
              detail: {
                cart: cart
              }
            }));
            (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.debounceReInitSliders)();
          case 6:
            return _context3.a(2);
        }
      }, _callee3);
    })));
  });

  // Handle direct input changes
  document.querySelectorAll('.js-cart-item-quantity input').forEach(function (input) {
    var debounceTimer;
    input.addEventListener('input', function () {
      // Allow only numbers
      var value = this.value;
      if (value !== '' && !/^\d+$/.test(value)) {
        this.value = value.replace(/\D/g, '');
      }
    });
    input.addEventListener('change', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var _this = this;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
              var rootItem, key, newQuantity, parentContainer, configurationId, itemType, updateItems, updates, removedSubItems, removedByType, pottingItem, pottingKey, cardItem, cardKey, addonItems, _pottingItem2, _pottingKey2, response, data, res, cart;
              return _regenerator().w(function (_context4) {
                while (1) switch (_context4.n) {
                  case 0:
                    rootItem = _this.closest('[data-line-item-key]');
                    key = rootItem.getAttribute('data-line-item-key');
                    newQuantity = parseInt(_this.value, 10); // Validate quantity
                    if (isNaN(newQuantity) || newQuantity < 0) {
                      newQuantity = 0;
                    }

                    // Find parent cart-item/cart-lineitem container to get configuration_id
                    parentContainer = rootItem.closest('.cart-item, .cart-lineitem');
                    configurationId = parentContainer && parentContainer.hasAttribute('data-configuration-id') ? parentContainer.getAttribute('data-configuration-id') : null; // Get item type from the rootItem
                    itemType = rootItem.getAttribute('data-item-type') || 'plant'; // Sub-items in the DOM only carry data-line-item-key — `data-configuration-id`
                    // lives on the parent container. To cascade qty changes across the whole
                    // configuration group, walk inside the parent container.
                    updateItems = configurationId && parentContainer ? parentContainer.querySelectorAll('[data-line-item-key]') : [rootItem];
                    updateItems.forEach(function (item) {
                      item.querySelectorAll('.js-cart-item-quantity button').forEach(function (btn) {
                        return btn.disabled = true;
                      });
                      item.classList.add('is-updating');
                    });

                    // Stel updates object in
                    updates = {};
                    removedSubItems = {
                      potting: false,
                      card: false
                    };
                    removedByType = ''; // If quantity becomes 0, handle sub-item removal based on item type
                    if (newQuantity <= 0 && configurationId) {
                      // Add main item to updates
                      updates[key] = 0;
                      if (parentContainer) {
                        if (itemType === 'plant') {
                          // Plant removed - remove all sub-items (potting, card_service, addon)
                          pottingItem = parentContainer.querySelector('[data-item-type="potting"]');
                          if (pottingItem) {
                            pottingKey = pottingItem.getAttribute('data-line-item-key');
                            if (pottingKey && pottingKey !== key) {
                              updates[pottingKey] = 0;
                              removedSubItems.potting = true;
                              removedByType = 'plant';
                              pottingItem.classList.add('is-updating');
                            }
                          }

                          // Remove card_service item (postcard/kaartje)
                          cardItem = parentContainer.querySelector('[data-item-type="card_service"]');
                          if (cardItem) {
                            cardKey = cardItem.getAttribute('data-line-item-key');
                            if (cardKey && cardKey !== key) {
                              updates[cardKey] = 0;
                              removedSubItems.card = true;
                              removedByType = 'plant';
                              cardItem.classList.add('is-updating');
                            }
                          }

                          // Remove all addon items
                          addonItems = parentContainer.querySelectorAll('[data-item-type="addon"]');
                          addonItems.forEach(function (addonItem) {
                            var addonKey = addonItem.getAttribute('data-line-item-key');
                            if (addonKey && addonKey !== key) {
                              updates[addonKey] = 0;
                              addonItem.classList.add('is-updating');
                            }
                          });
                        } else if (itemType === 'pot') {
                          // Pot removed - remove potting service only
                          _pottingItem2 = parentContainer.querySelector('[data-item-type="potting"]');
                          if (_pottingItem2) {
                            _pottingKey2 = _pottingItem2.getAttribute('data-line-item-key');
                            if (_pottingKey2 && _pottingKey2 !== key) {
                              updates[_pottingKey2] = 0;
                              removedSubItems.potting = true;
                              removedByType = 'pot';
                              _pottingItem2.classList.add('is-updating');
                            }
                          }
                        }
                      }
                    } else {
                      // Normal quantity update - update all items with same configurationId
                      updateItems.forEach(function (item) {
                        var itemKey = item.getAttribute('data-line-item-key');
                        if (itemKey) {
                          updates[itemKey] = newQuantity;
                        }
                      });
                    }

                    // AJAX update
                    _context4.n = 1;
                    return fetch(window.Shopify.routes.root + 'cart/update.js', {
                      method: "POST",
                      headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                      },
                      body: JSON.stringify({
                        updates: updates
                      })
                    });
                  case 1:
                    response = _context4.v;
                    _context4.n = 2;
                    return response.json();
                  case 2:
                    data = _context4.v;
                    // update winkelwagen count
                    document.querySelectorAll('.js-cart-count').forEach(function (el) {
                      return el.textContent = data.item_count;
                    });

                    // Re-enable buttons
                    updateItems.forEach(function (item) {
                      item.classList.remove('is-updating');
                      item.querySelectorAll('.js-cart-item-quantity button').forEach(function (btn) {
                        return btn.disabled = false;
                      });
                    });

                    // Get New Cart object
                    _context4.n = 3;
                    return fetch(window.Shopify.routes.root + 'cart.js');
                  case 3:
                    res = _context4.v;
                    _context4.n = 4;
                    return res.json();
                  case 4:
                    cart = _context4.v;
                    _context4.n = 5;
                    return updateCart(cart);
                  case 5:
                    // Show notification if any sub-items were auto-removed
                    if (removedSubItems.potting || removedSubItems.card) {
                      showSubItemRemovedNotification(removedSubItems, removedByType);
                    }
                    document.dispatchEvent(new CustomEvent('lineitem:updated', {
                      detail: {
                        cart: cart
                      }
                    }));
                    (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.debounceReInitSliders)();
                  case 6:
                    return _context4.a(2);
                }
              }, _callee4);
            })), 500); // Wait 500ms after user stops typing
          case 1:
            return _context5.a(2);
        }
      }, _callee5);
    })));
  });
}
function showSubItemRemovedNotification(removedSubItems, removedByType) {
  // Remove any existing notifications first to prevent duplicates
  var existingNotifications = document.querySelectorAll('.cart-notification');
  existingNotifications.forEach(function (notification) {
    return notification.remove();
  });
  var messageText = '';

  // Check if both potting and card were removed
  if (removedSubItems.potting && removedSubItems.card) {
    var key = 'potting_and_card_removed_plant';
    if (window.cartTranslations && window.cartTranslations[key]) {
      messageText = window.cartTranslations[key];
      if (messageText && messageText.includes('Translation missing')) {
        messageText = '';
      }
    }
    if (!messageText) {
      messageText = 'Oppotten en kaartje verwijderd omdat plant verwijderd is';
    }
  } else if (removedSubItems.potting) {
    // Only potting was removed
    var _key = removedByType === 'plant' ? 'oppotten_removed_plant' : 'oppotten_removed_pot';
    if (window.cartTranslations && window.cartTranslations[_key]) {
      messageText = window.cartTranslations[_key];
      if (messageText && messageText.includes('Translation missing')) {
        messageText = '';
      }
    }
    if (!messageText) {
      messageText = removedByType === 'plant' ? 'Oppotten verwijderd omdat plant verwijderd is' : 'Oppotten verwijderd omdat pot verwijderd is';
    }
  } else if (removedSubItems.card) {
    // Only card was removed
    var _key2 = 'card_removed_plant';
    if (window.cartTranslations && window.cartTranslations[_key2]) {
      messageText = window.cartTranslations[_key2];
      if (messageText && messageText.includes('Translation missing')) {
        messageText = '';
      }
    }
    if (!messageText) {
      messageText = 'Kaartje verwijderd omdat plant verwijderd is';
    }
  }
  if (!messageText) return;

  // Create notification element
  var notification = document.createElement('div');
  notification.className = 'cart-notification bg-warning text-white p-2 rounded-2 mb-2';
  notification.style.cssText = 'position: fixed; top: 20px; right: 20px; z-index: 10000; max-width: 400px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); animation: slideIn 0.3s ease-out;';
  notification.innerHTML = "\n\t\t<div class=\"d-flex align-items-center gap-2\">\n\t\t\t<i class=\"fa-sharp fa-regular fa-circle-info\" style=\"font-size: 18px;\"></i>\n\t\t\t<span style=\"font-size: 14px; font-weight: 500;\">".concat(messageText, "</span>\n\t\t\t<button class=\"ms-auto bg-transparent border-0 text-white\" style=\"cursor: pointer; font-size: 18px; padding: 0; line-height: 1;\" onclick=\"this.parentElement.parentElement.remove()\">\n\t\t\t\t<i class=\"fa-sharp fa-regular fa-xmark\"></i>\n\t\t\t</button>\n\t\t</div>\n\t");

  // Add animation styles if not already present
  if (!document.getElementById('cart-notification-styles')) {
    var style = document.createElement('style');
    style.id = 'cart-notification-styles';
    style.textContent = "\n\t\t\t@keyframes slideIn {\n\t\t\t\tfrom {\n\t\t\t\t\ttransform: translateX(100%);\n\t\t\t\t\topacity: 0;\n\t\t\t\t}\n\t\t\t\tto {\n\t\t\t\t\ttransform: translateX(0);\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t\t@keyframes slideOut {\n\t\t\t\tfrom {\n\t\t\t\t\ttransform: translateX(0);\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t\tto {\n\t\t\t\t\ttransform: translateX(100%);\n\t\t\t\t\topacity: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t";
    document.head.appendChild(style);
  }

  // Add to body
  document.body.appendChild(notification);

  // Auto-remove after 5 seconds
  setTimeout(function () {
    notification.style.animation = 'slideOut 0.3s ease-out';
    setTimeout(function () {
      if (notification.parentElement) {
        notification.remove();
      }
    }, 300);
  }, 5000);
}
function addDeleteListeners() {
  // Remove old event listeners by using event delegation or cloning buttons
  document.querySelectorAll('.js-cart-item-delete__confirm').forEach(function (button) {
    // Clone button to remove all existing event listeners
    var newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);

    // Add event listener to the new button
    newButton.addEventListener('click', /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(e) {
        var rootItem, key, parentContainer, configurationId, itemType, updates, removedSubItems, removedByType, allSubItems, pottingItem, pottingKey, cardItem, cardKey, addonItems, _allSubItems, _pottingItem3, _pottingKey3, deleteOverlay, res, cart;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              e.stopPropagation(); // Prevent event bubbling
              // Find the closest element with data-line-item-key (could be sub-item or main item)
              rootItem = newButton.closest('[data-line-item-key]');
              key = rootItem.getAttribute('data-line-item-key'); // If button has data-line-item-key attribute (for sub-items), use that
              if (newButton.hasAttribute('data-line-item-key')) {
                key = newButton.getAttribute('data-line-item-key');
                // Find the sub-item element (not the delete button itself) - look for elements with data-item-type
                rootItem = document.querySelector(".cart-item__sub-item[data-line-item-key=\"".concat(key, "\"], .cart-lineitem__sub-item[data-line-item-key=\"").concat(key, "\"], .cart-item__content[data-line-item-key=\"").concat(key, "\"], .cart-lineitem__content[data-line-item-key=\"").concat(key, "\"]"));
                // Fallback to any element with the key if specific selectors don't match
                if (!rootItem) {
                  rootItem = document.querySelector("[data-line-item-key=\"".concat(key, "\"]"));
                }
              }

              // Find parent cart-item/cart-lineitem container to get configuration_id
              parentContainer = rootItem.closest('.cart-item, .cart-lineitem');
              configurationId = parentContainer && parentContainer.hasAttribute('data-configuration-id') ? parentContainer.getAttribute('data-configuration-id') : null; // Get item type from the rootItem
              itemType = rootItem.getAttribute('data-item-type') || 'plant'; // Zet de updates object op basis van het configurationId en item type
              updates = {};
              removedSubItems = {
                potting: false,
                card: false
              };
              removedByType = ''; // Voeg het item zelf toe aan updates
              updates[key] = 0;

              // Als het item een configurationId heeft en het is een plant (main item), verwijder alle sub-items (potting, card_service, addon)
              if (configurationId && itemType === 'plant') {
                if (parentContainer) {
                  // Verwijder potting item
                  allSubItems = parentContainer.querySelectorAll('.cart-item__sub-item, .cart-lineitem__sub-item');
                  pottingItem = parentContainer.querySelector('[data-item-type="potting"]'); // Fallback: find potting item by title if not found by data-item-type
                  if (!pottingItem) {
                    allSubItems.forEach(function (item) {
                      var subItemType = item.getAttribute('data-item-type');
                      var titleEl = item.querySelector('.cart-item__title a, .cart-lineitem__title a');
                      var title = titleEl ? titleEl.textContent.toLowerCase() : '';
                      if (title.includes('oppot') || title.includes('potting') || subItemType === 'potting') {
                        pottingItem = item;
                      }
                    });
                  }
                  if (pottingItem) {
                    pottingKey = pottingItem.getAttribute('data-line-item-key');
                    if (pottingKey && pottingKey !== key) {
                      updates[pottingKey] = 0;
                      removedSubItems.potting = true;
                      removedByType = 'plant';
                      pottingItem.classList.add('is-updating');
                    }
                  }

                  // Verwijder card_service item (postcard/kaartje)
                  cardItem = parentContainer.querySelector('[data-item-type="card_service"]');
                  if (cardItem) {
                    cardKey = cardItem.getAttribute('data-line-item-key');
                    if (cardKey && cardKey !== key) {
                      updates[cardKey] = 0;
                      removedSubItems.card = true;
                      removedByType = 'plant';
                      cardItem.classList.add('is-updating');
                    }
                  }

                  // Verwijder alle addon items
                  addonItems = parentContainer.querySelectorAll('[data-item-type="addon"]');
                  addonItems.forEach(function (addonItem) {
                    var addonKey = addonItem.getAttribute('data-line-item-key');
                    if (addonKey && addonKey !== key) {
                      updates[addonKey] = 0;
                      addonItem.classList.add('is-updating');
                    }
                  });
                }
              }

              // Als het item een pot is, verwijder ook oppotten (maar niet de plant of andere items)
              console.log('Delete item debug:', {
                configurationId: configurationId,
                itemType: itemType,
                key: key,
                rootItem: rootItem,
                parentContainer: parentContainer
              });
              if (configurationId && itemType === 'pot') {
                if (parentContainer) {
                  // Log all sub-items to debug
                  _allSubItems = parentContainer.querySelectorAll('.cart-item__sub-item, .cart-lineitem__sub-item');
                  console.log('All sub-items found:', _allSubItems.length);
                  _allSubItems.forEach(function (item, index) {
                    console.log("Sub-item ".concat(index, ":"), item.getAttribute('data-item-type'), item.getAttribute('data-line-item-key'));
                  });

                  // Try finding potting item by data-item-type="potting"
                  _pottingItem3 = parentContainer.querySelector('[data-item-type="potting"]');
                  console.log('Looking for potting item in parentContainer:', _pottingItem3);

                  // If not found, try finding by checking if item title contains "oppot" or "potting"
                  if (!_pottingItem3) {
                    _allSubItems.forEach(function (item) {
                      var itemType = item.getAttribute('data-item-type');
                      var titleEl = item.querySelector('.cart-item__title a, .cart-lineitem__title a');
                      var title = titleEl ? titleEl.textContent.toLowerCase() : '';
                      console.log('Checking item:', {
                        itemType: itemType,
                        title: title
                      });
                      if (title.includes('oppot') || title.includes('potting') || itemType === 'potting') {
                        _pottingItem3 = item;
                      }
                    });
                  }
                  if (_pottingItem3) {
                    _pottingKey3 = _pottingItem3.getAttribute('data-line-item-key');
                    console.log('Potting key found:', _pottingKey3);
                    if (_pottingKey3 && _pottingKey3 !== key) {
                      updates[_pottingKey3] = 0;
                      removedSubItems.potting = true;
                      removedByType = 'pot';
                      _pottingItem3.classList.add('is-updating');
                      console.log('Potting item added to updates for removal');
                    }
                  }
                }
              }

              // Find the delete overlay (could be a sibling or parent)
              deleteOverlay = newButton.closest('.cart-item-delete') || rootItem.querySelector('.cart-item-delete');
              if (deleteOverlay) {
                deleteOverlay.classList.remove('is-active');
              }

              // Voeg de is-updating class toe aan het item
              rootItem.classList.add('is-updating');

              // AJAX update voor de geselecteerde items
              _context6.n = 1;
              return fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  updates: updates
                })
              }).then(function (response) {
                return response.json();
              }).then(function (data) {
                // Update het winkelwagenaantal
                document.querySelectorAll('.js-cart-count').forEach(function (el) {
                  el.textContent = data.item_count;
                });
              });
            case 1:
              // Verwijder de is-updating class van de geselecteerde items
              // Remove is-updating from all items that were in the updates object
              Object.keys(updates).forEach(function (itemKey) {
                var itemElement = document.querySelector("[data-line-item-key=\"".concat(itemKey, "\"]"));
                if (itemElement) {
                  itemElement.classList.remove('is-updating');
                }
              });
              _context6.n = 2;
              return fetch(window.Shopify.routes.root + 'cart.js');
            case 2:
              res = _context6.v;
              _context6.n = 3;
              return res.json();
            case 3:
              cart = _context6.v;
              _context6.n = 4;
              return updateCart(cart);
            case 4:
              // Show notification if any sub-items were auto-removed
              if (removedSubItems.potting || removedSubItems.card) {
                showSubItemRemovedNotification(removedSubItems, removedByType);
              }
              (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.debounceReInitSliders)();
            case 5:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }());
  });
}
function addEventListenersToCart() {
  addQuantityUpdateListeners();
  addDeleteListeners();
}

// Initial call to add event listeners
addEventListenersToCart();

// Init related add to cart
initRelatedAddToCart();

// js-cart-item-delete-toggle
$(document).on("click", ".js-cart-item-delete-toggle", function (e) {
  // Find the closest parent container (cart-item__content, cart-item__sub-item, etc.)
  var container = $(this).closest('.cart-item__content, .cart-item__sub-item, .cart-lineitem__content, .cart-lineitem__sub-item');
  // Find the next sibling delete overlay
  var deleteOverlay = container.next('.cart-item-delete');
  if (deleteOverlay.length) {
    deleteOverlay.addClass('is-active');
  } else {
    // Fallback to old method for backwards compatibility
    $(this).parent().parent().parent().next('.cart-item-delete').addClass('is-active');
  }
  addEventListenersToCart();
});
$(document).on("click", ".js-cart-item-delete__close", function (e) {
  // Find the closest delete overlay and remove active class
  $(this).closest('.cart-item-delete').removeClass('is-active');
  addEventListenersToCart();
});

/**
 * Handle product card add-to-cart buttons
 * Checks if the variant already exists in the cart and increments quantity if so
 */
document.body.addEventListener('click', /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(event) {
    var button, variantId, cartRes, cartData, existingItem, addData, changeRes, addRes, minicartHtml, newBox;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          button = event.target.closest('.js-block-add-to-cart');
          if (button) {
            _context7.n = 1;
            break;
          }
          return _context7.a(2);
        case 1:
          event.preventDefault();
          event.stopPropagation();
          variantId = button.getAttribute('data-variant-id');
          if (variantId) {
            _context7.n = 2;
            break;
          }
          return _context7.a(2);
        case 2:
          button.disabled = true;

          // Open drawer immediately + show placeholder for instant UX feedback.
          // Title + image come from the product card the button lives in.
          (0,_functions__WEBPACK_IMPORTED_MODULE_0__.openMiniCart)();
          (0,_functions__WEBPACK_IMPORTED_MODULE_0__.lockHTML)();
          injectOptimisticCartPlaceholder(button);

          // Check if variant already exists in cart as a STANDALONE line.
          // Skip lines tied to a configuration group (Plant+Pot+Oppotten bundles)
          // so we don't accidentally bump the qty of a bundle when adding the bare
          // product from a card.
          _context7.n = 3;
          return fetch(window.Shopify.routes.root + 'cart.js');
        case 3:
          cartRes = _context7.v;
          _context7.n = 4;
          return cartRes.json();
        case 4:
          cartData = _context7.v;
          existingItem = cartData.items.find(function (item) {
            var _item$properties2;
            return item.variant_id === parseInt(variantId) && !((_item$properties2 = item.properties) !== null && _item$properties2 !== void 0 && _item$properties2._configuration_id);
          });
          if (!existingItem) {
            _context7.n = 7;
            break;
          }
          _context7.n = 5;
          return fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: "POST",
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              line: cartData.items.indexOf(existingItem) + 1,
              quantity: existingItem.quantity + 1,
              sections: ['base-minicart']
            })
          });
        case 5:
          changeRes = _context7.v;
          _context7.n = 6;
          return changeRes.json();
        case 6:
          addData = _context7.v;
          _context7.n = 10;
          break;
        case 7:
          _context7.n = 8;
          return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: "POST",
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: parseInt(variantId),
                quantity: 1
              }],
              sections: ['base-minicart']
            })
          });
        case 8:
          addRes = _context7.v;
          _context7.n = 9;
          return addRes.json();
        case 9:
          addData = _context7.v;
        case 10:
          if (!(addData.sections && addData.sections['base-minicart'])) {
            _context7.n = 11;
            break;
          }
          minicartHtml = document.createElement('div');
          minicartHtml.innerHTML = addData.sections['base-minicart'];
          newBox = minicartHtml.querySelector('.drawer-cart');
          if (newBox) {
            document.querySelector('.drawer-cart').innerHTML = newBox.innerHTML;
            requestAnimationFrame(function () {
              addEventListenersToCart();
              initRelatedAddToCart();
              (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.reInitCartSliders)();
            });
          }
          _context7.n = 12;
          break;
        case 11:
          _context7.n = 12;
          return refreshCartSections();
        case 12:
          // Update cart count
          document.querySelector('.js-cart-count').classList.add('header-main__cart--hasitems');

          // Update count + cart page + gifts in background
          fetch(window.Shopify.routes.root + 'cart.js').then(function (r) {
            return r.json();
          }).then(function (cart) {
            document.querySelectorAll('.js-cart-count').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            new Promise(function (resolve) {
              window.dispatchEvent(new CustomEvent('cart:updated', {
                detail: {
                  action: 'add',
                  cart: cart,
                  done: resolve
                }
              }));
            }).then(function () {
              return refreshCartSections();
            });
          });

          // Update cart page if on cart page
          if (document.querySelector('.js-cart')) {
            refreshCartSections();
          }
          updateMobileCartBar();
          (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.debounceReInitSliders)();
          button.disabled = false;
        case 13:
          return _context7.a(2);
      }
    }, _callee7);
  }));
  return function (_x5) {
    return _ref7.apply(this, arguments);
  };
}());

/**
 * Doofinder search layer: "Add to cart" button.
 *
 * Doofinder's Shopify app already adds the item to the cart itself — it
 * also fires the `doofinder.cart.add` event so the theme can refresh its
 * UI. We do NOT call /cart/add.js here (that caused a double-add). We just
 * re-render the minicart section, open the drawer, bump the count, and
 * show a confirmation toast.
 *
 * Concurrency note: a small in-flight guard prevents two near-simultaneous
 * Doofinder events from spawning two minicart re-renders.
 */
var doofinderRefreshInFlight = false;
document.addEventListener('doofinder.cart.add', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
  var beforeCart, beforeCount, cart, startedAt, _document$querySelect;
  return _regenerator().w(function (_context8) {
    while (1) switch (_context8.p = _context8.n) {
      case 0:
        if (!doofinderRefreshInFlight) {
          _context8.n = 1;
          break;
        }
        return _context8.a(2);
      case 1:
        doofinderRefreshInFlight = true;
        _context8.p = 2;
        (0,_functions__WEBPACK_IMPORTED_MODULE_0__.openMiniCart)();
        (0,_functions__WEBPACK_IMPORTED_MODULE_0__.lockHTML)();

        // Doofinder's add runs server-side via its own fetch — there's no
        // public "added" callback. Snapshot the cart's item_count first,
        // then poll until it increases (or timeout) so the refresh below
        // reads the new cart, not the stale one.
        _context8.n = 3;
        return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) {
          return r.json();
        });
      case 3:
        beforeCart = _context8.v;
        beforeCount = beforeCart.item_count;
        cart = beforeCart;
        startedAt = Date.now();
      case 4:
        if (!(Date.now() - startedAt < 4000)) {
          _context8.n = 8;
          break;
        }
        _context8.n = 5;
        return new Promise(function (r) {
          return setTimeout(r, 150);
        });
      case 5:
        _context8.n = 6;
        return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) {
          return r.json();
        });
      case 6:
        cart = _context8.v;
        if (!(cart.item_count > beforeCount)) {
          _context8.n = 7;
          break;
        }
        return _context8.a(3, 8);
      case 7:
        _context8.n = 4;
        break;
      case 8:
        _context8.n = 9;
        return refreshCartSections();
      case 9:
        document.querySelectorAll('.js-cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        if (cart.item_count > 0) {
          (_document$querySelect = document.querySelector('.js-cart-count')) === null || _document$querySelect === void 0 || _document$querySelect.classList.add('header-main__cart--hasitems');
        }
        window.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            action: 'add',
            cart: cart
          }
        }));
        updateMobileCartBar();
        (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.debounceReInitSliders)();
        showDoofinderToast('Toegevoegd aan winkelwagen', 'success');
      case 10:
        _context8.p = 10;
        doofinderRefreshInFlight = false;
        return _context8.f(10);
      case 11:
        return _context8.a(2);
    }
  }, _callee8, null, [[2,, 10, 11]]);
})));

/**
 * Toast feedback. The Doofinder search layer overlays the page, so the
 * minicart drawer can be hidden behind it — the toast guarantees visible
 * feedback regardless of z-index.
 */
function showDoofinderToast(message, type) {
  document.querySelectorAll('.js-doofinder-toast').forEach(function (t) {
    return t.remove();
  });
  var bg = type === 'error' ? '#dc3545' : '#198754';
  var icon = type === 'error' ? '<i class="fa-sharp fa-regular fa-circle-exclamation"></i>' : '<i class="fa-sharp fa-regular fa-circle-check"></i>';
  var toast = document.createElement('div');
  toast.className = 'js-doofinder-toast';
  toast.style.cssText = "position:fixed;top:20px;right:20px;z-index:2147483647;background:".concat(bg, ";color:#fff;padding:12px 18px;border-radius:6px;box-shadow:0 4px 12px rgba(0,0,0,.2);font-size:14px;font-weight:500;display:flex;align-items:center;gap:10px;animation:dfToastIn .25s ease-out;");
  toast.innerHTML = "".concat(icon, "<span>").concat(message, "</span>");
  if (!document.getElementById('df-toast-styles')) {
    var style = document.createElement('style');
    style.id = 'df-toast-styles';
    style.textContent = '@keyframes dfToastIn{from{transform:translateX(110%);opacity:0}to{transform:translateX(0);opacity:1}}';
    document.head.appendChild(style);
  }
  document.body.appendChild(toast);
  setTimeout(function () {
    toast.style.transition = 'opacity .25s, transform .25s';
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(110%)';
    setTimeout(function () {
      return toast.remove();
    }, 250);
  }, 2500);
}


/***/ }),

/***/ "./src/js/find-my-pot.js":
/*!*******************************!*\
  !*** ./src/js/find-my-pot.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PotFinder: () => (/* binding */ PotFinder),
/* harmony export */   showQuickView: () => (/* binding */ showQuickView)
/* harmony export */ });
/* harmony import */ var _custom_add_to_cart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./custom-add-to-cart */ "./src/js/custom-add-to-cart.js");
/* harmony import */ var _sliders__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./sliders */ "./src/js/sliders.js");
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
/* provided dependency */ var __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "../../node_modules/.pnpm/jquery@3.7.1/node_modules/jquery/dist/jquery.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "../../node_modules/.pnpm/jquery@3.7.1/node_modules/jquery/dist/jquery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = __webpack_require__(/*! jquery */ "../../node_modules/.pnpm/jquery@3.7.1/node_modules/jquery/dist/jquery.js"),
  fn = _require.fn,
  type = _require.type;



window.$ = __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "../../node_modules/.pnpm/jquery@3.7.1/node_modules/jquery/dist/jquery.js");
var PotFinder = /*#__PURE__*/function () {
  function PotFinder() {
    _classCallCheck(this, PotFinder);
    // Define the selectors
    this.plantData = ".js-plant-configuration";
    this.potSelector = ".js-select-pot";
    this.mediumSelector = ".js-oppot-medium";

    // Hold the selected pot
    this.selectedPot = null;

    // Oppotten state.
    // preferredMedium holds a medium the customer picked themselves. Its non-null-ness IS the
    // "manual choice" flag: once set we never override it, not even when a change of decorative
    // pot temporarily hides that medium. It is only cleared by a page load.
    this.preferredMedium = null;
    this.currentSize = null;
    this.activeMedium = null;
    this.visibleMediumCount = 0;
    this.oppottenData = undefined; // parse-once cache; null means "no data on this page"

    // Define an add-to-cart array
    this.addToCartObject = [];

    // Quantity selectors
    this.quantityInputSelector = ".cart-item-quantity__input";
    this.minusButtonSelector = ".cart-item-quantity__btns.is-min";
    this.plusButtonSelector = ".cart-item-quantity__btns.is-plus";

    // Add to cart btn
    this.addToCartButton = ".js-add-to-cart";

    // Initialize the find-my-pot logic
    this.init();
  }

  /**
   * Init function to setup the find-my-pot logic
   */
  return _createClass(PotFinder, [{
    key: "init",
    value: function init() {
      this.addEventListeners(); // Add event listeners
      // Disable potting addon checkbox on init (no pot selected yet)
      this.disablePottingAddonOnInit();
      // Initialize price summary
      this.updateTotalConfigurationPrice();
    }

    /**
     * Get the potting addon checkbox
     * Uses the specific class added by Liquid for potting addons
     */
  }, {
    key: "getPottingAddonCheckbox",
    value: function getPottingAddonCheckbox() {
      // Primary: use the specific class added by Liquid template
      var checkbox = $('.js-potting-addon-checkbox');
      if (checkbox.length) return checkbox;

      // Fallback 1: find by addon type "potting"
      checkbox = $('.js-addon-checkbox[data-addon-type="potting"]');
      if (checkbox.length) return checkbox;

      // Fallback 2: find by addon name containing "oppotten" (case-insensitive)
      var foundCheckbox = null;
      $('.js-addon-checkbox').each(function () {
        var addonName = ($(this).data('addon-name') || '').toString().toLowerCase();
        if (addonName.includes('oppotten') || addonName.includes('oppot')) {
          foundCheckbox = $(this);
          return false; // break the loop
        }
      });
      return foundCheckbox ? foundCheckbox : $();
    }

    /**
     * Disable the potting addon checkbox on initialization
     * (it should only be enabled when a pot is selected)
     */
  }, {
    key: "disablePottingAddonOnInit",
    value: function disablePottingAddonOnInit() {
      var pottingAddonCheckbox = this.getPottingAddonCheckbox();
      if (pottingAddonCheckbox.length && !this.selectedPot) {
        pottingAddonCheckbox.prop("disabled", true);
      }
    }

    /**
     * Add event listeners to the necessary elements
     */
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this = this;
      // Delegated so pot cards loaded later (sections/pot-options.liquid, for pot collections
      // beyond Shopify's 50-product Liquid limit) are wired up regardless of load order.
      $(document).on("click", this.potSelector, this.handlePotChange.bind(this));
      // Oppotten medium tiles. Click, not change: a radio fires no change event when it is
      // already selected, and clicking the active tile has to switch potting back off.
      $(document).on("click", this.mediumSelector, this.handleMediumClick.bind(this));
      $(document).on("change", ".js-potting-addon-checkbox", this.syncMediumSelection.bind(this));
      // Listen for card checkbox changes
      $(".js-card-checkbox").on("change", this.updateTotalConfigurationPrice.bind(this));
      // Listen for add-on checkbox changes
      $(document).on("change", ".js-addon-checkbox", this.updateTotalConfigurationPrice.bind(this));
      // Listen for upsell checkbox changes
      $(document).on("change", ".js-upsell-checkbox", this.updateTotalConfigurationPrice.bind(this));

      // Quantity selectors
      $(this.minusButtonSelector).on("click", this.updateQuantity.bind(this, -1));
      $(this.plusButtonSelector).on("click", this.updateQuantity.bind(this, 1));

      // Price summary expand/collapse (starts collapsed)
      $(".product-price-summary__header").on("click", function () {
        var $header = $(this);
        var breakdown = $header.siblings(".product-price-summary__breakdown");
        var arrow = $header.find(".js-price-summary-arrow");
        var isExpanded = breakdown.is(":visible");
        if (isExpanded) {
          breakdown.slideUp(300);
          arrow.css("transform", "rotate(0deg)");
        } else {
          breakdown.slideDown(300);
          arrow.css("transform", "rotate(180deg)");
        }
      });
      $(this.quantityInputSelector).on("input", function (fn) {
        var value = $(_this.quantityInputSelector).val();
        if (value !== '' && !/^\d+$/.test(value)) {
          $(_this.quantityInputSelector).val(value.replace(/\D/g, ''));
        }
      });
      $(this.quantityInputSelector).on("blur", function () {
        var value = $(_this.quantityInputSelector).val();
        var quantity = parseInt(value, 10);
        if (value === '' || isNaN(quantity) || quantity < 1) {
          $(_this.quantityInputSelector).val(1);
        }
        _this.updateTotalConfigurationPrice();
      });

      // Add to cart button
      $(this.addToCartButton).on("click", this.addToCart.bind(this));
    }

    /**
     * Handle the pot change event, we need to do several things here:
     * 1. Check if the current "radio" pot input is selected, if so deselect it, else select it... Since radio inputs are not deselected by default
     * 2. Get the selected pot diameter and check if that minimum diameter is available in the potting options
     * 3. Handle the potting options
     * 4. Update the total configuration price
     * 5. Create the add to cart object
     *
     * @param {Event} event
     */
  }, {
    key: "handlePotChange",
    value: function handlePotChange(event) {
      event.preventDefault(); // Prevent the default event
      var selectedPot = $(event.currentTarget).parent().find("input"); // Get selected jQuery object
      var isNoPotOption = selectedPot.attr("id") === "pot-none";

      // Step 1: Handle the checked state of the radio input
      if (isNoPotOption) {
        // "No pot" option: always select it and deselect others
        $('input[name="addExtraPot"]').prop("checked", false);
        selectedPot.prop("checked", true);
        this.selectedPot = null;
      } else {
        // Regular pot option
        if (selectedPot.is(":checked")) {
          // Deselect this pot and select "no pot" instead
          selectedPot.prop("checked", false);
          $("#pot-none").prop("checked", true);
          this.selectedPot = null;
        } else {
          // Select this pot
          selectedPot.prop("checked", true);
          this.selectedPot = selectedPot;
        }
      }

      // Fill the data of the quickview info (only for actual pots, not "no pot"):
      if (!isNoPotOption && this.selectedPot) {
        var quickViewData = $(event.currentTarget).parent().find(".js-quickview-toggle");
        $(".js-quickview__title").html(quickViewData.data("title"));
        $(".js-quickview__image").attr("src", quickViewData.data("image"));

        // Populate measurements and materials
        var potDiameter = quickViewData.data("pot-diameter") || quickViewData.data("pot-opening");
        var potHeight = quickViewData.data("pot-height");
        var potMaterial = quickViewData.data("pot-material");

        // Show diameter or N/A
        var diameterText = potDiameter ? potDiameter + " cm" : "N/A";
        $(".js-quickview__diameter span.fw-semibold").text(diameterText);

        // Show height if available, otherwise show N/A
        if (potHeight && potHeight !== "" && potHeight !== "0" && potHeight !== 0) {
          $(".js-quickview__height span.fw-semibold").text(potHeight + " cm");
        } else {
          $(".js-quickview__height span.fw-semibold").text("N/A");
        }
        var price = quickViewData.data("price");
        var priceString = price.toString();
        var modifiedPrice = priceString.slice(0, -2) + "<span>" + priceString.slice(-2) + "</span>";
        $(".js-quickview__price").html(modifiedPrice);
      }

      // Show/hide quick view detail
      if (this.selectedPot) $(".js-quick-view-detail").removeClass("d-none");else $(".js-quick-view-detail").addClass("d-none");

      // Step 2: Handle the potting options
      this.handlePottingOptions();

      // Step 3: Update the total configuration price
      this.updateTotalConfigurationPrice();
    }

    /**
     * Handle the potting options
     *
     * The potting add-on is only offered once a decorative pot is selected: the potting size,
     * price and explanation text are all derived from that pot's outer diameter.
     */
  }, {
    key: "handlePottingOptions",
    value: function handlePottingOptions() {
      // Get the potting addon checkbox using the helper method
      var pottingAddonCheckbox = this.getPottingAddonCheckbox();
      if (!pottingAddonCheckbox.length) return;

      // Get the parent container for the potting addon
      var pottingAddonContainer = pottingAddonCheckbox.closest('.product-addon-option--potting');

      // The pot's outer diameter (custom.pot_diameter), set on the pot card in
      // snippets/pot-option-card.liquid. NaN when the pot carries no usable measurement at all.
      var potDiameter = this.getSelectedPotDiameter();

      // Resolved before anything is shown: a pot wider than every potting size this market sells
      // has no size, and must end up in the withdrawal branch below rather than in an add-on that
      // stays visible with the variant of the previous pot.
      var targetSize = this.selectedPot && potDiameter > 0 ? this.resolveTargetSize(potDiameter) : null;
      if (targetSize !== null) {
        // Show the potting addon container and enable checkbox
        if (pottingAddonContainer.length) {
          pottingAddonContainer.slideDown(200);
        }
        pottingAddonCheckbox.prop("disabled", false);
        this.updateOppottenVariant(potDiameter, pottingAddonCheckbox);
        return;
      }

      // No pot, a pot without an outer diameter, or a pot wider than every available potting size:
      // we cannot resolve a size that fits, so offering the add-on would ship whatever variant was
      // resolved for the previous pot — or a size the pot cannot take.
      pottingAddonCheckbox.prop("checked", false).prop("disabled", true);
      // Trigger change event to update any dependent UI (like description wrapper)
      pottingAddonCheckbox.trigger("change");
      if (pottingAddonContainer.length) {
        pottingAddonContainer.slideUp(200);
      }
      this.currentSize = null;
      this.activeMedium = null;
      this.visibleMediumCount = 0;
      $('.js-oppot-medium-wrapper').hide();
      $('.js-oppot-uitleg').attr('hidden', true);
    }

    /**
     * Read the oppotten variant data emitted by snippets/oppotten-data.liquid.
     * Parsed once and cached; null when this page has no potting product.
     *
     * @returns {Object|null}
     */
  }, {
    key: "getOppottenData",
    value: function getOppottenData() {
      if (this.oppottenData !== undefined) return this.oppottenData;
      var el = document.getElementById('oppotten-data');
      if (!el) {
        this.oppottenData = null;
        return this.oppottenData;
      }
      try {
        this.oppottenData = JSON.parse(el.textContent);
      } catch (error) {
        console.warn('[oppotten] could not parse variant data', error);
        this.oppottenData = null;
      }
      return this.oppottenData;
    }

    /**
     * Read the measurement that drives the potting size: the decorative pot's OUTER DIAMETER.
     *
     * The potting size has to match the pot the customer sees, and the transport route hangs
     * off that same diameter — a pot is boxable or it is not, regardless of how wide its
     * opening happens to be.
     *
     * Falls back to the inner opening for the pots with no outer diameter filled in. That
     * fallback is deliberately unchanged: those pots keep resolving exactly the size they
     * resolved before this fix, rather than losing the potting add-on outright.
     *
     * @returns {number} The diameter in cm, or NaN when the pot carries no usable measurement
     */
  }, {
    key: "getSelectedPotDiameter",
    value: function getSelectedPotDiameter() {
      if (!this.selectedPot) return NaN;
      var diameter = parseFloat(this.selectedPot.data("diameter"));
      if (diameter > 0) return diameter;
      return parseFloat(this.selectedPot.data("opening"));
    }

    /**
     * Resolve the potting size for a decorative pot: the SMALLEST size that is not smaller than
     * the pot's OUTER DIAMETER (round UP), or null for a pot wider than every available size.
     *
     * Round UP, never down: the inner pot has to physically fit inside the decorative pot, so a
     * size below the outer diameter is not a near miss but an unusable one. A 24 cm pot therefore
     * takes size 25, not 20, and a 33 cm pot takes 35, not 30.
     *
     * The box limit falls out of this rule rather than needing its own clamp. Pots ship in a box
     * up to 30 cm and on a pallet above it, and the sizes carry that route in their SKU. Because
     * a resolved size is never below the pot's diameter, a pot over 30 cm can never land on a
     * box size: on the current axis a 31 cm pot lands on 35, the next size on offer. No boundary
     * value is written out here — it follows from the sizes the potting product actually sells.
     *
     * Resolved across the union of sizes of ALL media, not per medium: the size (and therefore the
     * explanation text) must not shift when the customer switches medium. A medium with no variant
     * at this size hides its tile instead.
     *
     * @param {number} potDiameter - The outer diameter of the selected decorative pot
     * @returns {number|null}
     */
  }, {
    key: "resolveTargetSize",
    value: function resolveTargetSize(potDiameter) {
      var data = this.getOppottenData();
      if (!data) return null;
      var sizes = _toConsumableArray(new Set(data.variants.filter(function (variant) {
        return variant.available && variant.size > 0;
      }).map(function (variant) {
        return variant.size;
      }))).sort(function (a, b) {
        return a - b;
      });
      if (!sizes.length) return null;

      // No size big enough: null, never the largest size. The axis differs per market because
      // potting above 30 cm cannot be shipped everywhere (FR, DK, SE, ES and IT stop at 30), and
      // that availability already arrives per market in #oppotten-data. Substituting a smaller
      // size sells a service that physically cannot be performed — ORD73314, a D35 pot with
      // size-30 potting in Denmark. The caller withdraws the add-on instead.
      var fitting = sizes.find(function (size) {
        return size >= potDiameter;
      });
      return fitting !== undefined ? fitting : null;
    }

    /**
     * Get the media that have an available variant at the given size.
     *
     * @param {number} size
     * @returns {Array<{value: string, variant: Object}>}
     */
  }, {
    key: "getMediaAtSize",
    value: function getMediaAtSize(size) {
      var data = this.getOppottenData();
      if (!data || !data.media.length) return [];
      return data.media.map(function (medium) {
        return {
          value: medium.value,
          variant: data.variants.find(function (variant) {
            return variant.medium === medium.value && variant.size === size && variant.available;
          })
        };
      }).filter(function (candidate) {
        return candidate.variant;
      });
    }

    /**
     * Pick the medium to use: a manual choice always wins, otherwise the cheapest at this size.
     *
     * @param {Array} candidates - Output of getMediaAtSize()
     * @returns {Object|null}
     */
  }, {
    key: "resolveMedium",
    value: function resolveMedium(candidates) {
      var _this2 = this;
      if (!candidates.length) return null;
      if (this.preferredMedium) {
        var preferred = candidates.find(function (candidate) {
          return candidate.value === _this2.preferredMedium;
        });
        if (preferred) return preferred;
        // The customer's medium has no variant at this size. Keep remembering it (its tile is
        // hidden below) so it comes back the moment they pick a pot where it exists again.
      }
      return candidates.reduce(function (cheapest, candidate) {
        return candidate.variant.price < cheapest.variant.price ? candidate : cheapest;
      });
    }

    /**
     * Update the oppotten variant based on the selected pot's outer diameter.
     *
     * @param {number} potDiameter - The outer diameter of the selected pot
     * @param {jQuery} checkbox - The potting addon checkbox element
     */
  }, {
    key: "updateOppottenVariant",
    value: function updateOppottenVariant(potDiameter, checkbox) {
      var data = this.getOppottenData();
      if (!data || !data.variants.length) return;
      var size = this.resolveTargetSize(potDiameter);
      if (size === null) return;
      var candidates = this.getMediaAtSize(size);
      var chosen = this.resolveMedium(candidates);

      // Products without a medium axis (and any degenerate data) fall through to a plain
      // round-down over every variant, which is the whole behaviour for single-medium products.
      var variant = chosen ? chosen.variant : null;
      if (!variant) {
        var pool = data.variants.filter(function (candidate) {
          return candidate.available && candidate.size === size;
        }).sort(function (a, b) {
          return a.price - b.price;
        });
        variant = pool[0] || data.variants.find(function (candidate) {
          return candidate.size === size;
        }) || data.variants[0];
      }
      if (!variant) return;
      this.currentSize = size;
      this.activeMedium = chosen ? chosen.value : null;
      this.renderMediumTiles(candidates);
      this.renderOppotExplanation(variant.group);
      this.applyOppottenVariant(variant, data.product_id, checkbox);
    }

    /**
     * Write the resolved variant onto the potting addon checkbox, which is what
     * getAddonServicesData() reads when building the cart line.
     *
     * @param {Object} variant
     * @param {number} productId
     * @param {jQuery} checkbox
     */
  }, {
    key: "applyOppottenVariant",
    value: function applyOppottenVariant(variant, productId, checkbox) {
      checkbox.val(variant.id);
      checkbox.data('product-id', productId);
      checkbox.attr('data-product-id', productId);
      checkbox.data('addon-price', variant.price);
      checkbox.attr('data-addon-price', variant.price);

      // Update price display
      var priceDisplay = checkbox.closest('.product-addon-option').find('.js-addon-price-display');
      if (priceDisplay.length) {
        var formattedPrice = this.formatPriceForDisplay(variant.price);
        priceDisplay.html('+' + formattedPrice);
      }
    }

    /**
     * Show the tiles for the media available at the current size and check the active one.
     *
     * Only toggles visibility and the checked state — the markup is never rebuilt, which is what
     * lets a manual choice survive a change of decorative pot.
     *
     * @param {Array} candidates - Output of getMediaAtSize()
     */
  }, {
    key: "renderMediumTiles",
    value: function renderMediumTiles(candidates) {
      var wrapper = $('.js-oppot-medium-wrapper');
      if (!wrapper.length) return;
      var visible = candidates.map(function (candidate) {
        return candidate.value;
      });

      // Photo per medium AT THE CURRENT SIZE. Every size has its own variant image, so the
      // tiles have to follow the resolved size instead of keeping the one Liquid rendered.
      var imageByMedium = {};
      candidates.forEach(function (candidate) {
        if (candidate.variant && candidate.variant.image) {
          imageByMedium[candidate.value] = candidate.variant.image;
        }
      });

      // attr, not data: jQuery's data cache coerces values, and a medium is always a string
      wrapper.find('.js-oppot-medium-tile').each(function () {
        var medium = $(this).attr('data-medium');
        $(this).toggle(visible.indexOf(medium) !== -1);
        var image = imageByMedium[medium];
        if (image) {
          var img = $(this).find('.js-oppot-medium-image');
          if (img.length && img.attr('src') !== image) img.attr('src', image);
        }
      });
      this.visibleMediumCount = visible.length;
      this.refreshMediumTilesVisibility();
      this.syncMediumSelection();
    }

    /**
     * Keep the tile selection in step with the potting checkbox.
     *
     * Nothing is marked while potting is unticked — a ticked tile next to an unticked checkbox
     * reads as "potting soil is already selected" when the customer hasn't bought potting at all.
     * Once ticked, the tile follows the EFFECTIVE medium, so a hidden tile can never look selected.
     */
  }, {
    key: "syncMediumSelection",
    value: function syncMediumSelection() {
      var wrapper = $('.js-oppot-medium-wrapper');
      if (!wrapper.length) return;
      var checkbox = this.getPottingAddonCheckbox();
      var isChecked = checkbox.length > 0 && checkbox.is(':checked');
      var activeValue = this.activeMedium;
      wrapper.find(this.mediumSelector).each(function () {
        this.checked = isChecked && this.value === activeValue;
      });
    }

    /**
     * The tiles are shown as soon as a decorative pot resolves a size, not only once the potting
     * checkbox is ticked: the customer can start from either the checkbox or a photo.
     * Still hidden when there is nothing to choose — with one medium left we select it silently.
     */
  }, {
    key: "refreshMediumTilesVisibility",
    value: function refreshMediumTilesVisibility() {
      var wrapper = $('.js-oppot-medium-wrapper');
      if (!wrapper.length) return;
      wrapper.toggle(this.visibleMediumCount > 1);
    }

    /**
     * Show the explanation text belonging to the current size's transport group. Both texts are
     * already in the DOM (snippets/product-addon-option.liquid), so this is just a visibility flip.
     *
     * @param {string} group - 'parcel' or 'pallet'
     */
  }, {
    key: "renderOppotExplanation",
    value: function renderOppotExplanation(group) {
      var texts = $('.js-oppot-uitleg');
      if (!texts.length) return;
      var match = texts.filter('[data-size-group="' + group + '"]');
      texts.attr('hidden', true);
      // Fall back to whichever text exists if only one of the two metafields is filled in
      (match.length ? match : texts.first()).removeAttr('hidden');
    }

    /**
     * Handle a click on a medium tile. The tiles double as an on/off control for potting:
     *
     * - clicking a tile while potting is off  -> turn potting on with that medium
     * - clicking a different tile             -> switch medium, potting stays on
     * - clicking the tile that is already on  -> turn potting off again
     *
     * A chosen medium sticks from here on; we never override it, including after the customer
     * picks a different decorative pot. Switching potting off does not forget it either, so
     * ticking the checkbox again brings their medium back.
     *
     * @param {Event} event
     */
  }, {
    key: "handleMediumClick",
    value: function handleMediumClick(event) {
      var value = $(event.currentTarget).val();
      var checkbox = this.getPottingAddonCheckbox();
      if (!checkbox.length || checkbox.prop("disabled")) return;

      // Second click on the active tile switches potting off. syncMediumSelection runs off the
      // checkbox's change event and clears the radio the browser just checked.
      if (checkbox.prop("checked") && this.activeMedium === value) {
        checkbox.prop("checked", false).trigger("change");
        this.updateTotalConfigurationPrice();
        return;
      }
      this.preferredMedium = value;
      if (!checkbox.prop("checked")) {
        // change, not click: click would toggle it straight back off on a label-driven event
        checkbox.prop("checked", true).trigger("change");
      }
      var potDiameter = this.getSelectedPotDiameter();
      if (potDiameter > 0) {
        this.updateOppottenVariant(potDiameter, checkbox);
      }
      this.updateTotalConfigurationPrice();
    }

    /**
     * Currency affixes for the active market, as Liquid rendered them.
     *
     * Every element this class rewrites gets its whole contents replaced, and Liquid puts the
     * currency INSIDE those elements — {{ gb_currency_after }} sits within .js-sticky-price-value
     * and within .js-addon-price-display. A rewrite therefore deletes it, and the bar ended up
     * showing "313,95" beside a struck-through "456,95 zł". Euro markets never noticed: there the
     * theme deliberately shows no symbol, so both affixes are empty and wiping them changes nothing.
     *
     * sections/single-product.liquid publishes the pair as window.GB_PRICE_FORMAT for exactly this
     * purpose. The values come from the shop's own money format, not from user input.
     *
     * @returns {{before: string, after: string}} Affixes, empty strings on a euro storefront
     */
  }, {
    key: "priceAffixes",
    value: function priceAffixes() {
      var format = window.GB_PRICE_FORMAT || {};
      return {
        before: format.before || '',
        after: format.after || ''
      };
    }

    /**
     * Format price for display (e.g., 4995 -> "49,95", or "49,95 zł" outside the eurozone)
     * @param {number} priceInCents - Price in cents
     * @returns {string} Formatted price string
     */
  }, {
    key: "formatPriceForDisplay",
    value: function formatPriceForDisplay(priceInCents) {
      var euros = Math.floor(priceInCents / 100);
      var cents = priceInCents % 100;
      var centsStr = cents.toString().padStart(2, '0');
      var currency = this.priceAffixes();
      return "".concat(currency.before).concat(euros, "<span class=\"pdp-price-comma\">,</span><sup class=\"pdp-price-cents\">").concat(centsStr, "</sup>").concat(currency.after);
    }

    /**
     * Same amount as formatPriceForDisplay, but in the shape Liquid renders inside
     * .js-sticky-price-value: the euros and the comma sit together in one wrapper element.
     *
     * The shape matters because assets/gb-pdp-layout.js also writes this element — it mirrors the
     * "Total price" block into the bar — and its kopieerBedrag() addresses the parts positionally:
     * children[0] is the euros wrapper, children[1] the cents. Handing it the flat shape made it
     * read the bare comma span as the euros wrapper, overwrite that with "54," and leave the
     * original "54" text node in front of it, so the bar showed "5454,95".
     *
     * Keep this in step with the markup in sections/single-product.liquid (js-sticky-price).
     *
     * @param {number} priceInCents - Price in cents
     * @returns {string} Markup matching the Liquid-rendered sticky price
     */
  }, {
    key: "formatStickyPrice",
    value: function formatStickyPrice(priceInCents) {
      var euros = Math.floor(priceInCents / 100);
      var cents = priceInCents % 100;
      var centsStr = cents.toString().padStart(2, '0');
      var currency = this.priceAffixes();
      // The affixes are text nodes, so they stay out of .children and kopieerBedrag() keeps
      // finding the euros wrapper at [0] and the cents at [1].
      return currency.before + "<span class=\"js-product-price-euros lh-1\">".concat(euros, "<span class=\"pdp-price-comma\">,</span></span>") + "<sup class=\"js-product-pdp-price-cents pdp-price-cents\">".concat(centsStr, "</sup>") + currency.after;
    }

    /**
     * Get current quantity from input
     * @returns {number} Current quantity (default: 1)
     */
  }, {
    key: "getQuantity",
    value: function getQuantity() {
      return parseInt($('input[name="quantity"]').val()) || 1;
    }

    /**
     * Get plant configuration data
     * @returns {Object|null} Plant data object or null
     */
  }, {
    key: "getPlantData",
    value: function getPlantData() {
      var _$$val, _plantData$data;
      var plantData = $(this.plantData);
      if (plantData.length === 0) return null;
      return {
        id: plantData.data("product-id"),
        variation: (_$$val = $('#variant-id').val()) !== null && _$$val !== void 0 ? _$$val : null,
        quantity: this.getQuantity(),
        type: 'plant',
        price: (_plantData$data = plantData.data("price")) !== null && _plantData$data !== void 0 ? _plantData$data : 0
      };
    }

    /**
     * Get pot configuration data
     * @returns {Object|null} Pot data object or null
     */
  }, {
    key: "getPotData",
    value: function getPotData() {
      var _potData$data;
      var potData = $(this.selectedPot);
      if (potData.length === 0) return null;
      var potVariationId = parseInt(potData.val());
      var potProductId = potData.data("product-id");
      if (!potProductId || !potVariationId) return null;
      return {
        id: potProductId,
        variation: potVariationId,
        quantity: this.getQuantity(),
        type: 'pot',
        price: (_potData$data = potData.data("pot-price")) !== null && _potData$data !== void 0 ? _potData$data : 0
      };
    }

    /**
     * Get card service configuration data
     * @returns {Object|null} Card service data object or null
     */
  }, {
    key: "getCardServiceData",
    value: function getCardServiceData() {
      var _$cardCheckbox$data;
      var cardCheckbox = $(".js-card-checkbox:checked");
      if (cardCheckbox.length === 0) return null;
      var $cardCheckbox = $(cardCheckbox[0]);
      var cardVariationId = parseInt($cardCheckbox.val());
      var cardProductId = $cardCheckbox.data("product-id");
      if (!cardProductId || !cardVariationId) return null;
      var cardMessage = $cardCheckbox.closest('.product-card-option').find('.js-card-message').val() || '';
      return {
        id: cardProductId,
        variation: cardVariationId,
        quantity: this.getQuantity(),
        type: 'card_service',
        price: (_$cardCheckbox$data = $cardCheckbox.data("card-price")) !== null && _$cardCheckbox$data !== void 0 ? _$cardCheckbox$data : 0,
        message: cardMessage.trim()
      };
    }

    /**
     * Get all add-on services data
     * @returns {Array} Array of add-on data objects
     */
  }, {
    key: "getAddonServicesData",
    value: function getAddonServicesData() {
      var addonCheckboxes = $(".js-addon-checkbox:checked");
      if (addonCheckboxes.length === 0) return [];
      var quantity = this.getQuantity();
      var addons = [];
      addonCheckboxes.each(function (index, checkbox) {
        var _$checkbox$data;
        var $checkbox = $(checkbox);
        var addonVariationId = parseInt($checkbox.val());
        var addonProductId = $checkbox.data("product-id");
        if (!addonProductId || !addonVariationId) return;

        // Get add-on message if available
        var addonMessage = $checkbox.closest('.product-addon-option').find('.js-addon-message').val() || '';
        var addonName = $checkbox.data("addon-name") || 'Add-on';
        var addon = {
          id: addonProductId,
          variation: addonVariationId,
          quantity: quantity,
          type: $checkbox.data("addon-type") || 'addon',
          price: (_$checkbox$data = $checkbox.data("addon-price")) !== null && _$checkbox$data !== void 0 ? _$checkbox$data : 0,
          name: addonName
        };

        // Add message if present
        if (addonMessage.trim()) {
          addon.message = addonMessage.trim();
        }
        addons.push(addon);
      });
      return addons;
    }

    /**
     * Get all upsell items data
     * @returns {Array} Array of upsell item objects
     */
  }, {
    key: "getUpsellItemsData",
    value: function getUpsellItemsData() {
      var upsellCheckboxes = $(".js-upsell-checkbox:checked");
      if (upsellCheckboxes.length === 0) return [];
      var quantity = this.getQuantity();
      var upsells = [];
      upsellCheckboxes.each(function (index, checkbox) {
        var $checkbox = $(checkbox);
        var upsellVariationId = parseInt($checkbox.val());
        var upsellProductId = $checkbox.data("product-id");
        var upsellTitle = $checkbox.data("title") || 'Upsell';
        var upsellPrice = parseInt($checkbox.data("price")) || 0;
        if (!upsellProductId || !upsellVariationId) return;
        upsells.push({
          id: upsellProductId,
          variation: upsellVariationId,
          quantity: quantity,
          type: 'upsell',
          price: upsellPrice,
          title: upsellTitle
        });
      });
      return upsells;
    }

    /**
     * Update the total configuration price
     */
  }, {
    key: "updateTotalConfigurationPrice",
    value: function updateTotalConfigurationPrice() {
      // Reset the add to cart object
      this.addToCartObject = [];

      // Get all configuration data
      var plantData = this.getPlantData();
      var potData = this.getPotData();
      var cardServiceData = this.getCardServiceData();
      var addonServicesData = this.getAddonServicesData();
      var upsellItemsData = this.getUpsellItemsData();

      // Build add to cart object
      if (plantData) {
        this.addToCartObject.push(plantData);
      }
      if (potData) {
        this.addToCartObject.push(potData);
      }
      if (cardServiceData) {
        this.addToCartObject.push(cardServiceData);
      }
      if (addonServicesData.length > 0) {
        var _this$addToCartObject;
        (_this$addToCartObject = this.addToCartObject).push.apply(_this$addToCartObject, _toConsumableArray(addonServicesData));
      }
      if (upsellItemsData.length > 0) {
        var _this$addToCartObject2;
        (_this$addToCartObject2 = this.addToCartObject).push.apply(_this$addToCartObject2, _toConsumableArray(upsellItemsData));
      }

      // Calculate total price
      var quantity = this.getQuantity();
      var totalPrice = 0;
      [plantData, potData, cardServiceData].forEach(function (item) {
        if (item) totalPrice += item.price * quantity;
      });
      addonServicesData.forEach(function (addon) {
        totalPrice += addon.price * quantity;
      });
      upsellItemsData.forEach(function (upsell) {
        totalPrice += upsell.price * quantity;
      });

      // Update UI
      var hasAdditionalItems = potData || cardServiceData || addonServicesData.length > 0 || upsellItemsData.length > 0;
      if (hasAdditionalItems) {
        $(".js-configuration-price").removeClass("d-none");
      } else {
        $(".js-configuration-price").addClass("d-none");
      }
      $(".js-total-cents").text(totalPrice.toString().slice(-2));
      $(".js-total-euros").text(totalPrice.toString().slice(0, -2));
      this.updateStickyPrice(totalPrice, hasAdditionalItems);

      // Update price summary
      this.updatePriceSummary(plantData, potData, cardServiceData, addonServicesData, upsellItemsData, totalPrice);
    }

    /**
     * Keep the sticky add-to-cart bar showing the same number as "Total price".
     *
     * The bar is rendered by Liquid with the plant's own price and is otherwise only touched on
     * variant change, so adding a pot or the potting service left it showing the bare plant —
     * a different figure from the total the customer is about to pay.
     *
     * @param {number} totalPrice - Configuration total in cents
     * @param {boolean} hasAdditionalItems - Whether anything beyond the plant is selected
     */
  }, {
    key: "updateStickyPrice",
    value: function updateStickyPrice(totalPrice, hasAdditionalItems) {
      var value = $(".js-sticky-price-value");
      if (!value.length) return;
      value.html(this.formatStickyPrice(totalPrice));

      // The plant's compare-at price says nothing about a configured total, so hide it as soon
      // as anything is added and restore it when the customer is back to just the plant.
      var compare = $(".js-sticky-price").find(".js-product-price-compare-del, .product-cta--sale");
      if (compare.length) {
        if (hasAdditionalItems) compare.hide();else compare.css("display", "");
      }
    }

    /**
     * Update the price summary container with breakdown
     */
  }, {
    key: "updatePriceSummary",
    value: function updatePriceSummary(plantData, potData, cardServiceData, addonServicesData, upsellItemsData, totalPrice) {
      var quantity = this.getQuantity();
      var formatPrice = function formatPrice(price) {
        var priceStr = price.toString().padStart(3, '0');
        return {
          euros: priceStr.slice(0, -2),
          cents: priceStr.slice(-2)
        };
      };

      // Update total price
      var totalFormatted = formatPrice(totalPrice);
      $(".js-price-summary-total-euros").html(totalFormatted.euros + '<span class="pdp-price-comma">,</span>');
      $(".js-price-summary-total-cents").text(totalFormatted.cents);

      // Calculate compare at price total (sum of all compare prices, using regular price when no compare price)
      var totalComparePrice = 0;
      var hasAnyDiscount = false;
      var items = [];

      // Plant
      if (plantData) {
        var plantConfig = $(this.plantData);
        var plantTitle = plantConfig.data("product-title") || "Plant";
        var plantPrice = plantData.price * quantity;
        var plantComparePriceRaw = plantConfig.data("compare-price") || 0;
        var plantComparePrice = plantComparePriceRaw * quantity;
        // Add to total compare: use compare price if exists and greater, otherwise use regular price
        if (plantComparePriceRaw > 0 && plantComparePriceRaw > plantData.price) {
          totalComparePrice += plantComparePrice;
          hasAnyDiscount = true;
        } else {
          totalComparePrice += plantPrice;
        }
        items.push({
          title: plantTitle,
          quantity: quantity,
          price: plantPrice,
          comparePrice: plantComparePrice,
          type: 'plant'
        });
      }

      // Pot
      if (potData) {
        var potInput = $(this.selectedPot);
        var potTitle = potInput.data("pot-title") || "Pot";
        var potPrice = potData.price * quantity;
        var potComparePriceRaw = potInput.data("pot-compare-price") || 0;
        var potComparePrice = potComparePriceRaw * quantity;
        // Add to total compare: use compare price if exists and greater, otherwise use regular price
        if (potComparePriceRaw > 0 && potComparePriceRaw > potData.price) {
          totalComparePrice += potComparePrice;
          hasAnyDiscount = true;
        } else {
          totalComparePrice += potPrice;
        }
        items.push({
          title: potTitle,
          quantity: quantity,
          price: potPrice,
          comparePrice: potComparePrice,
          type: 'pot'
        });
      }

      // Card service
      if (cardServiceData) {
        var cardCheckbox = $(".js-card-checkbox:checked");
        var cardLabel = cardCheckbox.closest('.product-card-option').find('label span');
        var cardTitle = cardLabel.text().split('(+')[0].trim() || "Card";
        var cardPrice = cardServiceData.price * quantity;
        totalComparePrice += cardPrice;
        items.push({
          title: cardTitle,
          quantity: quantity,
          price: cardPrice,
          comparePrice: 0,
          type: 'card_service'
        });
      }

      // Add-ons
      addonServicesData.forEach(function (addon) {
        var addonPrice = addon.price * quantity;
        var addonComparePriceRaw = addon.comparePrice || 0;
        var addonComparePrice = addonComparePriceRaw * quantity;
        // Add to total compare: use compare price if exists and greater, otherwise use regular price
        if (addonComparePriceRaw > 0 && addonComparePriceRaw > addon.price) {
          totalComparePrice += addonComparePrice;
          hasAnyDiscount = true;
        } else {
          totalComparePrice += addonPrice;
        }
        items.push({
          title: addon.name || "Add-on",
          quantity: quantity,
          price: addonPrice,
          comparePrice: addonComparePrice,
          type: addon.type || 'addon'
        });
      });

      // Upsell items
      if (upsellItemsData && upsellItemsData.length > 0) {
        upsellItemsData.forEach(function (upsell) {
          var upsellPrice = upsell.price * quantity;
          totalComparePrice += upsellPrice;
          items.push({
            title: upsell.title || "Extra",
            quantity: quantity,
            price: upsellPrice,
            comparePrice: 0,
            type: 'upsell'
          });
        });
      }

      // Update compare price if there's any discount
      if (hasAnyDiscount && totalComparePrice > totalPrice) {
        var compareFormatted = formatPrice(totalComparePrice);
        $(".js-price-summary-compare-euros").html(compareFormatted.euros + '<span class="pdp-price-comma">,</span>');
        $(".js-price-summary-compare-cents").text(compareFormatted.cents);
        $(".js-price-summary-compare").show();
        $(".js-price-summary-total").css("color", "");
        $(".js-price-summary-total").addClass("text-danger");
      } else {
        $(".js-price-summary-compare").hide();
        $(".js-price-summary-total").removeClass("text-danger");
      }

      // Build breakdown HTML
      var breakdownHTML = '';
      items.forEach(function (item) {
        var itemFormatted = formatPrice(item.price);
        var itemCompareFormatted = item.comparePrice > 0 ? formatPrice(item.comparePrice) : null;
        breakdownHTML += "\n\t\t\t\t<div class=\"product-price-summary__item d-flex justify-content-between align-items-center py-2 border-bottom\">\n\t\t\t\t\t<div class=\"flex-grow-1\">\n\t\t\t\t\t\t<div class=\"fw-medium\">".concat(item.title, "</div>\n\t\t\t\t\t\t").concat(item.quantity > 1 ? "<small class=\"text-muted\">".concat(item.quantity, "x</small>") : '', "\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"text-end\">\n\t\t\t\t\t\t").concat(itemCompareFormatted && item.comparePrice > item.price ? "\n\t\t\t\t\t\t\t<del class=\"text-muted\" style=\"font-size: 0.875rem;\">\n\t\t\t\t\t\t\t\t".concat(itemCompareFormatted.euros, "<span class=\"pdp-price-comma\">,</span><sup class=\"pdp-price-cents\">").concat(itemCompareFormatted.cents, "</sup>\n\t\t\t\t\t\t\t</del>\n\t\t\t\t\t\t") : '', "\n\t\t\t\t\t\t<div class=\"fw-medium\">").concat(itemFormatted.euros, "<span class=\"pdp-price-comma\">,</span><sup class=\"pdp-price-cents\">").concat(itemFormatted.cents, "</sup></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t");
      });
      $(".product-price-summary__items").html(breakdownHTML);
    }

    /**
     * Get fresh card message from the UI at add-to-cart time
     * @returns {string} The card message or empty string
     */
  }, {
    key: "getFreshCardMessage",
    value: function getFreshCardMessage() {
      var cardCheckbox = $(".js-card-checkbox:checked");
      if (cardCheckbox.length === 0) return '';
      var cardMessageInput = cardCheckbox.closest('.product-card-option').find('.js-card-message');
      return (cardMessageInput.val() || '').trim();
    }

    /**
     * Get fresh card type from the currently checked radio button
     * @returns {string} The selected card type or empty string
     */
  }, {
    key: "getFreshCardType",
    value: function getFreshCardType() {
      var cardCheckbox = $(".js-card-checkbox:checked");
      if (cardCheckbox.length === 0) return '';
      var cardTypeInput = cardCheckbox.closest('.product-card-option').find('.js-card-type-radio:checked');
      return cardTypeInput.length > 0 ? cardTypeInput.val() : '';
    }

    /**
     * Validate card message - if card is selected, message must be entered
     * @returns {Object} { valid: boolean, message: string }
     */
  }, {
    key: "validateCardMessage",
    value: function validateCardMessage() {
      var cardCheckbox = $(".js-card-checkbox:checked");
      if (cardCheckbox.length === 0) return {
        valid: true,
        message: ''
      };

      // Card is selected, check if message is entered
      var cardMessageInput = cardCheckbox.closest('.product-card-option').find('.js-card-message');
      var cardMessage = (cardMessageInput.val() || '').trim();
      if (!cardMessage) {
        var _window$cartTranslati;
        return {
          valid: false,
          message: ((_window$cartTranslati = window.cartTranslations) === null || _window$cartTranslati === void 0 ? void 0 : _window$cartTranslati.card_message_required) || 'Vul een bericht in voor de kaart'
        };
      }
      return {
        valid: true,
        message: ''
      };
    }

    /**
     * Show validation error for card message
     * @param {string} message - Error message to display
     */
  }, {
    key: "showCardMessageError",
    value: function showCardMessageError(message) {
      var cardOption = $('.product-card-option');
      if (cardOption.length === 0) return;

      // Remove any existing error
      cardOption.find('.card-message-error').remove();

      // Create and show error message
      var errorDiv = $('<div class="card-message-error text-danger mt-2"></div>').css({
        'font-size': '13px',
        'font-weight': '500'
      }).html("<i class=\"fa-sharp fa-regular fa-circle-exclamation me-1\"></i>".concat(message));
      var messageWrapper = cardOption.find('.product-card-option__message-wrapper');
      if (messageWrapper.length) {
        messageWrapper.append(errorDiv);
      }

      // Focus on the textarea
      var cardMessageInput = cardOption.find('.js-card-message');
      if (cardMessageInput.length) {
        cardMessageInput.focus();
        cardMessageInput.css('border-color', '#dc3545');
      }

      // Auto-remove error after 5 seconds or when user types
      setTimeout(function () {
        errorDiv.remove();
        cardMessageInput.css('border-color', '');
      }, 5000);
      cardMessageInput.one('input', function () {
        errorDiv.remove();
        $(this).css('border-color', '');
      });
    }

    /**
     * Get fresh add-on messages from the UI at add-to-cart time
     * @returns {Object} Object mapping add-on names to messages
     */
  }, {
    key: "getFreshAddonMessages",
    value: function getFreshAddonMessages() {
      var messages = {};
      $(".js-addon-checkbox:checked").each(function (index, checkbox) {
        var $checkbox = $(checkbox);
        var addonName = $checkbox.data("addon-name") || 'Add-on';
        var addonMessageInput = $checkbox.closest('.product-addon-option').find('.js-addon-message');
        if (addonMessageInput.length > 0) {
          var message = (addonMessageInput.val() || '').trim();
          if (message) {
            messages[addonName] = message;
          }
        }
      });
      return messages;
    }

    /**
     * Build cart items array with proper properties
     * @param {string} configurationId - Unique configuration ID
     * @returns {Array} Array of cart item objects
     */
  }, {
    key: "buildCartItems",
    value: function buildCartItems(configurationId) {
      // Ensure we have the latest data
      if (this.addToCartObject.length === 0) {
        this.updateTotalConfigurationPrice();
      }

      // Get fresh card message and type at add-to-cart time (prefer fresh over stored)
      var freshCardMessage = this.getFreshCardMessage();
      var freshCardType = this.getFreshCardType();
      // Get fresh add-on messages at add-to-cart time
      var freshAddonMessages = this.getFreshAddonMessages();

      // Map products to cart items
      var cartItems = this.addToCartObject.map(function (product) {
        var _product$variation;
        var item = {
          id: (_product$variation = product.variation) !== null && _product$variation !== void 0 ? _product$variation : product.id,
          quantity: product.quantity,
          properties: {
            _sub: "true",
            _configuration_id: configurationId,
            _type: product.type
          }
        };

        // Add card type and message if it's a card service
        if (product.type === 'card_service') {
          var cardType = freshCardType || '';
          if (cardType) {
            item.properties['Card Type'] = cardType;
          }
          var cardMessage = freshCardMessage || product.message || '';
          if (cardMessage) {
            item.properties['Card Message'] = cardMessage;
          }
        }

        // Add add-on message if it's an add-on with a message
        if (product.type === 'addon' && product.name) {
          var addonMessage = freshAddonMessages[product.name] || product.message || '';
          if (addonMessage) {
            item.properties[product.name + ' Message'] = addonMessage;
          }
        }
        return item;
      });

      // Reverse array so main item (plant) is last, then mark it as main
      cartItems.reverse();
      if (cartItems.length > 0 && cartItems[cartItems.length - 1].properties) {
        cartItems[cartItems.length - 1].properties._sub = "false";
      }
      return cartItems;
    }

    /**
     * Add to cart functionality
     * @param {Event} event - Click event
     */
  }, {
    key: "addToCart",
    value: (function () {
      var _addToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
        var cardValidation, configurationId, cartItems, _mutationResponse, cartRes, cartData, mutationResponse, variantId, existingItem, newVariantIds, addQty, configGroups, matchingGroup, _i, _Object$entries, _Object$entries$_i, cfgId, group, existingVariantIds, updates, minicartHtml, newBox, errorMessage, errorData, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              // Prevent form submission and event bubbling to avoid duplicate add-to-cart
              if (event) {
                event.preventDefault();
                event.stopPropagation();
              }

              // Validate card message if card is selected
              cardValidation = this.validateCardMessage();
              if (cardValidation.valid) {
                _context.n = 1;
                break;
              }
              this.showCardMessageError(cardValidation.message);
              return _context.a(2);
            case 1:
              // Generate unique configuration ID
              configurationId = Date.now().toString(); // Build cart items
              cartItems = this.buildCartItems(configurationId); // Validate we have at least one item
              if (!(cartItems.length === 0)) {
                _context.n = 2;
                break;
              }
              console.error('No items to add to cart');
              return _context.a(2);
            case 2:
              // Open the drawer immediately on click for instant UX feedback.
              // Network requests run in parallel below; the new cart content
              // fills in as soon as the bundled section HTML returns.
              (0,_functions__WEBPACK_IMPORTED_MODULE_2__.openMiniCart)();

              // Optimistic UI: show a placeholder card in the drawer immediately
              // (without waiting for the API). Replaced when the real cart HTML arrives.
              injectOptimisticCartPlaceholder();
              _context.p = 3;
              _context.n = 4;
              return fetch(window.Shopify.routes.root + 'cart.js');
            case 4:
              cartRes = _context.v;
              _context.n = 5;
              return cartRes.json();
            case 5:
              cartData = _context.v;
              if (!(cartItems.length === 1)) {
                _context.n = 10;
                break;
              }
              // Standalone plant — stack onto an existing STANDALONE line with the
              // same variant ID. Skip lines that belong to a configuration group
              // (those have a _configuration_id property) so we don't accidentally
              // bump the qty of a Plant+Pot+Oppotten bundle when the user is adding
              // a bare plant.
              variantId = parseInt(cartItems[0].id);
              existingItem = cartData.items.find(function (item) {
                var _item$properties;
                return item.variant_id === variantId && !((_item$properties = item.properties) !== null && _item$properties !== void 0 && _item$properties._configuration_id);
              });
              if (!existingItem) {
                _context.n = 7;
                break;
              }
              _context.n = 6;
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  line: cartData.items.indexOf(existingItem) + 1,
                  quantity: existingItem.quantity + cartItems[0].quantity,
                  sections: ['base-minicart']
                })
              }).then(function (r) {
                return r.json();
              });
            case 6:
              mutationResponse = _context.v;
              _context.n = 9;
              break;
            case 7:
              delete cartItems[0].properties._configuration_id;
              delete cartItems[0].properties._sub;
              delete cartItems[0].properties._type;
              if (Object.keys(cartItems[0].properties).length === 0) {
                delete cartItems[0].properties;
              }
              _context.n = 8;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  items: cartItems,
                  sections: ['base-minicart']
                })
              }).then(function (r) {
                return r.json();
              });
            case 8:
              mutationResponse = _context.v;
            case 9:
              _context.n = 17;
              break;
            case 10:
              // Configuration group — check if exact same combo exists in cart
              newVariantIds = cartItems.map(function (item) {
                return parseInt(item.id);
              }).sort(function (a, b) {
                return a - b;
              });
              addQty = cartItems[0].quantity; // Group existing cart items by configuration_id
              configGroups = {};
              cartData.items.forEach(function (item, index) {
                var _item$properties2;
                var cfgId = (_item$properties2 = item.properties) === null || _item$properties2 === void 0 ? void 0 : _item$properties2._configuration_id;
                if (cfgId) {
                  if (!configGroups[cfgId]) configGroups[cfgId] = [];
                  configGroups[cfgId].push({
                    item: item,
                    index: index
                  });
                }
              });

              // Find a matching configuration group
              matchingGroup = null;
              _i = 0, _Object$entries = Object.entries(configGroups);
            case 11:
              if (!(_i < _Object$entries.length)) {
                _context.n = 13;
                break;
              }
              _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), cfgId = _Object$entries$_i[0], group = _Object$entries$_i[1];
              existingVariantIds = group.map(function (g) {
                return g.item.variant_id;
              }).sort(function (a, b) {
                return a - b;
              });
              if (!(existingVariantIds.length === newVariantIds.length && existingVariantIds.every(function (id, i) {
                return id === newVariantIds[i];
              }))) {
                _context.n = 12;
                break;
              }
              matchingGroup = group;
              return _context.a(3, 13);
            case 12:
              _i++;
              _context.n = 11;
              break;
            case 13:
              if (!matchingGroup) {
                _context.n = 15;
                break;
              }
              // Same combo exists — increment quantities of all items in the group
              updates = {};
              matchingGroup.forEach(function (g) {
                updates[g.item.key] = g.item.quantity + addQty;
              });
              _context.n = 14;
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  updates: updates,
                  sections: ['base-minicart']
                })
              }).then(function (r) {
                return r.json();
              });
            case 14:
              mutationResponse = _context.v;
              _context.n = 17;
              break;
            case 15:
              _context.n = 16;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  items: cartItems,
                  sections: ['base-minicart']
                })
              }).then(function (r) {
                return r.json();
              });
            case 16:
              mutationResponse = _context.v;
            case 17:
              // Use bundled section HTML from the same response — no extra fetch.
              // Inject HTML synchronously (paints fast), then defer heavy JS work
              // (slider init, listener re-attach) to next frame so the user sees
              // the cart contents before we re-init listeners.
              if ((_mutationResponse = mutationResponse) !== null && _mutationResponse !== void 0 && _mutationResponse.sections && mutationResponse.sections['base-minicart']) {
                minicartHtml = document.createElement('div');
                minicartHtml.innerHTML = mutationResponse.sections['base-minicart'];
                newBox = minicartHtml.querySelector('.drawer-cart');
                if (newBox) {
                  document.querySelector('.drawer-cart').innerHTML = newBox.innerHTML;
                  // Defer post-render work to next animation frame so the paint
                  // happens immediately. Sliders + listeners are not needed
                  // for the user to see cart contents.
                  requestAnimationFrame(function () {
                    (0,_custom_add_to_cart__WEBPACK_IMPORTED_MODULE_0__.addEventListenersToCart)();
                    (0,_custom_add_to_cart__WEBPACK_IMPORTED_MODULE_0__.initRelatedAddToCart)();
                    (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.reInitCartSliders)();
                  });
                }
              }

              // Update cart count + dispatch cart:updated event in background.
              // Fire-and-forget — don't block UI on this.
              fetch(window.Shopify.routes.root + 'cart.js').then(function (r) {
                return r.json();
              }).then(function (cart) {
                document.querySelectorAll('.js-cart-count').forEach(function (el) {
                  el.textContent = cart.item_count;
                });
                window.dispatchEvent(new CustomEvent('cart:updated', {
                  detail: {
                    action: 'add',
                    cart: cart
                  }
                }));
              });
              _context.n = 19;
              break;
            case 18:
              _context.p = 18;
              _t = _context.v;
              // Handle error response
              errorMessage = 'An error occurred while adding items to cart';
              try {
                errorData = JSON.parse(_t.responseText);
                errorMessage = (errorData === null || errorData === void 0 ? void 0 : errorData.message) || errorMessage;
              } catch (e) {
                console.error('Error parsing error response:', e);
              }
              alert(errorMessage);
            case 19:
              return _context.a(2);
          }
        }, _callee, this, [[3, 18]]);
      }));
      function addToCart(_x) {
        return _addToCart.apply(this, arguments);
      }
      return addToCart;
    }()
    /**
     * Update quantity
     *
     * @param {Number} increment
     */
    )
  }, {
    key: "updateQuantity",
    value: function updateQuantity(increment) {
      // Get the current quantity
      var currentQuantity = parseInt($(this.quantityInputSelector).val(), 10);

      // If it's not a number, set it to 0
      if (isNaN(currentQuantity)) currentQuantity = 0;

      // Get the new quantity
      var newQuantity = currentQuantity + increment;

      // Overwrite the value
      if (newQuantity >= 1) $(this.quantityInputSelector).val(newQuantity);

      // Update the total configuration price
      this.updateTotalConfigurationPrice();
    }
  }]);
}();
/**
 * Show an instant placeholder card inside the drawer-cart while the
 * real cart HTML is fetched. Shopify's /cart/add.js + section render
 * still takes 300-700ms; this gives the user immediate feedback.
 *
 * The placeholder is replaced when the real .drawer-cart innerHTML is swapped in.
 */
function injectOptimisticCartPlaceholder() {
  var drawer = document.querySelector('.drawer-cart');
  if (!drawer) return;

  // Pull title + image from the current PDP — they're already in the DOM.
  var titleEl = document.querySelector('h1.display-2');
  var imageEl = document.querySelector('.product-hero-main-slider__slide.slick-active img, .product-hero-main-slider__slide img');
  var title = titleEl ? titleEl.textContent.trim() : 'Plant';
  var imageSrc = imageEl ? imageEl.currentSrc || imageEl.src : '';

  // Find the existing scrollable area where cart items would appear.
  var contentArea = drawer.querySelector('.drawer-content');
  if (!contentArea) return;

  // If the user already has items and the drawer was rendered before,
  // just append a small "adding…" badge at the top instead of wiping.
  var placeholderHtml = "\n\t\t<div class=\"cart-item rounded p-1 position-relative js-optimistic-placeholder\" style=\"opacity:.7;background:rgba(0,0,0,.02);\">\n\t\t\t<div class=\"cart-item__content d-flex align-items-center gap-1 w-100\">\n\t\t\t\t<div class=\"cart-item__media position-relative\" style=\"width:60px;height:60px;flex-shrink:0;\">\n\t\t\t\t\t".concat(imageSrc ? "<img src=\"".concat(imageSrc, "\" alt=\"").concat(title, "\" class=\"img-abs-center\" style=\"width:100%;height:100%;object-fit:cover;border-radius:4px;\">") : '', "\n\t\t\t\t</div>\n\t\t\t\t<div class=\"cart-item__details flex-grow-1 ps-1\">\n\t\t\t\t\t<strong class=\"cart-item__title fw-medium d-block lh-1 mb-1\">").concat(title, "</strong>\n\t\t\t\t\t<small class=\"text-muted\">\n\t\t\t\t\t\t<i class=\"fa-duotone fa-solid fa-spinner-third fa-spin\"></i> Adding\u2026\n\t\t\t\t\t</small>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t");

  // Insert at the very top of drawer-content so it's the first thing visible.
  contentArea.insertAdjacentHTML('afterbegin', placeholderHtml);
}

/**
 * Show the find-my-pot product quickview
 */
var showQuickView = function showQuickView(event) {
  // Get the product and fill the quickview
  var product = $(event.currentTarget);
  $(".js-quickview__title").html(product.data("title"));
  $(".js-quickview__image").attr("src", product.data("image"));
  var price = product.data("price");
  var priceString = price.toString();
  var modifiedPrice = priceString.slice(0, -2) + ",<span>" + priceString.slice(-2) + "</span>";
  $(".js-quickview__price").html(modifiedPrice);

  // Populate measurements and materials
  var potDiameter = product.data("pot-diameter") || product.data("pot-opening");
  var potHeight = product.data("pot-height");
  var potMaterial = product.data("pot-material");

  // Show diameter or N/A
  var diameterText = potDiameter ? potDiameter + " cm" : "N/A";
  $(".js-quickview__diameter span.fw-semibold").text(diameterText);

  // Show height if available, otherwise show N/A
  if (potHeight && potHeight !== "" && potHeight !== "0") {
    $(".js-quickview__height span.fw-semibold").text(potHeight + " cm");
  } else {
    $(".js-quickview__height span.fw-semibold").text("N/A");
  }

  // Show material if available, hide row if not
  if (potMaterial && potMaterial !== "") {
    $(".js-quickview__material span.fw-semibold").text(potMaterial);
    $(".js-quickview__material").show();
  } else {
    $(".js-quickview__material").hide();
  }
};


/***/ }),

/***/ "./src/js/functions.js":
/*!*****************************!*\
  !*** ./src/js/functions.js ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   closeFilterPanel: () => (/* binding */ closeFilterPanel),
/* harmony export */   closeLangPanel: () => (/* binding */ closeLangPanel),
/* harmony export */   closeMiniCart: () => (/* binding */ closeMiniCart),
/* harmony export */   filterToggle: () => (/* binding */ filterToggle),
/* harmony export */   lockHTML: () => (/* binding */ lockHTML),
/* harmony export */   openFilterPanel: () => (/* binding */ openFilterPanel),
/* harmony export */   openLangPanel: () => (/* binding */ openLangPanel),
/* harmony export */   openMiniCart: () => (/* binding */ openMiniCart),
/* harmony export */   unlockHTML: () => (/* binding */ unlockHTML)
/* harmony export */ });
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "../../node_modules/.pnpm/jquery@3.7.1/node_modules/jquery/dist/jquery.js");
var openMiniCart = function openMiniCart() {
  $(".drawer-cart").addClass("is-open");
};
var closeMiniCart = function closeMiniCart() {
  $(".drawer-cart").removeClass("is-open");
};
var openLangPanel = function openLangPanel() {
  $(".drawer-lang").toggleClass("is-open");
};
var closeLangPanel = function closeLangPanel() {
  $(".drawer-lang").removeClass("is-open");
};
var filterToggle = function filterToggle(element) {
  if (element.parent().hasClass("is-hidden")) {
    element.parent().removeClass("is-hidden").find(".collection-filter-content").stop().slideToggle();
  } else {
    element.parent().addClass("is-hidden").find(".collection-filter-content").stop().slideToggle();
  }
};
var openFilterPanel = function openFilterPanel() {
  $(".drawer-filter").toggleClass("is-open");
};
var closeFilterPanel = function closeFilterPanel() {
  $(".drawer-filter").removeClass("is-open");
};
var lockHTML = function lockHTML() {
  if (!$("html").hasClass("is-locked")) {
    $("html").addClass("is-locked");
  }
};
var unlockHTML = function unlockHTML() {
  $("html").removeClass("is-locked");
};


/***/ }),

/***/ "./src/js/price-slider.js":
/*!********************************!*\
  !*** ./src/js/price-slider.js ***!
  \********************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Price Range Slider with Filter Integration
 * Syncs slider handles with input fields and applies filters
 */
var PriceRangeSlider = /*#__PURE__*/function () {
  function PriceRangeSlider(container) {
    _classCallCheck(this, PriceRangeSlider);
    this.container = container;
    this.rangeMin = container.querySelector('.price-range-filter__range-min');
    this.rangeMax = container.querySelector('.price-range-filter__range-max');
    this.inputMin = container.querySelector('.price-range-filter__input-min');
    this.inputMax = container.querySelector('.price-range-filter__input-max');
    this.fill = container.querySelector('.price-range-filter__fill');
    this.valueMinDisplay = container.querySelector('.price-range-filter__value-min-num');
    this.valueMaxDisplay = container.querySelector('.price-range-filter__value-max-num');
    this.max = parseInt(container.getAttribute('data-max')) || 2000;
    this.min = 0;
    this.minGap = 10;

    // Prevent circular updates
    this.updatingFromSlider = false;
    this.updatingFromInput = false;

    // Debounce timers for filter application
    this.filterDebounceTimer = null;
    this.filterDebounceDelay = 400; // milliseconds

    // Track if user is actively typing (to prevent DOM replacement)
    this.isTyping = false;
    this.typingDebounceTimer = null;
    this.typingDebounceDelay = 800; // milliseconds

    if (!this.rangeMin || !this.rangeMax || !this.inputMin || !this.inputMax) {
      return;
    }
    this.init();
  }
  return _createClass(PriceRangeSlider, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Set initial values
      this.updateFill();
      this.updateDisplayValues();

      // Slider events
      this.rangeMin.addEventListener('input', function () {
        return _this.handleMinSlider();
      });
      this.rangeMax.addEventListener('input', function () {
        return _this.handleMaxSlider();
      });

      // Input events
      this.inputMin.addEventListener('input', function () {
        return _this.handleMinInput();
      });
      this.inputMin.addEventListener('blur', function () {
        return _this.handleMinInputBlur();
      });
      this.inputMax.addEventListener('input', function () {
        return _this.handleMaxInput();
      });
      this.inputMax.addEventListener('blur', function () {
        return _this.handleMaxInputBlur();
      });

      // Update fill position on initial load
      this.updateFill();
    }
  }, {
    key: "getMinValue",
    value: function getMinValue() {
      return parseInt(this.rangeMin.value) || this.min;
    }
  }, {
    key: "getMaxValue",
    value: function getMaxValue() {
      return parseInt(this.rangeMax.value) || this.max;
    }
  }, {
    key: "updateFill",
    value: function updateFill() {
      var minVal = this.getMinValue();
      var maxVal = this.getMaxValue();
      var minPercent = minVal / this.max * 100;
      var maxPercent = maxVal / this.max * 100;
      this.fill.style.left = "".concat(minPercent, "%");
      this.fill.style.width = "".concat(maxPercent - minPercent, "%");
    }
  }, {
    key: "updateDisplayValues",
    value: function updateDisplayValues() {
      var minVal = this.getMinValue();
      var maxVal = this.getMaxValue();
      if (this.valueMinDisplay) {
        this.valueMinDisplay.textContent = minVal;
      }
      if (this.valueMaxDisplay) {
        this.valueMaxDisplay.textContent = maxVal;
      }
    }
  }, {
    key: "validateValue",
    value: function validateValue(value, isMin) {
      // Allow empty string during typing
      if (value === '' || value === null || value === undefined) {
        return isMin ? this.min : this.max;
      }
      var num = parseInt(value);
      if (isNaN(num)) {
        return isMin ? this.min : this.max;
      }

      // Clamp to bounds
      if (num < this.min) num = this.min;
      if (num > this.max) num = this.max;

      // Enforce min gap
      if (isMin) {
        var maxVal = this.getMaxValue();
        if (maxVal - num < this.minGap) {
          num = maxVal - this.minGap;
          if (num < this.min) num = this.min;
        }
      } else {
        var minVal = this.getMinValue();
        if (num - minVal < this.minGap) {
          num = minVal + this.minGap;
          if (num > this.max) num = this.max;
        }
      }
      return num;
    }
  }, {
    key: "applyFilter",
    value: function applyFilter() {
      var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // Filters are applied only when user clicks the "Apply" button in the filter drawer.
      // This method now only updates the slider UI (fill, display values) without triggering form submission.
      // Clear any pending timers
      if (this.filterDebounceTimer) {
        clearTimeout(this.filterDebounceTimer);
        this.filterDebounceTimer = null;
      }
    }
  }, {
    key: "handleMinSlider",
    value: function handleMinSlider() {
      if (this.updatingFromInput) return;
      this.updatingFromSlider = true;
      var value = this.getMinValue();
      var maxVal = this.getMaxValue();

      // Enforce min gap
      if (maxVal - value < this.minGap) {
        value = maxVal - this.minGap;
        this.rangeMin.value = value;
      }

      // Update input
      this.inputMin.value = value;

      // Update visual immediately (no debounce for UI updates)
      this.updateFill();
      this.updateDisplayValues();
      this.updatingFromSlider = false;

      // Apply filter with debounce (delayed)
      this.applyFilter(false);
    }
  }, {
    key: "handleMaxSlider",
    value: function handleMaxSlider() {
      if (this.updatingFromInput) return;
      this.updatingFromSlider = true;
      var value = this.getMaxValue();
      var minVal = this.getMinValue();

      // Enforce min gap
      if (value - minVal < this.minGap) {
        value = minVal + this.minGap;
        this.rangeMax.value = value;
      }

      // Update input
      this.inputMax.value = value;

      // Update visual immediately (no debounce for UI updates)
      this.updateFill();
      this.updateDisplayValues();
      this.updatingFromSlider = false;

      // Apply filter with debounce (delayed)
      this.applyFilter(false);
    }
  }, {
    key: "setTypingState",
    value: function setTypingState(isTyping) {
      this.isTyping = isTyping;
      // Expose typing state on container for collection-filtering.js to check
      this.container.dataset.isTyping = isTyping ? 'true' : 'false';
    }
  }, {
    key: "handleMinInput",
    value: function handleMinInput() {
      var _this2 = this;
      if (this.updatingFromSlider) return;
      this.updatingFromInput = true;

      // Mark as typing and reset typing timer
      this.setTypingState(true);
      if (this.typingDebounceTimer) {
        clearTimeout(this.typingDebounceTimer);
      }
      this.typingDebounceTimer = setTimeout(function () {
        _this2.setTypingState(false);
      }, this.typingDebounceDelay);

      // Don't validate or constrain while typing - let user type freely
      var inputValue = this.inputMin.value;

      // Only update slider and display if input is a valid number
      // Don't constrain the input value itself
      if (inputValue !== '' && !isNaN(parseInt(inputValue))) {
        var numValue = parseInt(inputValue);

        // Only update slider if within reasonable bounds (don't constrain input)
        if (numValue >= 0) {
          // Use the input value for slider, but clamp slider to max
          var sliderValue = numValue > this.max ? this.max : numValue;

          // Constrain slider to min gap
          var maxVal = this.getMaxValue();
          if (maxVal - sliderValue < this.minGap) {
            sliderValue = maxVal - this.minGap;
            if (sliderValue < this.min) sliderValue = this.min;
          }

          // Update slider position only (don't change input value)
          this.rangeMin.value = sliderValue;
          this.updateFill();
        }

        // Update display with input value (or max if over)
        if (this.valueMinDisplay) {
          this.valueMinDisplay.textContent = numValue > this.max ? this.max : numValue;
        }
      }
      this.updatingFromInput = false;

      // Apply filter with debounce for input typing
      this.applyFilter(false);
    }
  }, {
    key: "handleMinInputBlur",
    value: function handleMinInputBlur() {
      if (this.updatingFromSlider) return;
      this.updatingFromInput = true;
      if (!this.inputMin.value || this.inputMin.value === '') {
        this.inputMin.value = this.min;
        this.rangeMin.value = this.min;
      } else {
        var value = this.validateValue(this.inputMin.value, true);
        this.inputMin.value = value;
        this.rangeMin.value = value;
      }
      this.updateFill();
      this.updateDisplayValues();
      this.updatingFromInput = false;
      // Apply filter immediately on blur
      this.applyFilter(true);
    }
  }, {
    key: "handleMaxInput",
    value: function handleMaxInput() {
      var _this3 = this;
      if (this.updatingFromSlider) return;
      this.updatingFromInput = true;

      // Mark as typing and reset typing timer
      this.setTypingState(true);
      if (this.typingDebounceTimer) {
        clearTimeout(this.typingDebounceTimer);
      }
      this.typingDebounceTimer = setTimeout(function () {
        _this3.setTypingState(false);
      }, this.typingDebounceDelay);

      // Don't validate or constrain while typing - let user type freely
      var inputValue = this.inputMax.value;

      // Only update slider and display if input is a valid number
      // Don't constrain the input value itself
      if (inputValue !== '' && !isNaN(parseInt(inputValue))) {
        var numValue = parseInt(inputValue);

        // Only update slider if within reasonable bounds (don't constrain input)
        if (numValue >= 0) {
          // Use the input value for slider, but clamp slider to max
          var sliderValue = numValue > this.max ? this.max : numValue;

          // Constrain slider to min gap
          var minVal = this.getMinValue();
          if (sliderValue - minVal < this.minGap) {
            sliderValue = minVal + this.minGap;
            if (sliderValue > this.max) sliderValue = this.max;
          }

          // Update slider position only (don't change input value)
          this.rangeMax.value = sliderValue;
          this.updateFill();
        }

        // Update display with input value (or max if over)
        if (this.valueMaxDisplay) {
          this.valueMaxDisplay.textContent = numValue > this.max ? this.max : numValue;
        }
      }
      this.updatingFromInput = false;

      // Apply filter with debounce for input typing
      this.applyFilter(false);
    }
  }, {
    key: "handleMaxInputBlur",
    value: function handleMaxInputBlur() {
      if (this.updatingFromSlider) return;
      this.updatingFromInput = true;
      if (!this.inputMax.value || this.inputMax.value === '') {
        this.inputMax.value = this.max;
        this.rangeMax.value = this.max;
      } else {
        var value = this.validateValue(this.inputMax.value, false);
        this.inputMax.value = value;
        this.rangeMax.value = value;
      }
      this.updateFill();
      this.updateDisplayValues();
      this.updatingFromInput = false;
      // Apply filter immediately on blur
      this.applyFilter(true);
    }
  }]);
}(); // Initialize all price sliders on page load and after AJAX updates
function initPriceSliders() {
  var containers = document.querySelectorAll('.price-range-filter');
  containers.forEach(function (container) {
    // Clear existing instance if it exists (for re-initialization after AJAX)
    if (container.priceSliderInstance) {
      container.priceSliderInstance = null;
    }
    // Create new instance
    container.priceSliderInstance = new PriceRangeSlider(container);
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPriceSliders);
} else {
  initPriceSliders();
}

// Re-initialize after AJAX updates (for dynamic content)
document.addEventListener('filterUpdated', initPriceSliders);

// Export for use in other scripts
window.initPriceSliders = initPriceSliders;

/***/ }),

/***/ "./src/js/sliders.js":
/*!***************************!*\
  !*** ./src/js/sliders.js ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   debounceReInitSliders: () => (/* binding */ debounceReInitSliders),
/* harmony export */   destroyHomeHeroAsideMobileSlider: () => (/* binding */ destroyHomeHeroAsideMobileSlider),
/* harmony export */   initHomeHeroAsideMobileSlider: () => (/* binding */ initHomeHeroAsideMobileSlider),
/* harmony export */   reInitCartSliders: () => (/* binding */ reInitCartSliders)
/* harmony export */ });
/* harmony import */ var slick_slider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-slider */ "../../node_modules/.pnpm/slick-slider@1.8.2/node_modules/slick-slider/slick/slick.js");
/* harmony import */ var slick_slider__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_slider__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _find_my_pot__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./find-my-pot */ "./src/js/find-my-pot.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "../../node_modules/.pnpm/jquery@3.7.1/node_modules/jquery/dist/jquery.js");


var mq = {
  xs: 425,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1600
};

/**
 * Enable drag functionality on custom scrollbar thumb
 * @param {HTMLElement} slider - The scrollable container
 * @param {HTMLElement} track - The scrollbar track element
 * @param {HTMLElement} thumb - The scrollbar thumb element
 */
function enableScrollbarDrag(slider, track, thumb) {
  if (!slider || !track || !thumb) return;

  // Skip if already initialized
  if (thumb.dataset.dragInit) return;
  thumb.dataset.dragInit = 'true';
  var isDragging = false;
  var startX = 0;
  var startScrollLeft = 0;
  function onMouseDown(e) {
    isDragging = true;
    startX = e.clientX;
    startScrollLeft = slider.scrollLeft;
    thumb.classList.add('is-dragging');
    document.body.style.userSelect = 'none';
    // Disable smooth scrolling during drag for immediate response
    slider.style.scrollBehavior = 'auto';
    e.preventDefault();
  }
  function onMouseMove(e) {
    if (!isDragging) return;
    var trackRect = track.getBoundingClientRect();
    var trackWidth = trackRect.width;
    var thumbWidth = thumb.offsetWidth;
    var scrollableWidth = slider.scrollWidth - slider.clientWidth;

    // Calculate delta movement as percentage of track
    var deltaX = e.clientX - startX;
    var trackScrollableWidth = trackWidth - thumbWidth;
    if (trackScrollableWidth <= 0) return;

    // Convert track movement to scroll movement
    var scrollDelta = deltaX / trackScrollableWidth * scrollableWidth;
    slider.scrollLeft = startScrollLeft + scrollDelta;
  }
  function onMouseUp() {
    if (!isDragging) return;
    isDragging = false;
    thumb.classList.remove('is-dragging');
    document.body.style.userSelect = '';
    // Restore smooth scrolling after drag ends
    slider.style.scrollBehavior = '';
  }

  // Click on track to jump to position
  function onTrackClick(e) {
    if (e.target === thumb) return;
    var trackRect = track.getBoundingClientRect();
    var clickX = e.clientX - trackRect.left;
    var trackWidth = trackRect.width;
    var thumbWidth = thumb.offsetWidth;
    var scrollableWidth = slider.scrollWidth - slider.clientWidth;

    // Center the thumb on click position
    var targetThumbCenter = clickX;
    var targetThumbLeft = targetThumbCenter - thumbWidth / 2;
    var trackScrollableWidth = trackWidth - thumbWidth;
    if (trackScrollableWidth <= 0) return;
    var scrollPosition = targetThumbLeft / trackScrollableWidth * scrollableWidth;
    slider.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    });
  }
  thumb.addEventListener('mousedown', onMouseDown);
  document.addEventListener('mousemove', onMouseMove);
  document.addEventListener('mouseup', onMouseUp);
  track.addEventListener('click', onTrackClick);

  // Touch support
  function onTouchStart(e) {
    isDragging = true;
    startX = e.touches[0].clientX;
    startScrollLeft = slider.scrollLeft;
    thumb.classList.add('is-dragging');
    // Disable smooth scrolling during drag for immediate response
    slider.style.scrollBehavior = 'auto';
    e.preventDefault();
  }
  function onTouchMove(e) {
    if (!isDragging) return;
    var trackRect = track.getBoundingClientRect();
    var trackWidth = trackRect.width;
    var thumbWidth = thumb.offsetWidth;
    var scrollableWidth = slider.scrollWidth - slider.clientWidth;
    var deltaX = e.touches[0].clientX - startX;
    var trackScrollableWidth = trackWidth - thumbWidth;
    if (trackScrollableWidth <= 0) return;
    var scrollDelta = deltaX / trackScrollableWidth * scrollableWidth;
    slider.scrollLeft = startScrollLeft + scrollDelta;
  }
  function onTouchEnd() {
    if (!isDragging) return;
    isDragging = false;
    thumb.classList.remove('is-dragging');
    // Restore smooth scrolling after drag ends
    slider.style.scrollBehavior = '';
  }
  thumb.addEventListener('touchstart', onTouchStart, {
    passive: false
  });
  document.addEventListener('touchmove', onTouchMove, {
    passive: true
  });
  document.addEventListener('touchend', onTouchEnd);
}

/***********************
 ***********************
 *** Oppot Slider ***
 ***********************
 ***********************/
var OppotSliderSelector = ".js-oppot-slider";
var OppotSliderAttributes = {
  slidesToShow: 4,
  slidesToScroll: 1,
  grabCursor: true,
  dots: false,
  arrows: false,
  rows: 0,
  speed: 150,
  swipeToSlide: true,
  infinite: false,
  draggable: true,
  swipe: true,
  touchMove: true,
  responsive: [{
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 3
    }
  }, {
    breakpoint: mq.sm,
    settings: {
      slidesToShow: 2.5
    }
  }, {
    breakpoint: mq.xs,
    settings: {
      slidesToShow: 2.5
    }
  }]
};

// Init the slider
function initOppotSlider() {
  // Remove slick if it was previously initialized
  var $slider = $(OppotSliderSelector);
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }
  // Native scrolling is handled by CSS
}

/***************************
 ***************************
 ***  Drawer Crosssells  ***
 ***************************
 ***************************/
var DrawerCrosssellsSelector = ".js-drawer-crosssells";

// Init the slider with native horizontal scroll and custom scrollbar
function initDrawerCrosssels() {
  initNativeHorizontalSlider({
    sliderSelector: DrawerCrosssellsSelector,
    wrapperSelector: ".drawer-crosssells-slider-wrapper",
    trackClass: "drawer-crosssells-scrollbar-track",
    thumbClass: "drawer-crosssells-scrollbar-thumb"
  });
}

/********************************
 ********************************
 ***  Product Page Crosssells ***
 ********************************
 ********************************/
var ProductCrosssellsSelector = ".js-product-crosssells";

// Init the slider with native horizontal scroll and custom scrollbar
function initProductCrosssells() {
  initNativeHorizontalSlider({
    sliderSelector: ProductCrosssellsSelector,
    wrapperSelector: ".product-crosssells-slider-wrapper",
    trackClass: "product-crosssells-scrollbar-track",
    thumbClass: "product-crosssells-scrollbar-thumb"
  });
}

/***********************
 ***********************
 ***  Home Hero USP  ***
 ***********************
 ***********************/
var HomeHeroUspSelector = ".js-home-hero-usp-slider";
var HomeHeroUspAttributes = {
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  rows: 1,
  infinite: false,
  responsive: [{
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2,
      dots: true,
      infinite: true
    }
  }, {
    breakpoint: mq.sm,
    settings: {
      slidesToShow: 1,
      arrows: false,
      dots: false,
      infinite: true,
      centerMode: false,
      autoplay: true,
      autoplaySpeed: 3000
    }
  }]
};
// Init the slider
function initHomeHeroUsp() {
  $(HomeHeroUspSelector).slick(HomeHeroUspAttributes);
}

/****************************
 ****************************
 *** Home Products Slider ***
 ****************************
 ****************************/
var HomeProductsSliderSelector = ".js-home-products-slider";
function initNativeHorizontalSlider(_ref) {
  var sliderSelector = _ref.sliderSelector,
    wrapperSelector = _ref.wrapperSelector,
    trackClass = _ref.trackClass,
    thumbClass = _ref.thumbClass;
  var slider = document.querySelector(sliderSelector);
  if (!slider) return;
  if ($(slider).hasClass("slick-initialized")) {
    $(slider).slick("unslick");
  }
  var wrapper = slider.closest(wrapperSelector);
  if (!wrapper) return;
  var track = wrapper.querySelector(".".concat(trackClass));
  if (!track) {
    track = document.createElement("div");
    track.className = trackClass;
    wrapper.appendChild(track);
  }
  var thumb = track.querySelector(".".concat(thumbClass));
  if (!thumb) {
    thumb = document.createElement("div");
    thumb.className = thumbClass;
    track.appendChild(thumb);
  }
  function updateThumb() {
    var scrollWidth = slider.scrollWidth;
    var clientWidth = slider.clientWidth;
    var scrollLeft = slider.scrollLeft;
    if (scrollWidth <= clientWidth) {
      track.style.opacity = "0";
      return;
    }
    track.style.opacity = "1";
    var thumbWidth = clientWidth / scrollWidth * 100;
    var maxScroll = scrollWidth - clientWidth;
    var thumbLeft = maxScroll <= 0 ? 0 : scrollLeft / maxScroll * (100 - thumbWidth);
    thumb.style.width = "".concat(thumbWidth, "%");
    thumb.style.left = "".concat(thumbLeft, "%");
  }
  if (!slider.dataset.nativeSliderInit) {
    slider.addEventListener("scroll", updateThumb, {
      passive: true
    });
    window.addEventListener("resize", updateThumb);
    slider.dataset.nativeSliderInit = "true";
  }

  // Enable drag functionality on the scrollbar
  enableScrollbarDrag(slider, track, thumb);
  updateThumb();
  setTimeout(updateThumb, 100);
  setTimeout(updateThumb, 400);
}
function initHomeProductsSlider() {
  initNativeHorizontalSlider({
    sliderSelector: HomeProductsSliderSelector,
    wrapperSelector: ".home-products-slider-wrapper",
    trackClass: "home-products-scrollbar-track",
    thumbClass: "home-products-scrollbar-thumb"
  });
}

/************************
 ************************
 *** Home Sale Slider ***
 ************************
 ************************/
var HomeSaleSliderSelector = ".js-home-sale-slider";
function initHomeSaleSlider() {
  initNativeHorizontalSlider({
    sliderSelector: HomeSaleSliderSelector,
    wrapperSelector: ".home-sale-slider-wrapper",
    trackClass: "home-sale-scrollbar-track",
    thumbClass: "home-sale-scrollbar-thumb"
  });
}

/****************************
 ****************************
 *** Home Category Slider ***
 ****************************
 ****************************/
var HomeCategorySliderSelector = ".js-home-category-slider";
var HomeCategorySliderAttributes = {
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  rows: 0,
  responsive: [{
    breakpoint: mq.xxl,
    settings: {
      slidesToShow: 4
    }
  }, {
    breakpoint: mq.xl,
    settings: {
      slidesToShow: 3,
      infinite: false
    }
  }, {
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2,
      infinite: false
    }
  }, {
    breakpoint: mq.sm,
    settings: {
      slidesToShow: 1.25,
      arrows: true,
      infinite: false,
      prevArrow: $(".js-home-sale-slider-prev"),
      nextArrow: $(".js-home-sale-slider-next")
    }
  }]
};

// Init the slider
function initHomeCategorySlider() {
  $(HomeCategorySliderSelector).slick(HomeCategorySliderAttributes);
}

/************************
 ************************
 *** Home News Slider ***
 ************************
 ************************/
var HomeNewsSliderSelector = ".js-home-news-slider";
var HomeNewsSliderAttributes = {
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2
    }
  }, {
    breakpoint: mq.sm,
    settings: {
      slidesToShow: 1.1,
      arrows: true,
      infinite: false,
      prevArrow: $(".js-home-news-slider-prev"),
      nextArrow: $(".js-home-news-slider-next")
    }
  }]
};

// Init the slider
function initHomeNewsSlider() {
  $(HomeNewsSliderSelector).slick(HomeNewsSliderAttributes);
}

/*********************
 *********************
 *** Upsell Slider ***
 *********************
 *********************/
// Original Upsell Slider for desktop
var UpsellSliderSelector = ".js-upsell-slider";
var UpsellSliderAttributes = {
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  focusOnSelect: false,
  arrows: false,
  rows: 0,
  responsive: [{
    breakpoint: mq.xxxl,
    settings: {
      slidesToShow: 4
    }
  }, {
    breakpoint: mq.xl,
    settings: {
      slidesToShow: 3
    }
  }, {
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2.5
    }
  }, {
    breakpoint: mq.md,
    settings: "unslick" // Disable Slick on mobile
  }]
};

// Init the slider
function initUpsellSlider() {
  var upsellSliders = document.querySelectorAll(UpsellSliderSelector);
  upsellSliders.forEach(function (slider) {
    if (slider.classList.contains('js-related-products-slider')) {
      return;
    }
    if (!$(slider).hasClass('slick-initialized')) {
      $(slider).slick(UpsellSliderAttributes);
    }
  });
}

// Horizontal scroll for related products (all screen sizes)
function initRelatedProductsSlider() {
  var slider = document.querySelector('.js-related-products-slider');
  if (!slider) return;

  // Skip if already initialized
  if (slider.dataset.relatedSliderInit) return;
  slider.dataset.relatedSliderInit = 'true';

  // Remove Slick slider if it's initialized (to use native scroll on all screens)
  if ($(slider).hasClass('slick-initialized')) {
    $(slider).slick('unslick');
  }
  var wrapper = slider.closest('.related-products-slider-wrapper');
  if (!wrapper) return;

  // Remove any existing track to start fresh
  var existingTrack = wrapper.querySelector('.related-products-scrollbar-track');
  if (existingTrack) {
    existingTrack.remove();
  }

  // Create track and thumb
  var track = document.createElement('div');
  track.className = 'related-products-scrollbar-track';
  var thumb = document.createElement('div');
  thumb.className = 'related-products-scrollbar-thumb';
  track.appendChild(thumb);
  wrapper.appendChild(track);

  // Update scrollbar thumb
  function updateScrollbar() {
    var scrollLeft = slider.scrollLeft;
    var scrollWidth = slider.scrollWidth;
    var clientWidth = slider.clientWidth;
    if (scrollWidth <= clientWidth) {
      track.style.display = 'none';
      return;
    }
    track.style.display = 'block';
    var thumbWidth = clientWidth / scrollWidth * 100;
    var maxScroll = scrollWidth - clientWidth;
    var thumbLeft = scrollLeft / maxScroll * (100 - thumbWidth);
    thumb.style.width = thumbWidth + '%';
    thumb.style.left = thumbLeft + '%';
  }

  // Event listeners
  slider.addEventListener('scroll', updateScrollbar);
  window.addEventListener('resize', updateScrollbar);

  // Enable drag functionality on the scrollbar
  enableScrollbarDrag(slider, track, thumb);

  // Initial update
  updateScrollbar();
  setTimeout(updateScrollbar, 100);
  setTimeout(updateScrollbar, 500);
}

/******************************
 ******************************
 *** Layout Products Slider ***
 ******************************
 ******************************/
var LayoutProductsSliderSelector = ".js-layout-products";
var LayoutProductsSliderAttributes = {
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  focusOnSelect: false,
  arrows: false,
  rows: 0,
  responsive: [{
    breakpoint: mq.xxxl,
    settings: {
      slidesToShow: 4
    }
  }, {
    breakpoint: mq.xl,
    settings: {
      slidesToShow: 3
    }
  }, {
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2.5,
      arrows: true,
      infinite: false,
      prevArrow: $(".js-layout-products-prev"),
      nextArrow: $(".js-layout-products-next")
    }
  }, {
    breakpoint: mq.md,
    settings: {
      slidesToShow: 2,
      arrows: true,
      prevArrow: $(".js-layout-products-prev"),
      nextArrow: $(".js-layout-products-next")
    }
  }]
};

// Init the slider
function initLayoutProductsSlider() {
  $(LayoutProductsSliderSelector).slick(LayoutProductsSliderAttributes);
}

/********************************
 ********************************
 *** Product Hero Main Slider ***
 ********************************
 ********************************/
var ProductHeroMainSliderSelector = ".js-product-hero-main-slider";
var ProductHeroMainSliderAttributes = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  rows: 0,
  infinite: false
};
function initProductHeroMainSlider() {
  $(ProductHeroMainSliderSelector).slick(ProductHeroMainSliderAttributes);

  // Sync nav slider with main slider
  var mainSlider = document.querySelector(ProductHeroMainSliderSelector);
  if (mainSlider) {
    $(mainSlider).on('afterChange', function (event, slick, currentSlide) {
      // Update active nav slide
      var navSlides = document.querySelectorAll('.product-hero-main-nav__slide');
      navSlides.forEach(function (slide, index) {
        if (index === currentSlide) {
          slide.classList.add('active');
        } else {
          slide.classList.remove('active');
        }
      });
    });
  }
}
function goToSlide(index) {
  $(ProductHeroMainSliderSelector).slick('slickGoTo', index);
}

/****************************
 ****************************
 *** Product Hero Main Nav ***
 ****************************
 ****************************/
var ProductHeroMainNavSelector = ".js-product-hero-main-nav";
var ProductHeroMainNavAttributes = {
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: ".js-product-hero-main-slider",
  dots: false,
  focusOnSelect: true,
  arrows: false,
  rows: 0,
  responsive: [{
    breakpoint: 992,
    settings: {
      slidesToShow: 2,
      vertical: true,
      verticalSwiping: true
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 2,
      vertical: true,
      verticalSwiping: true,
      arrows: false,
      infinite: false
    }
  }]
};
function initProductHeroMainNav() {
  // Remove Slick Slider, use native horizontal scroll
  var navSlider = document.querySelector(ProductHeroMainNavSelector);
  if (navSlider) {
    // Un-slick if already initialized
    if ($(navSlider).hasClass('slick-initialized')) {
      $(navSlider).slick('unslick');
    }

    // Initialize scrollbar thumb
    initProductNavScrollbarThumb();

    // Handle click on nav slides to sync with main slider
    var slides = navSlider.querySelectorAll('.product-hero-main-nav__slide');

    // Set first slide as active by default
    if (slides.length > 0) {
      slides[0].classList.add('active');
    }
    slides.forEach(function (slide, index) {
      slide.addEventListener('click', function () {
        // Remove active class from all slides
        slides.forEach(function (s) {
          return s.classList.remove('active');
        });
        // Add active class to clicked slide
        slide.classList.add('active');

        // Check if mobile (vertical layout)
        var isMobile = window.matchMedia('(max-width: 991.98px)').matches;

        // Scroll slide into view
        if (isMobile) {
          // Vertical scroll on mobile
          slide.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        } else {
          // Horizontal scroll on desktop
          slide.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }

        // Sync with main slider if it exists
        var mainSlider = document.querySelector('.js-product-hero-main-slider');
        if (mainSlider && $(mainSlider).hasClass('slick-initialized')) {
          $(mainSlider).slick('slickGoTo', index);
        }
      });
    });
  }
}

// Initialize scrollbar thumb for product nav slider
function initProductNavScrollbarThumb() {
  var navSlider = document.querySelector('.js-product-hero-main-nav');
  var scrollbarTrack = document.querySelector('.product-hero-main-nav-scrollbar-track');
  if (!navSlider || !scrollbarTrack) return;

  // Check if mobile (vertical layout)
  function isMobile() {
    return window.matchMedia('(max-width: 991.98px)').matches;
  }

  // Create thumb element
  var thumb = scrollbarTrack.querySelector('.product-hero-main-nav-scrollbar-thumb');
  if (!thumb) {
    thumb = document.createElement('div');
    thumb.className = 'product-hero-main-nav-scrollbar-thumb';
    scrollbarTrack.appendChild(thumb);
  }

  // Update thumb position and size
  function updateThumb() {
    // Hide thumb on mobile (vertical layout)
    if (isMobile()) {
      thumb.style.display = 'none';
      return;
    }
    var containerWidth = navSlider.offsetWidth;
    var scrollWidth = navSlider.scrollWidth;
    var scrollLeft = navSlider.scrollLeft;
    if (scrollWidth <= containerWidth) {
      thumb.style.display = 'none';
      return;
    }
    thumb.style.display = 'block';
    var thumbWidth = containerWidth / scrollWidth * 100;
    var thumbLeft = scrollLeft / (scrollWidth - containerWidth) * (100 - thumbWidth);
    thumb.style.width = thumbWidth + '%';
    thumb.style.left = thumbLeft + '%';
  }

  // Update on scroll
  navSlider.addEventListener('scroll', updateThumb);

  // Update on resize
  var resizeObserver = new ResizeObserver(updateThumb);
  resizeObserver.observe(navSlider);

  // Listen for window resize to handle mobile/desktop switch
  window.addEventListener('resize', updateThumb);

  // Enable drag functionality on the scrollbar (desktop only)
  enableScrollbarDrag(navSlider, scrollbarTrack, thumb);

  // Initial update
  updateThumb();

  // Update after a short delay to ensure content is loaded
  setTimeout(updateThumb, 100);
  setTimeout(updateThumb, 500);
}

// Sync thumbnail column height with main image on mobile
function syncThumbnailHeight() {
  var mainSlider = document.querySelector('.product-hero-main-slider');
  var navSlider = document.querySelector('.js-product-hero-main-nav');
  if (!mainSlider || !navSlider) return;
  function isMobile() {
    return window.matchMedia('(max-width: 991.98px)').matches;
  }
  function updateHeight() {
    if (isMobile()) {
      var mainHeight = mainSlider.offsetHeight;
      if (mainHeight > 0) {
        navSlider.style.maxHeight = mainHeight + 'px';
      }
    } else {
      navSlider.style.maxHeight = '';
    }
  }

  // Update on resize
  window.addEventListener('resize', updateHeight);

  // Initial update
  updateHeight();

  // Update after images load
  var images = mainSlider.querySelectorAll('img');
  images.forEach(function (img) {
    if (img.complete) {
      updateHeight();
    } else {
      img.addEventListener('load', updateHeight);
    }
  });

  // Update after short delays
  setTimeout(updateHeight, 100);
  setTimeout(updateHeight, 300);
  setTimeout(updateHeight, 500);
}

/********************************
 ********************************
 *** Product Hero Main Slider ***
 ********************************
 ********************************/
var HomeHeroAsideMobileSelector = ".js-home-hero-aside-mobile";
var HomeHeroAsideMobileAttributes = {
  slidesToShow: 1.5,
  slidesToScroll: 1,
  mobileFirst: true,
  arrows: false,
  dots: false,
  infinite: false
};
function initHomeHeroAsideMobileSlider() {
  $(HomeHeroAsideMobileSelector).slick(HomeHeroAsideMobileAttributes);
}
function destroyHomeHeroAsideMobileSlider() {
  if ($(HomeHeroAsideMobileSelector).hasClass("slick-initialized")) {
    $(HomeHeroAsideMobileSelector).slick("unslick");
  }
}

// Init all sliders
initHomeHeroUsp();
initDrawerCrosssels();
initProductCrosssells();
initHomeProductsSlider();
initHomeSaleSlider();
initHomeCategorySlider();
initHomeNewsSlider();
initUpsellSlider();
initRelatedProductsSlider();
initLayoutProductsSlider();
initProductHeroMainSlider();
initProductHeroMainNav();
syncThumbnailHeight();

// Re init function
function reInitSliders() {
  // Unset the slick of all .slick-initialized
  $(".slick-initialized").slick("unslick");

  // Re init all sliders
  initHomeHeroUsp();
  initDrawerCrosssels();
  initProductCrosssells();
  initHomeProductsSlider();
  initHomeSaleSlider();
  initHomeCategorySlider();
  initHomeNewsSlider();
  initUpsellSlider();
  initRelatedProductsSlider();
  initLayoutProductsSlider();
  initProductHeroMainSlider();
  initProductHeroMainNav();
  syncThumbnailHeight();

  // This is the exceptional version:
  initOppotSlider();
  initColorVariantSlider();
}
var screenWidth = $(window).width();

// Debounce function to limit the frequency of reInitSliders calls
var resizeTimeout;
function debounceReInitSliders() {
  // If the width is the same, don't reInit
  if (screenWidth === $(window).width()) {
    return;
  }
  screenWidth = $(window).width();
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function () {
    reInitSliders();
  }, 200); // Adjust the delay as needed (in milliseconds)
}

// Add event listeners for resize and orientation change
window.addEventListener("resize", debounceReInitSliders);
window.addEventListener("orientationchange", debounceReInitSliders);
window.addEventListener("variationchange", function (e) {
  return goToSlide(e.detail.index);
});

// Fix the slider with the oppot values
function initOppotConfigurator() {
  // Order divs first
  var $slider = $(".js-oppot-slider");
  var $slides = $(".js-oppot-slider>div");

  // Hide slider during DOM manipulation to prevent flicker
  $slider.css('visibility', 'hidden');
  var uniqueVariations = [];
  $slides.sort(function (a, b) {
    var orderA = $(a).data("order");
    var orderB = $(b).data("order");

    // First sort by data-order
    if (orderA !== orderB) {
      return orderA - orderB;
    }

    // If data-order is the same, sort by data-suborder
    var subOrderA = $(a).data("suborder");
    var subOrderB = $(b).data("suborder");
    return subOrderA - subOrderB;
  }).each(function (index, slide) {
    var variation = $(slide).find("input").val();
    if (!uniqueVariations.includes(variation)) {
      uniqueVariations.push(variation);
    } else {
      $slides.splice(index, 1);
    }
  });
  // Empty the slider
  $slider.empty();

  // Separate the view-all card from sortable slides
  var $viewAllCard = $slides.filter('.related-pots--view-all');
  var $potSlides = $slides.not('.related-pots--view-all');

  // Only show first 3 pots, hide the rest
  $potSlides.each(function (index, slide) {
    if (index < 3) {
      $slider.append(slide);
    } else {
      $(slide).hide();
      $slider.append(slide);
    }
  });

  // Always place view-all card after the visible pots
  if ($viewAllCard.length) {
    $slider.children('.related-pots:not(.related-pots--view-all)').filter(':visible').last().after($viewAllCard);
  }

  // Show slider after DOM manipulation is complete
  $slider.css('visibility', 'visible');

  // On mobile, enable horizontal scrolling by default
  if (window.innerWidth < 992) {
    $slider.css('overflow-x', 'scroll');
    $slider.closest('.oppot-slider-wrapper').find('.oppot-scrollbar-track').css('display', 'block');
  }

  // Click handler: reveal all hidden pots and remove the view-all card
  $slider.on('click', '.js-view-all-pots', function () {
    $(this).remove();
    $slider.children('.related-pots').show();
    // Enable horizontal scrolling now that all pots are visible
    $slider.addClass('is-scrollable');
    $slider.css('overflow-x', 'scroll');
    $slider.closest('.oppot-slider-wrapper').find('.oppot-scrollbar-track').css('display', 'block');
    initOppotScrollbarThumb();
  });

  // Now init the configurator
  if (document.getElementById("find_my_pot_configurator")) {
    initOppotSlider();
    new _find_my_pot__WEBPACK_IMPORTED_MODULE_1__.PotFinder();
  }
  initOppotScrollbarThumb();
}

// Load pots beyond Shopify's 50-product-per-collection Liquid limit via the Section
// Rendering API, injecting them into the slider BEFORE the configurator initialises so
// they get sorted/deduped/revealed and wired to PotFinder exactly like the page-1 pots.
function loadRemainingPots() {
  var $slider = $(".js-oppot-slider");
  if (!$slider.length) return Promise.resolve();
  var total = parseInt($slider.attr("data-pot-total"), 10) || 0;
  if (total <= 50) return Promise.resolve();
  var pages = Math.ceil(total / 50);
  var path = window.location.pathname;
  var requests = [];
  for (var page = 2; page <= pages; page++) {
    requests.push(fetch("".concat(path, "?sections=pot-options&page=").concat(page)).then(function (res) {
      return res.json();
    }).then(function (data) {
      var html = data && data["pot-options"] || "";
      var doc = new DOMParser().parseFromString(html, "text/html");
      doc.querySelectorAll(".related-pots").forEach(function (card) {
        $slider.append(card);
      });
    })["catch"](function () {}));
  }
  return Promise.all(requests);
}
loadRemainingPots().then(initOppotConfigurator);

// Create custom scrollbar thumb that's always visible
function initOppotScrollbarThumb() {
  var slider = document.querySelector('.js-oppot-slider');
  if (!slider) return;
  var wrapper = slider.closest('.oppot-slider-wrapper');
  if (!wrapper) return;

  // Get or create track element
  var track = wrapper.querySelector('.oppot-scrollbar-track');
  if (!track) {
    track = document.createElement('div');
    track.className = 'oppot-scrollbar-track';
    wrapper.appendChild(track);
  }

  // Remove existing thumb if any
  var existingThumb = wrapper.querySelector('.oppot-scrollbar-thumb');
  if (existingThumb) {
    existingThumb.remove();
  }

  // Create thumb element
  var thumb = document.createElement('div');
  thumb.className = 'oppot-scrollbar-thumb';
  track.appendChild(thumb);
  function updateThumb() {
    var scrollWidth = slider.scrollWidth;
    var clientWidth = slider.clientWidth;
    var scrollLeft = slider.scrollLeft;
    var maxScroll = scrollWidth - clientWidth;
    if (maxScroll <= 0) {
      thumb.style.display = 'none';
      return;
    }
    thumb.style.display = 'block';
    var thumbWidth = clientWidth / scrollWidth * 100;
    var thumbLeft = scrollLeft / maxScroll * (100 - thumbWidth);
    thumb.style.width = thumbWidth + '%';
    thumb.style.left = thumbLeft + '%';
  }

  // Update on scroll
  slider.addEventListener('scroll', updateThumb);

  // Update on resize
  var resizeObserver = new ResizeObserver(updateThumb);
  resizeObserver.observe(slider);

  // Enable drag functionality on the scrollbar
  enableScrollbarDrag(slider, track, thumb);

  // Initial update
  updateThumb();

  // Update after a short delay to ensure content is loaded
  setTimeout(updateThumb, 100);
  setTimeout(updateThumb, 500);
}

// Function to reinitialize cart/drawer sliders after cart updates (no screen width check)
function reInitCartSliders() {
  initDrawerCrosssels();
}

/*******************************
 *******************************
 *** Color Variant Slider ***
 *******************************
 *******************************/
var ColorVariantSliderSelector = ".js-color-variant-slider";
function initColorVariantSlider() {
  var slider = document.querySelector(ColorVariantSliderSelector);
  if (!slider) return;

  // Skip if already initialized
  if (slider.dataset.colorSliderInit) return;
  slider.dataset.colorSliderInit = 'true';
  var wrapper = slider.closest('.color-variant-slider-wrapper');
  if (!wrapper) return;

  // Get or create track element
  var track = wrapper.querySelector('.color-variant-scrollbar-track');
  if (!track) {
    track = document.createElement('div');
    track.className = 'color-variant-scrollbar-track';
    wrapper.appendChild(track);
  }

  // Remove existing thumb if any
  var existingThumb = wrapper.querySelector('.color-variant-scrollbar-thumb');
  if (existingThumb) {
    existingThumb.remove();
  }

  // Create thumb element
  var thumb = document.createElement('div');
  thumb.className = 'color-variant-scrollbar-thumb';
  track.appendChild(thumb);
  function updateThumb() {
    var scrollWidth = slider.scrollWidth;
    var clientWidth = slider.clientWidth;
    var scrollLeft = slider.scrollLeft;
    var maxScroll = scrollWidth - clientWidth;
    if (maxScroll <= 0) {
      track.style.opacity = '0';
      return;
    }
    track.style.opacity = '1';
    var thumbWidth = clientWidth / scrollWidth * 100;
    var thumbLeft = scrollLeft / maxScroll * (100 - thumbWidth);
    thumb.style.width = thumbWidth + '%';
    thumb.style.left = thumbLeft + '%';
  }

  // Update on scroll
  slider.addEventListener('scroll', updateThumb, {
    passive: true
  });

  // Update on resize
  window.addEventListener('resize', updateThumb);

  // Enable drag functionality on the scrollbar
  enableScrollbarDrag(slider, track, thumb);

  // Initial update
  updateThumb();
  setTimeout(updateThumb, 100);
  setTimeout(updateThumb, 500);

  // Handle click on color variant to navigate to that variant URL
  var inputs = slider.querySelectorAll('.color-variant__input');
  inputs.forEach(function (input) {
    input.addEventListener('change', function () {
      var url = this.dataset.url;
      if (url) {
        window.location.href = url;
      }
    });
  });
}

// Initialize color variant slider on page load
initColorVariantSlider();

// Export the reInitSliders function


/***/ }),

/***/ "./src/js/toggles.js":
/*!***************************!*\
  !*** ./src/js/toggles.js ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "../../node_modules/.pnpm/jquery@3.7.1/node_modules/jquery/dist/jquery.js");

$(document).on("click", ".js-footer-toggle ", function (e) {
  e.preventDefault();
  $(this).parent().toggleClass("is-active");
  $(this).parent().next("nav").children("ul").stop().slideToggle();
});

// Sluit alle panels
function closeAllPanels() {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeMiniCart)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeLangPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeFilterPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.unlockHTML)();
  $("html").removeClass("show-nav");
  $(".js-header-toggle").removeClass("is-active");
}
$(".js-header-search input").on("input", function () {
  if ($(this).val().length > 0) {
    closeAllPanels();
  }
});
$(document).on("click", ".js-header-toggle", function (e) {
  e.preventDefault();
  $(this).toggleClass("is-active");
  $("html").toggleClass("show-nav");
});

// Close panel when clicking the close button
$(document).on("click", ".js-panel-close", function (e) {
  e.preventDefault();
  $("html").removeClass("show-nav");
  $(".js-header-toggle").removeClass("is-active");
});

// Close panel when clicking the overlay (right side body area)
$(document).on("click", ".js-panel-overlay", function (e) {
  e.preventDefault();
  $("html").removeClass("show-nav");
  $(".js-header-toggle").removeClass("is-active");
});

// Minicart openen/sluiten
$(document).on("click", ".js-cart-toggle", function (e) {
  closeAllPanels(); // Sluit andere panels
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.openMiniCart)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.lockHTML)();
});
$(document).on("click", ".js-minicart-close", function (e) {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeMiniCart)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.unlockHTML)();
});

// Taalpanel openen/sluiten
$(document).on("click", ".js-lang-switch, .js-lang-switch-panel", function (e) {
  closeAllPanels(); // Sluit andere panels
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.openLangPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.lockHTML)();
});
$(document).on("click", ".js-drawer-lang-close", function (e) {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeLangPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.unlockHTML)();
});

// Filterpanel openen/sluiten
$(document).on("click", ".js-header-collection-mobile-filter", function (e) {
  closeAllPanels(); // Sluit andere panels
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.openFilterPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.lockHTML)();
});
$(document).on("click", ".js-drawer-filter-close", function (e) {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeFilterPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.unlockHTML)();
});
$(document).on("click", ".js-collection-filter-toggle", function (e) {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.filterToggle)($(this));
});
$(document).on("click", ".js-show-more", function (e) {
  var readMore = $(this);
  var container = readMore.parent().find(".js-content-container");
  var newHeight = container.find(".colums-2").height();
  if (container.hasClass("is-show")) {
    $(".js-content-container").animate({
      height: 100
    }, 500);
    container.removeClass("is-show");
    $(this).next(span).html("Toon minder");
  } else {
    $(".js-content-container").animate({
      height: newHeight
    }, 500);
    container.addClass("is-show");
    $(this).next(span).html("Toon minder");
  }
});
$(document).on("click", ".js-faq-toggle", function (e) {
  e.preventDefault();
  $(this).toggleClass("is-active");
  $(this).next().stop().slideToggle(300);
});

// ============================================================================
// MOBILE SIDEBAR MENU - UNIFIED RECURSIVE EXPAND/COLLAPSE LOGIC
// ============================================================================
// Rules:
// 1. Click on TEXT (link) -> Navigate to collection page
// 2. Click on ARROW ICON or WHITE SPACE -> Expand/collapse only that item's children
// 3. Expanding a child must NOT affect parent state
// 4. Works for ALL levels (2, 3, 4, 5, 6, etc.)
// ============================================================================

// Helper function to show/hide panel back button
function updatePanelBackButton() {
  var $activeMenu = $(".panel .mega-menu.is-active");
  var $backButton = $(".panel__back");
  if ($activeMenu.length) {
    $backButton.addClass("is-visible");
  } else {
    $backButton.removeClass("is-visible");
  }
}

// Level 1: Main menu items with mega-menu (li.has-megamenu)
// Chevron icon click -> toggle mega-menu panel
$(document).on("click", ".panel .has-megamenu > i.fa-chevron-down", function (e) {
  e.preventDefault();
  e.stopPropagation();
  $(this).toggleClass("is-active");
  $(this).siblings(".mega-menu").toggleClass("is-active");
  updatePanelBackButton();
});

// Level 1: Main menu item white space click -> toggle mega-menu panel
$(document).on("click", ".panel .has-megamenu", function (e) {
  // Don't handle if click was on the link (let it navigate)
  if ($(e.target).is("a") || $(e.target).closest("a").length) {
    return;
  }
  // Don't handle if click was on chevron (handled above)
  if ($(e.target).is("i.fa-chevron-down")) {
    return;
  }
  // Don't handle if click was inside mega-menu content
  if ($(e.target).closest(".mega-menu").length) {
    return;
  }
  e.preventDefault();
  e.stopPropagation();
  var $chevron = $(this).children("i.fa-chevron-down");
  $chevron.toggleClass("is-active");
  $(this).children(".mega-menu").toggleClass("is-active");
  updatePanelBackButton();
});

// Panel header back button click -> close active mega-menu
$(document).on("click", ".js-panel-back", function (e) {
  e.preventDefault();
  e.stopPropagation();

  // Find and close the active mega-menu
  var $activeMenu = $(".panel .mega-menu.is-active");
  $activeMenu.removeClass("is-active");

  // Reset the parent chevron icon
  var $parentLi = $activeMenu.closest("li.has-megamenu");
  $parentLi.children("i.fa-chevron-down").removeClass("is-active");

  // Hide the back button
  $(this).removeClass("is-visible");
});

// ============================================================================
// UNIFIED HANDLER: All menu items with expandable children (Level 2+)
// ============================================================================

// Helper function to toggle a menu item's submenu
function toggleMenuItemSubmenu($menuItem) {
  // Find the arrow icon (direct child only)
  var $arrow = $menuItem.children(".mega-menu__arrow");
  if (!$arrow.length) {
    return false; // No children to expand
  }

  // Toggle arrow state
  $arrow.toggleClass("is-active");

  // Find and toggle the submenu (direct child only)
  var $submenu = $menuItem.children(".mega-menu__submenu--inline, .mega-menu__column-submenu").first();
  if ($submenu.length) {
    $submenu.slideToggle(300);
    return true;
  }
  return false;
}

// Helper function to find the closest menu item that should handle this click
function findTargetMenuItem($target) {
  // Find the closest menu item wrapper that contains this target
  // We need to find the INNERMOST menu item that the click is directly on

  // Check if we clicked directly on a menu item container (not inside a nested submenu)
  var $closestWrapper = $target.closest(".mega-menu__item-wrapper, .mega-menu__submenu-item");
  if (!$closestWrapper.length) {
    return null;
  }

  // Check if the target is inside a nested submenu OF this wrapper
  // If so, the click should be handled by a deeper nested item, not this one
  var $submenuOfWrapper = $closestWrapper.children(".mega-menu__submenu--inline, .mega-menu__column-submenu");
  if ($submenuOfWrapper.length && $target.closest($submenuOfWrapper).length) {
    // The click is inside a child submenu, so this wrapper should not handle it
    // The event will bubble to the correct nested item
    return null;
  }
  return $closestWrapper;
}

// Arrow icon click handler - works for ALL levels
$(document).on("click", ".mega-menu__arrow", function (e) {
  e.preventDefault();
  e.stopPropagation();
  var $arrow = $(this);
  var $menuItem = $arrow.parent();

  // Toggle arrow state
  $arrow.toggleClass("is-active");

  // Find and toggle the submenu (direct child of parent only)
  var $submenu = $menuItem.children(".mega-menu__submenu--inline, .mega-menu__column-submenu").first();
  if ($submenu.length) {
    $submenu.slideToggle(300);
  }
});

// White space click handler for Level 2 items (.mega-menu__item-wrapper)
$(document).on("click", ".mega-menu__item-wrapper", function (e) {
  var $target = $(e.target);

  // Don't handle if clicking on a link
  if ($target.is("a") || $target.closest("a").length) {
    return;
  }

  // Don't handle if clicking on arrow icon (separate handler)
  if ($target.hasClass("mega-menu__arrow")) {
    return;
  }

  // Check if this is the correct wrapper to handle the click
  var $targetMenuItem = findTargetMenuItem($target);
  if (!$targetMenuItem || !$targetMenuItem.is(this)) {
    return; // Let event bubble to correct handler
  }

  // Check if this item has children
  if (!$(this).children(".mega-menu__arrow").length) {
    return;
  }
  e.preventDefault();
  e.stopPropagation();
  toggleMenuItemSubmenu($(this));
});

// White space click handler for Level 3+ items (.mega-menu__submenu-item)
$(document).on("click", ".mega-menu__submenu-item", function (e) {
  var $target = $(e.target);

  // Don't handle if clicking on a link
  if ($target.is("a") || $target.closest("a").length) {
    return;
  }

  // Don't handle if clicking on arrow icon (separate handler)
  if ($target.hasClass("mega-menu__arrow")) {
    return;
  }

  // Check if this is the correct item to handle the click
  var $targetMenuItem = findTargetMenuItem($target);
  if (!$targetMenuItem || !$targetMenuItem.is(this)) {
    return; // Let event bubble to correct handler
  }

  // Check if this item has children
  if (!$(this).children(".mega-menu__arrow").length) {
    return;
  }
  e.preventDefault();
  e.stopPropagation();
  toggleMenuItemSubmenu($(this));
});
$(document).on("click", ".js-megamenu-return", function (e) {
  e.preventDefault();
  e.stopPropagation();

  // Find and close the mega-menu
  var $megaMenu = $(this).closest(".mega-menu");
  $megaMenu.removeClass("is-active");

  // Find the parent li.has-megamenu and reset its chevron icon
  var $parentLi = $megaMenu.closest("li.has-megamenu");
  $parentLi.children("i.fa-chevron-down").removeClass("is-active");

  // Also hide the panel back button
  updatePanelBackButton();
});
$(document).on("click", ".js-child-toggle i", function (e) {
  e.preventDefault();
  $(this).parent().toggleClass("is-active");
  $(this).parent().next("ul").slideToggle();
});

// Plantsome-style navigation: Left-to-right submenu hover behavior
$(document).ready(function () {
  // Desktop: Show submenu on parent hover (Level 2 items WITH children)
  $(document).on("mouseenter", ".js-submenu-trigger", function () {
    var submenuId = $(this).data("submenu");
    var $megaMenu = $(this).closest(".mega-menu");

    // Remove active state from all parents and hide all submenus
    $megaMenu.find(".mega-menu__parent").removeClass("is-active");
    $megaMenu.find(".mega-menu__submenu").removeClass("is-visible");

    // Also hide all dynamic columns when switching Level 2 categories
    $megaMenu.find(".mega-menu__child").removeClass("is-active");
    $megaMenu.find(".mega-menu__dynamic-col").removeClass("is-visible");

    // Add active state to current parent and show its submenu
    $(this).addClass("is-active");
    $megaMenu.find('[data-submenu-id="' + submenuId + '"]').addClass("is-visible");
  });

  // Desktop: Hide submenus when hovering Level 2 items WITHOUT children
  $(document).on("mouseenter", ".mega-menu__parent.no-children", function () {
    var $megaMenu = $(this).closest(".mega-menu");

    // Remove active state from all parents and hide all submenus
    $megaMenu.find(".mega-menu__parent").removeClass("is-active");
    $megaMenu.find(".mega-menu__submenu").removeClass("is-visible");

    // Also hide all dynamic columns
    $megaMenu.find(".mega-menu__child").removeClass("is-active");
    $megaMenu.find(".mega-menu__dynamic-col").removeClass("is-visible");

    // Add active state to current item (no submenu to show)
    $(this).addClass("is-active");
  });

  // Show first submenu by default when mega menu opens
  $(document).on("mouseenter", ".has-megamenu", function () {
    var $megaMenu = $(this).find(".mega-menu");
    var $firstTrigger = $megaMenu.find(".js-submenu-trigger").first();
    if ($firstTrigger.length) {
      var submenuId = $firstTrigger.data("submenu");
      $firstTrigger.addClass("is-active");
      $megaMenu.find('[data-submenu-id="' + submenuId + '"]').addClass("is-visible");
    }
  });

  // Reset states when leaving mega menu
  $(document).on("mouseleave", ".has-megamenu", function () {
    var $megaMenu = $(this).find(".mega-menu");
    $megaMenu.find(".mega-menu__parent").removeClass("is-active");
    $megaMenu.find(".mega-menu__submenu").removeClass("is-visible");
    $megaMenu.find(".mega-menu__child").removeClass("is-active");
    $megaMenu.find(".mega-menu__dynamic-col").removeClass("is-visible");
  });

  // Desktop: Show dynamic column on hover (generic for any level 4+)
  $(document).on("mouseenter", ".js-column-trigger", function () {
    var $link = $(this);
    var columnTarget = $link.data("column-target");
    var columnLevel = $link.data("column-level");
    var $megaMenu = $link.closest(".mega-menu");
    var $dynamicColumns = $megaMenu.find(".mega-menu__dynamic-columns");

    // Check if trigger is in secondary column (Level 3 item) or in a dynamic column (Level 4+ item)
    var $parentCol = $link.closest(".mega-menu__dynamic-col");
    var isInDynamicCol = $parentCol.length > 0;
    if (isInDynamicCol) {
      // Hovering on a Level 4+ item - hide only columns DEEPER than current
      var parentLevel = $parentCol.data("column-level");
      $dynamicColumns.find(".mega-menu__dynamic-col").each(function () {
        var thisLevel = $(this).data("column-level");
        if (thisLevel > parentLevel) {
          $(this).removeClass("is-visible");
          $(this).find(".mega-menu__child").removeClass("is-active");
        }
      });
    } else {
      // Hovering on a Level 3 item in secondary column - hide ALL dynamic columns
      $dynamicColumns.find(".mega-menu__dynamic-col").removeClass("is-visible");
      $dynamicColumns.find(".mega-menu__child").removeClass("is-active");
    }

    // Remove active state from siblings at same level
    $link.closest(".mega-menu__submenu-list").find(".mega-menu__child").removeClass("is-active");

    // Show target column and add active state
    $link.addClass("is-active");
    $dynamicColumns.find('[data-column-id="' + columnTarget + '"]').addClass("is-visible");
  });

  // Hide dynamic columns when hovering on an item WITHOUT children at any level
  $(document).on("mouseenter", ".mega-menu__dynamic-col .mega-menu__child.no-children", function () {
    var $link = $(this);
    var $megaMenu = $link.closest(".mega-menu");
    var $currentCol = $link.closest(".mega-menu__dynamic-col");
    var currentLevel = $currentCol.data("column-level");
    var $dynamicColumns = $megaMenu.find(".mega-menu__dynamic-columns");

    // Hide columns deeper than current level
    $dynamicColumns.find(".mega-menu__dynamic-col").each(function () {
      var thisLevel = $(this).data("column-level");
      if (thisLevel > currentLevel) {
        $(this).removeClass("is-visible");
        $(this).find(".mega-menu__child").removeClass("is-active");
      }
    });
  });

  // Hide all dynamic columns when hovering on a Level 3 item WITHOUT children
  $(document).on("mouseenter", ".mega-menu__secondary-col .mega-menu__child.no-children", function () {
    var $megaMenu = $(this).closest(".mega-menu");
    var $submenuList = $(this).closest(".mega-menu__submenu-list");

    // Remove active state from all children in the same submenu list
    $submenuList.find(".mega-menu__child").removeClass("is-active");

    // Hide all dynamic columns
    $megaMenu.find(".mega-menu__dynamic-col").removeClass("is-visible");

    // Add active state to current item
    $(this).addClass("is-active");
  });
});
var HOME_CONTENT_COLLAPSED_HEIGHT = 80;
function evaluateHomeContentToggles() {
  $(".js-home-content-toggle").each(function () {
    var $wrapper = $(this);
    var $text = $wrapper.find(".js-home-content-toggle-text");
    if (!$text.length) {
      return;
    }
    var naturalHeight = $text[0].scrollHeight;
    var shouldCollapse = naturalHeight > HOME_CONTENT_COLLAPSED_HEIGHT + 10;
    if (shouldCollapse) {
      $wrapper.addClass("is-collapsible");
    } else {
      $wrapper.removeClass("is-collapsible").addClass("is-expanded");
      $wrapper.find(".js-home-content-toggle-btn").attr("aria-expanded", true);
    }
  });
}
$(document).on("click", ".js-home-content-toggle-btn", function (e) {
  e.preventDefault();
  var $btn = $(this);
  var $wrapper = $btn.closest(".js-home-content-toggle");

  // Skip toggling when text is not collapsible
  if (!$wrapper.hasClass("is-collapsible")) {
    return;
  }
  var isExpanded = $wrapper.toggleClass("is-expanded").hasClass("is-expanded");
  $btn.attr("aria-expanded", isExpanded);
});
evaluateHomeContentToggles();
var homeContentToggleResizeTimer;
$(window).on("resize orientationchange", function () {
  clearTimeout(homeContentToggleResizeTimer);
  homeContentToggleResizeTimer = setTimeout(evaluateHomeContentToggles, 200);
});

// Sticky header on scroll - works on all screen sizes
(function initStickyHeader() {
  var $header = $(".header");
  var $headerMain = $(".header-main");
  var $headerTop = $(".header-top");
  var $headerLeft = $(".js-header-main");
  var $headerRight = $(".js-header-main-right");
  var $search = $(".js-header-search");

  // Exit early if elements don't exist
  if (!$header.length || !$headerMain.length) {
    console.warn("Sticky header: Required elements not found");
    return;
  }

  // Create placeholder element
  var $placeholder = $(".header-placeholder");
  if (!$placeholder.length) {
    $placeholder = $('<div class="header-placeholder"></div>');
    $header.after($placeholder);
  }
  var headerMainHeight = $headerMain.outerHeight() || 80;
  var headerTopHeight = $headerTop.outerHeight() || 0;
  var stickyThreshold = headerTopHeight;
  var isSticky = false;
  var searchMovedToSticky = false;

  // Store original search parent for restoring later
  var $originalSearchParent = null;
  function moveSearchToStickyHeader() {
    var windowWidth = $(window).width();
    // On mobile/tablet (below xl), move search to be between left and right sections
    if (windowWidth < 1200 && $search.length && !searchMovedToSticky) {
      $originalSearchParent = $search.parent();
      // Insert search after the left section so it becomes a flex sibling between left and right
      $headerLeft.after($search);
      searchMovedToSticky = true;
    }
  }
  function restoreSearchPosition() {
    var windowWidth = $(window).width();
    // On mobile/tablet, restore search to original position
    if (windowWidth < 1200 && $search.length && searchMovedToSticky && $originalSearchParent) {
      $originalSearchParent.append($search);
      searchMovedToSticky = false;
    }
  }
  function handleScroll() {
    var scrollTop = $(window).scrollTop();
    var windowWidth = $(window).width();
    // Sticky CSS only applies below xl breakpoint (1200px)
    var isMobileTablet = windowWidth < 1200;

    // Enable sticky on all screen sizes
    if (scrollTop > stickyThreshold && !isSticky) {
      isSticky = true;
      $header.addClass("is-sticky");
      // Only show placeholder on mobile/tablet where header becomes fixed
      if (isMobileTablet) {
        $placeholder.css("height", headerMainHeight).addClass("is-active");
      }
      moveSearchToStickyHeader();
    } else if (scrollTop <= stickyThreshold && isSticky) {
      isSticky = false;
      $header.removeClass("is-sticky");
      $placeholder.removeClass("is-active").css("height", 0);
      restoreSearchPosition();
    }
  }

  // Recalculate heights on resize
  function recalculateHeights() {
    // Temporarily remove sticky to get accurate heights
    var wasSticky = isSticky;
    if (wasSticky) {
      $header.removeClass("is-sticky");
      $placeholder.removeClass("is-active").css("height", 0);
      restoreSearchPosition();
    }
    headerMainHeight = $headerMain.outerHeight() || 80;
    headerTopHeight = $headerTop.outerHeight() || 0;
    stickyThreshold = headerTopHeight;
    if (wasSticky) {
      $header.addClass("is-sticky");
      $placeholder.css("height", headerMainHeight).addClass("is-active");
      moveSearchToStickyHeader();
    }
  }

  // Use passive scroll listener for better performance
  var ticking = false;
  window.addEventListener("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, {
    passive: true
  });

  // Handle resize
  var resizeTimer;
  $(window).on("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      recalculateHeights();
      handleScroll();
    }, 100);
  });

  // Initial check
  handleScroll();
})();

// Sticky collection bar on collection pages (works on all screen sizes)
// Sticky behavior is conditional: stops being sticky once user scrolls past product grid
(function initStickyCollectionBar() {
  var $stickyBar = $(".js-collection-sticky-bar");
  var $filterButton = $(".js-header-collection-mobile-filter").not(".sticky-filter-icon");
  var $stickyFilterIcon = $(".js-sticky-filter-icon");
  var $stickyHeader = $(".header");
  var $filterAside = $(".js-collection-filters-aside");
  var $productGrid = $("#products-grid");

  // Exit if not on collection page or elements don't exist
  if (!$stickyBar.length) {
    return;
  }

  // Check if we're on a search page (Hello Retail or native Shopify search)
  function isSearchPage() {
    // Check URL for search parameters
    var url = window.location.href;
    var pathname = window.location.pathname;

    // Check for /search path or search query parameters
    if (pathname.includes("/search") || url.includes("q=") || url.includes("query=")) {
      return true;
    }

    // Check for Hello Retail search overlay/page elements
    if (document.querySelector('[class*="hello-retail"], [class*="helloretail"], [id*="hello-retail"], [id*="helloretail"], .hr-search, .hr-overlay, [data-hello-retail]')) {
      return true;
    }
    return false;
  }

  // Hide sticky bar on search pages
  function hideOnSearch() {
    if (isSearchPage()) {
      $stickyBar.hide();
      return true;
    }
    $stickyBar.show();
    return false;
  }

  // Initial check - hide if on search page
  if (hideOnSearch()) {
    return;
  }

  // Watch for URL changes (for SPA-like navigation from Hello Retail)
  var lastUrl = window.location.href;
  var urlObserver = new MutationObserver(function () {
    if (window.location.href !== lastUrl) {
      lastUrl = window.location.href;
      hideOnSearch();
    }
  });
  urlObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also listen for popstate (back/forward navigation)
  window.addEventListener("popstate", hideOnSearch);

  // Function to update filter column sticky position (always called on scroll)
  // Note: position: sticky naturally stops sticking when scrolling past its container
  // We just need to dynamically update the "top" value based on header state
  function updateFilterPosition() {
    var windowWidth = $(window).width();
    if (windowWidth < 992 || !$filterAside.length) return; // Only on desktop

    // Get header main element
    var $headerMain = $stickyHeader.find(".header-main");

    // Calculate top offset based on whether header is sticky
    var topOffset;
    if ($stickyHeader.hasClass("is-sticky")) {
      // Header is sticky (fixed at top) - get its actual current height
      var headerMainHeight = $headerMain.length ? $headerMain.outerHeight() : 60;
      topOffset = headerMainHeight + 15;
    } else {
      // Header is not sticky (desktop: sticky header disabled) - use minimal offset
      topOffset = 20;
    }

    // If collection bar is also sticky (and not pinned at bottom), add its height
    if ($stickyBar.hasClass("is-sticky") && !$stickyBar.hasClass("is-pinned-bottom")) {
      topOffset += $stickyBar.outerHeight() || 50;
    }

    // Update the sticky top position and max-height
    $filterAside.css({
      top: topOffset + "px",
      "max-height": "calc(100vh - " + (topOffset + 20) + "px)"
    });
  }

  // Create placeholder element
  var $placeholder = $(".js-collection-sticky-bar-placeholder");
  if (!$placeholder.length) {
    $placeholder = $('<div class="collection-sticky-bar-placeholder"></div>');
    $stickyBar.after($placeholder);
  }
  var barHeight = $stickyBar.outerHeight() || 50;
  var barOffsetTop = $stickyBar.offset() ? $stickyBar.offset().top : 0;
  var barOffsetLeft = $stickyBar.offset() ? $stickyBar.offset().left : 0;
  var barWidth = $stickyBar.outerWidth() || 0;
  var isSticky = false;
  var isPinnedBottom = false; // Track if bar is pinned at product grid bottom

  // Get dynamic header height
  function getStickyHeaderHeight() {
    if ($stickyHeader.hasClass("is-sticky")) {
      var $headerMain = $stickyHeader.find(".header-main");
      return $headerMain.length ? $headerMain.outerHeight() : 0;
    }
    return 0;
  }

  // Get the bottom boundary of the product grid (where sticky should stop)
  function getProductGridBottom() {
    if (!$productGrid.length) {
      return Infinity; // No product grid found, never stop being sticky
    }
    // Get the bottom of the product grid relative to the document
    return $productGrid.offset().top + $productGrid.outerHeight();
  }

  // Set dynamic position for sticky bar
  function updateBarPosition() {
    var headerHeight = getStickyHeaderHeight();
    var windowWidth = $(window).width();
    $stickyBar.css("top", headerHeight + "px");

    // On desktop (lg and up: 992px), also set left position and width to match original
    if (windowWidth >= 992) {
      $stickyBar.css({
        left: barOffsetLeft + "px",
        width: barWidth + "px"
      });
    } else {
      // On mobile, remove inline styles for left/width (CSS handles full width)
      $stickyBar.css({
        left: "",
        width: ""
      });
    }

    // Always update filter position
    updateFilterPosition();
  }

  // Pin the bar at the bottom of the product grid (absolute positioning)
  function pinAtBottom() {
    var productGridBottom = getProductGridBottom();
    var windowWidth = $(window).width();

    // Position absolute relative to document, at product grid bottom minus bar height
    $stickyBar.addClass("is-pinned-bottom");
    $stickyBar.css({
      position: "absolute",
      top: productGridBottom - barHeight + "px",
      left: windowWidth >= 992 ? barOffsetLeft + "px" : "",
      width: windowWidth >= 992 ? barWidth + "px" : ""
    });
  }

  // Restore normal sticky positioning
  function restoreSticky() {
    var headerHeight = getStickyHeaderHeight();
    var windowWidth = $(window).width();
    $stickyBar.removeClass("is-pinned-bottom");
    $stickyBar.css({
      position: "",
      top: headerHeight + "px",
      left: windowWidth >= 992 ? barOffsetLeft + "px" : "",
      width: windowWidth >= 992 ? barWidth + "px" : ""
    });
  }
  function handleScroll() {
    var scrollTop = $(window).scrollTop();
    var windowWidth = $(window).width();

    // On desktop (lg and up: 992px), use CSS sticky - no JS intervention needed
    // Only apply JS sticky logic on mobile/tablet
    if (windowWidth >= 992) {
      // Reset any JS-applied styles on desktop
      if (isSticky || isPinnedBottom) {
        isSticky = false;
        isPinnedBottom = false;
        $stickyBar.removeClass("is-sticky is-pinned-bottom");
        $stickyBar.css({
          position: "",
          top: "",
          left: "",
          width: ""
        });
        $placeholder.removeClass("is-active").css("height", 0);
      }
      // Still update filter position on desktop
      updateFilterPosition();
      return;
    }

    // Mobile/tablet logic below
    var headerHeight = getStickyHeaderHeight();

    // On mobile/tablet - trigger when filter button scrolls out of view
    var triggerOffset = $filterButton.length ? $filterButton.offset().top + $filterButton.outerHeight() : barOffsetTop;

    // Calculate the boundary: where the sticky bar bottom would be vs product grid bottom
    var productGridBottom = getProductGridBottom();
    var stickyBarBottomWhenSticky = scrollTop + headerHeight + barHeight;

    // Should we be in sticky zone at all?
    var inStickyZone = scrollTop > triggerOffset;

    // Should we pin at bottom? (sticky bar would go past product grid)
    var shouldPinAtBottom = stickyBarBottomWhenSticky >= productGridBottom;
    if (!inStickyZone) {
      // Not scrolled enough to be sticky - back to normal flow
      if (isSticky || isPinnedBottom) {
        isSticky = false;
        isPinnedBottom = false;
        $stickyBar.removeClass("is-sticky is-pinned-bottom");
        $stickyBar.css({
          position: "",
          top: "",
          left: "",
          width: ""
        });
        $placeholder.removeClass("is-active").css("height", 0);
      }
    } else if (shouldPinAtBottom) {
      // We're past the product grid - pin at the bottom
      if (!isPinnedBottom) {
        isPinnedBottom = true;
        isSticky = true;
        $stickyBar.addClass("is-sticky");
        $placeholder.css("height", barHeight).addClass("is-active");
        pinAtBottom();
      }
    } else {
      // Normal sticky behavior
      if (!isSticky || isPinnedBottom) {
        isSticky = true;
        isPinnedBottom = false;
        $stickyBar.addClass("is-sticky").removeClass("is-pinned-bottom");
        $placeholder.css("height", barHeight).addClass("is-active");
        restoreSticky();
      } else {
        // Already sticky, just update position in case header changed
        updateBarPosition();
      }
    }

    // Always update filter position on scroll
    updateFilterPosition();
  }

  // Recalculate dimensions on resize
  function recalculateDimensions() {
    var wasSticky = isSticky;
    if (wasSticky) {
      $stickyBar.removeClass("is-sticky is-pinned-bottom");
      $stickyBar.css({
        position: "",
        top: "",
        left: "",
        width: ""
      });
      $placeholder.removeClass("is-active").css("height", 0);
    }

    // Reset filter aside state
    if ($filterAside.length) {
      $filterAside.css({
        top: "",
        "max-height": ""
      });
    }
    barHeight = $stickyBar.outerHeight() || 50;
    barOffsetTop = $stickyBar.offset() ? $stickyBar.offset().top : 0;
    barOffsetLeft = $stickyBar.offset() ? $stickyBar.offset().left : 0;
    barWidth = $stickyBar.outerWidth() || 0;

    // Re-evaluate sticky state after recalculating dimensions
    isSticky = false;
    isPinnedBottom = false;
  }

  // Scroll listener
  var ticking = false;
  window.addEventListener("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, {
    passive: true
  });

  // Resize listener
  var resizeTimer;
  $(window).on("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      recalculateDimensions();
      handleScroll();
    }, 100);
  });

  // Initial check with slight delay to ensure DOM is ready
  setTimeout(function () {
    // Update filter position immediately on load
    updateFilterPosition();
    // Then handle scroll state
    handleScroll();
  }, 100);
})();

// Custom sort dropdown - consistent behavior across all screen sizes
(function initCustomSortDropdown() {
  var $dropdown = $(".js-custom-sort-dropdown");
  var $trigger = $(".js-sort-trigger");
  var $menu = $(".js-sort-menu");
  var $options = $(".js-sort-option");
  var $valueDisplay = $(".js-sort-value");
  var $hiddenSelect = $dropdown.find(".js-sort-by");

  // Exit if elements don't exist
  if (!$dropdown.length || !$trigger.length) {
    return;
  }

  // Toggle dropdown on trigger click
  $trigger.on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $dropdown.toggleClass("is-open");
  });

  // Handle option selection
  $options.on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $option = $(this);
    var value = $option.data("value");
    var text = $option.text().trim();

    // Update visual state
    $options.removeClass("is-selected");
    $option.addClass("is-selected");

    // Update displayed value
    $valueDisplay.text(text);

    // Update hidden select and dispatch native change event
    // (collection-filtering.js uses native addEventListener, not jQuery)
    var selectElement = $hiddenSelect[0];
    if (selectElement) {
      selectElement.value = value;
      selectElement.dispatchEvent(new Event("change", {
        bubbles: true
      }));
    }

    // Close dropdown
    $dropdown.removeClass("is-open");
  });

  // Close dropdown when clicking outside
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".js-custom-sort-dropdown").length) {
      $dropdown.removeClass("is-open");
    }
  });

  // Close dropdown on escape key
  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      $dropdown.removeClass("is-open");
    }
  });
})();

// Collection short description - mobile show more/less toggle
(function initCollectionShortDescriptionToggle() {
  var $container = $(".collection-short-description");
  if (!$container.length) return;
  var $toggle = $container.find(".collection-short-description__toggle");
  if (!$toggle.length) return;
  var $truncated = $container.find(".collection-short-description__truncated");
  var $full = $container.find(".collection-short-description__full");
  var fullText = $full.text().trim();

  // Dynamically truncate: 2 lines on mobile, 1 line on desktop/tablet
  function truncateToLines() {
    // Reset expanded state on resize
    $container.removeClass("is-expanded");
    $full.hide();
    $truncated.show();
    $toggle.css("display", "inline");
    $toggle.find(".toggle-text").text($toggle.data("more"));
    var $text = $container.find(".collection-short-description__text");
    var lineHeight = parseFloat($text.css("line-height"));
    var maxLines = window.innerWidth < 768 ? 2 : 1;
    var maxHeight = lineHeight * maxLines;
    $truncated.text(fullText);

    // Only truncate if text overflows
    if ($text[0].scrollHeight > maxHeight + 1) {
      var low = 0;
      var high = fullText.length;
      while (low < high) {
        var mid = Math.floor((low + high) / 2);
        $truncated.text(fullText.substring(0, mid) + "...\xA0");
        if ($text[0].scrollHeight > maxHeight + 1) {
          high = mid;
        } else {
          low = mid + 1;
        }
      }
      var cutoff = Math.max(high - 2, 0);

      // Never break inside a word: fall back to the last whole word boundary.
      var cutText = fullText.substring(0, cutoff);
      // Only fall back when the cut actually lands inside a word; if it already
      // sits on a word boundary, trimming again would drop a whole word.
      if (cutoff < fullText.length && !/\s/.test(fullText.charAt(cutoff)) && !/\s$/.test(cutText)) {
        var lastSpace = cutText.lastIndexOf(" ");
        if (lastSpace > 0) cutText = cutText.substring(0, lastSpace);
      }
      cutText = cutText.replace(/[\s.,;:!?\u2013\u2014-]+$/, "");
      $truncated.text(cutText + "...\xA0");

      // Final safety — keep trimming word-by-word if still overflows
      var finalText = cutText;
      while ($text[0].scrollHeight > maxHeight + 1 && finalText.length > 10) {
        finalText = finalText.substring(0, finalText.lastIndexOf(" ") || finalText.length - 1).trimEnd();
        $truncated.text(finalText + "...\xA0");
      }
    } else {
      // Text fits — no need for toggle
      $toggle.css("display", "none");
    }
  }
  truncateToLines();
  $(window).on("resize", truncateToLines);

  // Toggle expanded state
  $toggle.on("click", function () {
    var $toggleText = $(this).find(".toggle-text");
    var isExpanded = $container.hasClass("is-expanded");
    if (isExpanded) {
      // Collapse: show truncated, hide full
      $container.removeClass("is-expanded");
      $full.hide();
      $truncated.show();
      $toggleText.text($(this).data("more"));
    } else {
      // Expand: show full, hide truncated
      $container.addClass("is-expanded");
      $full.show();
      $truncated.hide();
      $toggleText.text($(this).data("less"));
    }
  });
})();

// Cart safe delivery popover — click to open the reassurance points, click outside or Esc to close
function closeSafeDeliveryPopovers($except) {
  $(".js-safe-delivery").each(function () {
    var $block = $(this);
    if ($except && $block.is($except)) return;
    $block.removeClass("is-open");
    $block.find(".js-safe-delivery-trigger").attr("aria-expanded", "false");
    $block.find(".js-safe-delivery-panel").attr("hidden", "hidden");
  });
}
$(document).on("click", ".js-safe-delivery-trigger", function (e) {
  e.preventDefault();
  e.stopPropagation();
  var $block = $(this).closest(".js-safe-delivery");
  var isOpen = $block.hasClass("is-open");
  closeSafeDeliveryPopovers($block);
  $block.toggleClass("is-open", !isOpen);
  $(this).attr("aria-expanded", isOpen ? "false" : "true");
  $block.find(".js-safe-delivery-panel").attr("hidden", isOpen ? "hidden" : null);
});
$(document).on("click", function (e) {
  if ($(e.target).closest(".js-safe-delivery").length) return;
  closeSafeDeliveryPopovers();
});
$(document).on("keyup", function (e) {
  if (e.key === "Escape") closeSafeDeliveryPopovers();
});

/***/ }),

/***/ "./src/js/trustpilot-scroll.js":
/*!*************************************!*\
  !*** ./src/js/trustpilot-scroll.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Trustpilot Widget Scroll Functionality
 * Makes the top Trustpilot widget clickable and scrolls to the carousel
 */
var TrustpilotScroll = /*#__PURE__*/function () {
  function TrustpilotScroll() {
    _classCallCheck(this, TrustpilotScroll);
    this.topWidget = null;
    this.carouselWidget = null;
    this.initialized = false;
    this.maxAttempts = 15;
    this.attemptCount = 0;
    this.init();
  }
  return _createClass(TrustpilotScroll, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          return _this.setup();
        });
      } else {
        this.setup();
      }
    }
  }, {
    key: "setup",
    value: function setup() {
      // Try to find widgets, retry if not found (Trustpilot loads async)
      this.findWidgets();
    }
  }, {
    key: "findWidgets",
    value: function findWidgets() {
      var _this2 = this;
      this.topWidget = document.querySelector('#tp-wrapper');
      this.carouselWidget = document.querySelector('#tp-wrapper-carousel');
      if (this.topWidget && this.carouselWidget) {
        this.attachHandlers();
      } else {
        // Retry finding widgets
        this.attemptCount++;
        if (this.attemptCount < this.maxAttempts) {
          setTimeout(function () {
            return _this2.findWidgets();
          }, 300);
        } else {
          console.warn('Trustpilot widgets not found after multiple attempts');
        }
      }
    }
  }, {
    key: "attachHandlers",
    value: function attachHandlers() {
      if (this.initialized) return;

      // Make the entire wrapper clickable with a visual overlay
      this.createClickableOverlay();
      this.initialized = true;
      console.log('Trustpilot scroll functionality initialized');
    }
  }, {
    key: "createClickableOverlay",
    value: function createClickableOverlay() {
      var _this3 = this;
      // Create a transparent clickable overlay on top of the widget
      // This works even when Trustpilot content is in an iframe
      var overlay = document.createElement('div');
      overlay.className = 'tp-scroll-overlay';
      overlay.style.cssText = "\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      cursor: pointer;\n      z-index: 10;\n      background: transparent;\n    ";

      // Make sure the wrapper has position relative
      if (window.getComputedStyle(this.topWidget).position === 'static') {
        this.topWidget.style.position = 'relative';
      }

      // Add the overlay
      this.topWidget.appendChild(overlay);

      // Add click handler to overlay
      overlay.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        _this3.scrollToCarousel();
      });

      // Also add hover effect
      overlay.addEventListener('mouseenter', function () {
        overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.02)';
      });
      overlay.addEventListener('mouseleave', function () {
        overlay.style.backgroundColor = 'transparent';
      });
      console.log('Clickable overlay created for Trustpilot widget');
    }
  }, {
    key: "scrollToCarousel",
    value: function scrollToCarousel() {
      if (!this.carouselWidget) return;

      // Get the position of the carousel
      var carouselRect = this.carouselWidget.getBoundingClientRect();
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Calculate target position with offset for fixed header
      var headerOffset = 100; // Adjust based on your header height
      var targetPosition = carouselRect.top + scrollTop - headerOffset;

      // Smooth scroll to target
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      // Add a highlight effect to the carousel
      this.highlightCarousel();
      console.log('Scrolling to Trustpilot carousel');
    }
  }, {
    key: "highlightCarousel",
    value: function highlightCarousel() {
      var _this4 = this;
      // Temporarily highlight the carousel to show where we scrolled to
      this.carouselWidget.style.transition = 'background-color 0.3s ease';
      var originalBg = window.getComputedStyle(this.carouselWidget).backgroundColor;
      this.carouselWidget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
      setTimeout(function () {
        _this4.carouselWidget.style.backgroundColor = originalBg;
        setTimeout(function () {
          _this4.carouselWidget.style.transition = '';
        }, 300);
      }, 1000);
    }
  }]);
}();
/**
 * Fetch Trustpilot review data and update product USP
 */
function fetchTrustpilotUSP() {
  var ratingEl = document.getElementById('tp-rating');
  var countEl = document.getElementById('tp-count');
  var ratingHeroEl = document.getElementById('tp-rating-hero');
  var countHeroEl = document.getElementById('tp-count-hero');
  if (!ratingEl && !countEl && !ratingHeroEl && !countHeroEl) return;
  var businessUnitId = '614ad6015c664c001d811095';
  var url = 'https://widget.trustpilot.com/trustbox-data/53aa8807dec7e10d38f59f32?businessUnitId=' + businessUnitId + '&locale=nl-NL';
  fetch(url).then(function (r) {
    return r.json();
  }).then(function (data) {
    if (data && data.businessEntity) {
      var score = data.businessEntity.trustScore;
      var count = data.businessEntity.numberOfReviews && data.businessEntity.numberOfReviews.total;
      if (score) {
        if (ratingEl) ratingEl.textContent = score + '/5';
        if (ratingHeroEl) ratingHeroEl.textContent = score + '/5';
      }
      if (count) {
        var formattedCount = count.toLocaleString('nl-NL');
        if (countEl) countEl.textContent = formattedCount;
        if (countHeroEl) countHeroEl.textContent = formattedCount;
      }
      var heroReview = document.querySelector('.product-hero__review');
      if (heroReview) heroReview.style.opacity = '1';
    }
  })["catch"](function () {
    var heroReview = document.querySelector('.product-hero__review');
    if (heroReview) heroReview.style.opacity = '1';
  });
}

// Initialize when script loads
var trustpilotScroll = new TrustpilotScroll();
fetchTrustpilotUSP();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TrustpilotScroll);

/***/ }),

/***/ "./src/scss/app.scss":
/*!***************************!*\
  !*** ./src/scss/app.scss ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, ["app","/vendor"], () => (__webpack_exec__("./src/js/app.js"), __webpack_exec__("./src/scss/app.scss")));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);